/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as BaseRouteRouteImport } from './routes/_base/route'
import { Route as BaseAuthRouteRouteImport } from './routes/_base/_auth/route'
import { Route as BasePublicRouteRouteImport } from './routes/_base/_public/route'
import { Route as BaseAuthBackofficeRouteRouteImport } from './routes/_base/_auth/backoffice/route'
import { Route as BaseAuthCampaignsRouteRouteImport } from './routes/_base/_auth/campaigns/route'
import { Route as BaseAuthCapabilitiesRouteRouteImport } from './routes/_base/_auth/capabilities/route'
import { Route as BaseAuthConversationsRouteRouteImport } from './routes/_base/_auth/conversations/route'
import { Route as BaseAuthCustomersRouteRouteImport } from './routes/_base/_auth/customers/route'
import { Route as BaseAuthInsightsRouteRouteImport } from './routes/_base/_auth/insights/route'
import { Route as BaseAuthKnowledgeRouteRouteImport } from './routes/_base/_auth/knowledge/route'
import { Route as BaseAuthSettingsRouteRouteImport } from './routes/_base/_auth/settings/route'
import { Route as BaseAuthSupportRouteRouteImport } from './routes/_base/_auth/support/route'
import { Route as BasePublicForgotPasswordRouteImport } from './routes/_base/_public/forgot-password'
import { Route as BasePublicInviteRouteImport } from './routes/_base/_public/invite'
import { Route as BasePublicLoginRouteImport } from './routes/_base/_public/login'
import { Route as BasePublicResetPasswordRouteImport } from './routes/_base/_public/reset-password'
import { Route as BasePublicSignupRouteImport } from './routes/_base/_public/signup'
import { Route as BasePublicSignupWebsiteRouteRouteImport } from './routes/_base/_public/signup-website/route'
import { Route as BaseAuthBackofficeIndexRouteImport } from './routes/_base/_auth/backoffice/index'
import { Route as BaseAuthBackofficeBiRouteRouteImport } from './routes/_base/_auth/backoffice/bi/route'
import { Route as BaseAuthBackofficeCampaignsRouteRouteImport } from './routes/_base/_auth/backoffice/campaigns/route'
import { Route as BaseAuthBackofficeCapabilityExecutionsRouteRouteImport } from './routes/_base/_auth/backoffice/capabilityExecutions/route'
import { Route as BaseAuthBackofficeClustersRouteRouteImport } from './routes/_base/_auth/backoffice/clusters/route'
import { Route as BaseAuthBackofficeConversationExperimentsRouteRouteImport } from './routes/_base/_auth/backoffice/conversationExperiments/route'
import { Route as BaseAuthBackofficeConversationSalesReportsRouteRouteImport } from './routes/_base/_auth/backoffice/conversationSalesReports/route'
import { Route as BaseAuthBackofficeEmailVerifierRouteRouteImport } from './routes/_base/_auth/backoffice/emailVerifier/route'
import { Route as BaseAuthBackofficeFlagsRouteRouteImport } from './routes/_base/_auth/backoffice/flags/route'
import { Route as BaseAuthBackofficeGmailReaderRouteRouteImport } from './routes/_base/_auth/backoffice/gmailReader/route'
import { Route as BaseAuthBackofficeJobSearchRouteRouteImport } from './routes/_base/_auth/backoffice/jobSearch/route'
import { Route as BaseAuthBackofficeKnowledgeRouteRouteImport } from './routes/_base/_auth/backoffice/knowledge/route'
import { Route as BaseAuthBackofficeOrganizationsRouteRouteImport } from './routes/_base/_auth/backoffice/organizations/route'
import { Route as BaseAuthBackofficeOutlookReaderRouteRouteImport } from './routes/_base/_auth/backoffice/outlookReader/route'
import { Route as BaseAuthBackofficeReferralsRouteRouteImport } from './routes/_base/_auth/backoffice/referrals/route'
import { Route as BaseAuthBackofficeScheduledReportsRouteRouteImport } from './routes/_base/_auth/backoffice/scheduledReports/route'
import { Route as BaseAuthBackofficeSupportRouteRouteImport } from './routes/_base/_auth/backoffice/support/route'
import { Route as BaseAuthBackofficeWhatsappRoutesRouteRouteImport } from './routes/_base/_auth/backoffice/whatsappRoutes/route'
import { Route as BaseAuthCampaignsIndexRouteImport } from './routes/_base/_auth/campaigns/index'
import { Route as BaseAuthCampaignsIdRouteRouteImport } from './routes/_base/_auth/campaigns/$id/route'
import { Route as BaseAuthCampaignsGoalsRouteRouteImport } from './routes/_base/_auth/campaigns/goals/route'
import { Route as BaseAuthCampaignsListRouteRouteImport } from './routes/_base/_auth/campaigns/list/route'
import { Route as BaseAuthCapabilitiesIndexRouteImport } from './routes/_base/_auth/capabilities/index'
import { Route as BaseAuthCapabilitiesListRouteRouteImport } from './routes/_base/_auth/capabilities/list/route'
import { Route as BaseAuthConversationsIndexRouteImport } from './routes/_base/_auth/conversations/index'
import { Route as BaseAuthConversationsListRouteRouteImport } from './routes/_base/_auth/conversations/list/route'
import { Route as BaseAuthCustomersIndexRouteImport } from './routes/_base/_auth/customers/index'
import { Route as BaseAuthCustomersListRouteRouteImport } from './routes/_base/_auth/customers/list/route'
import { Route as BaseAuthCustomersSegmentsRouteRouteImport } from './routes/_base/_auth/customers/segments/route'
import { Route as BaseAuthInsightsIndexRouteImport } from './routes/_base/_auth/insights/index'
import { Route as BaseAuthKnowledgeIndexRouteImport } from './routes/_base/_auth/knowledge/index'
import { Route as BaseAuthKnowledgeCustomizationRouteImport } from './routes/_base/_auth/knowledge/customization'
import { Route as BaseAuthKnowledgeKnowledgeBaseRouteImport } from './routes/_base/_auth/knowledge/knowledge-base'
import { Route as BaseAuthKnowledgeSuggestionsRouteImport } from './routes/_base/_auth/knowledge/suggestions'
import { Route as BaseAuthSettingsIndexRouteImport } from './routes/_base/_auth/settings/index'
import { Route as BaseAuthSettingsChannelsRouteRouteImport } from './routes/_base/_auth/settings/channels/route'
import { Route as BaseAuthSettingsCustomizationRouteRouteImport } from './routes/_base/_auth/settings/customization/route'
import { Route as BaseAuthSettingsIntegrationsRouteRouteImport } from './routes/_base/_auth/settings/integrations/route'
import { Route as BaseAuthSettingsKeysAndSecretsRouteRouteImport } from './routes/_base/_auth/settings/keys-and-secrets/route'
import { Route as BaseAuthSettingsReferralsRouteRouteImport } from './routes/_base/_auth/settings/referrals/route'
import { Route as BaseAuthSettingsSubscriptionRouteRouteImport } from './routes/_base/_auth/settings/subscription/route'
import { Route as BaseAuthSettingsTeamRouteRouteImport } from './routes/_base/_auth/settings/team/route'
import { Route as BaseAuthSettingsWorkflowsRouteRouteImport } from './routes/_base/_auth/settings/workflows/route'
import { Route as BaseAuthSupportIndexRouteImport } from './routes/_base/_auth/support/index'
import { Route as BaseAuthSupportListRouteRouteImport } from './routes/_base/_auth/support/list/route'
import { Route as BasePublicSignupWebsiteIndexRouteImport } from './routes/_base/_public/signup-website/index'
import { Route as BasePublicSignupWebsitePreviewRouteImport } from './routes/_base/_public/signup-website/preview'
import { Route as BaseAuthBackofficeCampaignsHealthRouteRouteImport } from './routes/_base/_auth/backoffice/campaigns/health/route'
import { Route as BaseAuthBackofficeClustersIndexRouteImport } from './routes/_base/_auth/backoffice/clusters/index'
import { Route as BaseAuthBackofficeCompaniesCreateRouteImport } from './routes/_base/_auth/backoffice/companies/create'
import { Route as BaseAuthBackofficeConversationExperimentsListRouteRouteImport } from './routes/_base/_auth/backoffice/conversationExperiments/list/route'
import { Route as BaseAuthBackofficeFlagsIndexRouteImport } from './routes/_base/_auth/backoffice/flags/index'
import { Route as BaseAuthBackofficeOrganizationsIndexRouteImport } from './routes/_base/_auth/backoffice/organizations/index'
import { Route as BaseAuthBackofficeOrganizationsIdRouteRouteImport } from './routes/_base/_auth/backoffice/organizations/$id/route'
import { Route as BaseAuthBackofficeOrganizationsListRouteImport } from './routes/_base/_auth/backoffice/organizations/list'
import { Route as BaseAuthBackofficeReferralsIndexRouteImport } from './routes/_base/_auth/backoffice/referrals/index'
import { Route as BaseAuthBackofficeReferralsListRouteImport } from './routes/_base/_auth/backoffice/referrals/list'
import { Route as BaseAuthBackofficeScheduledReportsIndexRouteImport } from './routes/_base/_auth/backoffice/scheduledReports/index'
import { Route as BaseAuthBackofficeScheduledReportsIdRouteImport } from './routes/_base/_auth/backoffice/scheduledReports/$id'
import { Route as BaseAuthBackofficeScheduledReportsCreateRouteImport } from './routes/_base/_auth/backoffice/scheduledReports/create'
import { Route as BaseAuthBackofficeScheduledReportsListRouteRouteImport } from './routes/_base/_auth/backoffice/scheduledReports/list/route'
import { Route as BaseAuthBackofficeSupportListRouteRouteImport } from './routes/_base/_auth/backoffice/support/list/route'
import { Route as BaseAuthCampaignsIdIndexRouteImport } from './routes/_base/_auth/campaigns/$id/index'
import { Route as BaseAuthCampaignsIdActivityRouteRouteImport } from './routes/_base/_auth/campaigns/$id/activity/route'
import { Route as BaseAuthCampaignsIdCapabilitiesRouteRouteImport } from './routes/_base/_auth/campaigns/$id/capabilities/route'
import { Route as BaseAuthCampaignsIdConfigurationRouteRouteImport } from './routes/_base/_auth/campaigns/$id/configuration/route'
import { Route as BaseAuthCampaignsIdInsightsRouteRouteImport } from './routes/_base/_auth/campaigns/$id/insights/route'
import { Route as BaseAuthCampaignsIdKnowledgeBaseRouteRouteImport } from './routes/_base/_auth/campaigns/$id/knowledge-base/route'
import { Route as BaseAuthCampaignsIdWorkflowsRouteRouteImport } from './routes/_base/_auth/campaigns/$id/workflows/route'
import { Route as BaseAuthCampaignsGoalsIndexRouteImport } from './routes/_base/_auth/campaigns/goals/index'
import { Route as BaseAuthCampaignsGoalsListRouteRouteImport } from './routes/_base/_auth/campaigns/goals/list/route'
import { Route as BaseAuthCapabilitiesListCreateCustomRouteImport } from './routes/_base/_auth/capabilities/list/create-custom'
import { Route as BaseAuthConversationsListCustomerIdRouteRouteImport } from './routes/_base/_auth/conversations/list/$customerId/route'
import { Route as BaseAuthCustomersListIdRouteImport } from './routes/_base/_auth/customers/list/$id'
import { Route as BaseAuthCustomersListCreateRouteImport } from './routes/_base/_auth/customers/list/create'
import { Route as BaseAuthCustomersListImportRouteImport } from './routes/_base/_auth/customers/list/import'
import { Route as BaseAuthCustomersSegmentsIndexRouteImport } from './routes/_base/_auth/customers/segments/index'
import { Route as BaseAuthCustomersSegmentsIdRouteRouteImport } from './routes/_base/_auth/customers/segments/$id/route'
import { Route as BaseAuthCustomersSegmentsListRouteRouteImport } from './routes/_base/_auth/customers/segments/list/route'
import { Route as BaseAuthSettingsChannelsIndexRouteImport } from './routes/_base/_auth/settings/channels/index'
import { Route as BaseAuthSettingsChannelsGmailRouteRouteImport } from './routes/_base/_auth/settings/channels/gmail/route'
import { Route as BaseAuthSettingsChannelsInstagramRouteRouteImport } from './routes/_base/_auth/settings/channels/instagram/route'
import { Route as BaseAuthSettingsChannelsOutlookRouteRouteImport } from './routes/_base/_auth/settings/channels/outlook/route'
import { Route as BaseAuthSettingsChannelsQrRouteRouteImport } from './routes/_base/_auth/settings/channels/qr/route'
import { Route as BaseAuthSettingsChannelsWhatsappRouteRouteImport } from './routes/_base/_auth/settings/channels/whatsapp/route'
import { Route as BaseAuthSettingsChannelsWidgetRouteRouteImport } from './routes/_base/_auth/settings/channels/widget/route'
import { Route as BaseAuthSettingsIntegrationsIndexRouteImport } from './routes/_base/_auth/settings/integrations/index'
import { Route as BaseAuthSettingsIntegrationsAmphoraRouteRouteImport } from './routes/_base/_auth/settings/integrations/amphora/route'
import { Route as BaseAuthSettingsIntegrationsBigblueRouteRouteImport } from './routes/_base/_auth/settings/integrations/bigblue/route'
import { Route as BaseAuthSettingsIntegrationsFrontappRouteRouteImport } from './routes/_base/_auth/settings/integrations/frontapp/route'
import { Route as BaseAuthSettingsIntegrationsGorgiasRouteRouteImport } from './routes/_base/_auth/settings/integrations/gorgias/route'
import { Route as BaseAuthSettingsIntegrationsKlaviyoRouteRouteImport } from './routes/_base/_auth/settings/integrations/klaviyo/route'
import { Route as BaseAuthSettingsIntegrationsLoopReturnsRouteRouteImport } from './routes/_base/_auth/settings/integrations/loopReturns/route'
import { Route as BaseAuthSettingsIntegrationsReveniRouteRouteImport } from './routes/_base/_auth/settings/integrations/reveni/route'
import { Route as BaseAuthSettingsIntegrationsReverRouteRouteImport } from './routes/_base/_auth/settings/integrations/rever/route'
import { Route as BaseAuthSettingsIntegrationsSalesForceRouteRouteImport } from './routes/_base/_auth/settings/integrations/salesForce/route'
import { Route as BaseAuthSettingsIntegrationsShopifyRouteRouteImport } from './routes/_base/_auth/settings/integrations/shopify/route'
import { Route as BaseAuthSettingsIntegrationsZendeskRouteRouteImport } from './routes/_base/_auth/settings/integrations/zendesk/route'
import { Route as BaseAuthSettingsSubscriptionIndexRouteImport } from './routes/_base/_auth/settings/subscription/index'
import { Route as BaseAuthSettingsSubscriptionPlansRouteRouteImport } from './routes/_base/_auth/settings/subscription/plans/route'
import { Route as BaseAuthSettingsSubscriptionReferralsRouteRouteImport } from './routes/_base/_auth/settings/subscription/referrals/route'
import { Route as BaseAuthSettingsSubscriptionUsageRouteRouteImport } from './routes/_base/_auth/settings/subscription/usage/route'
import { Route as BaseAuthSettingsTeamIndexRouteImport } from './routes/_base/_auth/settings/team/index'
import { Route as BaseAuthSettingsTeamInviteRouteImport } from './routes/_base/_auth/settings/team/invite'
import { Route as BaseAuthSettingsWorkflowsIndexRouteImport } from './routes/_base/_auth/settings/workflows/index'
import { Route as BaseAuthSupportListCustomerIdRouteRouteImport } from './routes/_base/_auth/support/list/$customerId/route'
import { Route as BaseAuthBackofficeConversationExperimentsListPromptExperimentRouteImport } from './routes/_base/_auth/backoffice/conversationExperiments/list/prompt-experiment'
import { Route as BaseAuthBackofficeKnowledgeTopicsTopicIdRouteImport } from './routes/_base/_auth/backoffice/knowledge/topics.$topicId'
import { Route as BaseAuthBackofficeOrganizationsIdIndexRouteImport } from './routes/_base/_auth/backoffice/organizations/$id/index'
import { Route as BaseAuthBackofficeOrganizationsIdCompaniesRouteRouteImport } from './routes/_base/_auth/backoffice/organizations/$id/companies/route'
import { Route as BaseAuthBackofficeOrganizationsIdCreditsRouteRouteImport } from './routes/_base/_auth/backoffice/organizations/$id/credits/route'
import { Route as BaseAuthBackofficeOrganizationsListCreateRouteImport } from './routes/_base/_auth/backoffice/organizations/list/create'
import { Route as BaseAuthBackofficeOrganizationsListCreateFromWebsiteRouteImport } from './routes/_base/_auth/backoffice/organizations/list/create-from-website'
import { Route as BaseAuthCampaignsIdActivityCustomerIdRouteImport } from './routes/_base/_auth/campaigns/$id/activity/$customerId'
import { Route as BaseAuthCampaignsIdInsightsLaunchRouteImport } from './routes/_base/_auth/campaigns/$id/insights/launch'
import { Route as BaseAuthCampaignsGoalsListCreateRouteImport } from './routes/_base/_auth/campaigns/goals/list/create'
import { Route as BaseAuthKnowledgeSuggestionsGapIdDismissRouteImport } from './routes/_base/_auth/knowledge/suggestions/$gapId/dismiss'
import { Route as BaseAuthKnowledgeSuggestionsGapIdEvidenceRouteImport } from './routes/_base/_auth/knowledge/suggestions/$gapId/evidence'
import { Route as BaseAuthSettingsChannelsGmailNewRouteImport } from './routes/_base/_auth/settings/channels/gmail/new'
import { Route as BaseAuthSettingsChannelsInstagramNewRouteImport } from './routes/_base/_auth/settings/channels/instagram/new'
import { Route as BaseAuthSettingsChannelsOutlookNewRouteImport } from './routes/_base/_auth/settings/channels/outlook/new'
import { Route as BaseAuthSettingsChannelsQrIdRouteImport } from './routes/_base/_auth/settings/channels/qr/$id'
import { Route as BaseAuthSettingsChannelsQrCreateRouteImport } from './routes/_base/_auth/settings/channels/qr/create'
import { Route as BaseAuthSettingsChannelsWhatsappIndexRouteImport } from './routes/_base/_auth/settings/channels/whatsapp/index'
import { Route as BaseAuthSettingsChannelsWhatsappAlertsRouteImport } from './routes/_base/_auth/settings/channels/whatsapp/alerts'
import { Route as BaseAuthSettingsChannelsWhatsappOpeningsRouteRouteImport } from './routes/_base/_auth/settings/channels/whatsapp/openings/route'
import { Route as BaseAuthSettingsChannelsWhatsappTemplatesRouteRouteImport } from './routes/_base/_auth/settings/channels/whatsapp/templates/route'
import { Route as BaseAuthSettingsChannelsWidgetIndexRouteImport } from './routes/_base/_auth/settings/channels/widget/index'
import { Route as BaseAuthSettingsChannelsWidgetPhoneMockupRouteImport } from './routes/_base/_auth/settings/channels/widget/phone-mockup'
import { Route as BaseAuthSettingsIntegrationsAmphoraConnectRouteImport } from './routes/_base/_auth/settings/integrations/amphora/connect'
import { Route as BaseAuthSettingsIntegrationsBigblueConnectRouteImport } from './routes/_base/_auth/settings/integrations/bigblue/connect'
import { Route as BaseAuthSettingsIntegrationsFrontappConnectRouteImport } from './routes/_base/_auth/settings/integrations/frontapp/connect'
import { Route as BaseAuthSettingsIntegrationsGorgiasConnectRouteImport } from './routes/_base/_auth/settings/integrations/gorgias/connect'
import { Route as BaseAuthSettingsIntegrationsKlaviyoConnectRouteImport } from './routes/_base/_auth/settings/integrations/klaviyo/connect'
import { Route as BaseAuthSettingsIntegrationsLoopReturnsConnectRouteImport } from './routes/_base/_auth/settings/integrations/loopReturns/connect'
import { Route as BaseAuthSettingsIntegrationsReveniConnectRouteImport } from './routes/_base/_auth/settings/integrations/reveni/connect'
import { Route as BaseAuthSettingsIntegrationsReverConnectRouteImport } from './routes/_base/_auth/settings/integrations/rever/connect'
import { Route as BaseAuthSettingsIntegrationsSalesForceConnectRouteImport } from './routes/_base/_auth/settings/integrations/salesForce/connect'
import { Route as BaseAuthSettingsIntegrationsShopifySizeChartRouteImport } from './routes/_base/_auth/settings/integrations/shopify.SizeChart'
import { Route as BaseAuthSettingsIntegrationsShopifyConnectRouteImport } from './routes/_base/_auth/settings/integrations/shopify/connect'
import { Route as BaseAuthSettingsIntegrationsZendeskConnectRouteImport } from './routes/_base/_auth/settings/integrations/zendesk/connect'
import { Route as BaseAuthSettingsKeysAndSecretsApiTokensCreateRouteImport } from './routes/_base/_auth/settings/keys-and-secrets/api-tokens.create'
import { Route as BaseAuthSettingsKeysAndSecretsVaultCreateRouteImport } from './routes/_base/_auth/settings/keys-and-secrets/vault.create'
import { Route as BaseAuthSettingsSubscriptionUsageConfigureTopupsRouteImport } from './routes/_base/_auth/settings/subscription/usage/configure-topups'
import { Route as BaseAuthSettingsTeamEmployeeIdAccessRouteImport } from './routes/_base/_auth/settings/team/$employeeId/access'
import { Route as BaseAuthBackofficeOrganizationsIdCompaniesCompanyIdRouteRouteImport } from './routes/_base/_auth/backoffice/organizations/$id/companies/$companyId/route'
import { Route as BaseAuthBackofficeOrganizationsIdCreditsListRouteImport } from './routes/_base/_auth/backoffice/organizations/$id/credits/list'
import { Route as BaseAuthCampaignsGoalsListEditIdRouteImport } from './routes/_base/_auth/campaigns/goals/list/edit.$id'
import { Route as BaseAuthSettingsChannelsGmailDeleteIntegrationIdRouteImport } from './routes/_base/_auth/settings/channels/gmail/deleteIntegration.$id'
import { Route as BaseAuthSettingsChannelsOutlookDeleteIntegrationIdRouteImport } from './routes/_base/_auth/settings/channels/outlook/deleteIntegration.$id'
import { Route as BaseAuthSettingsChannelsWhatsappOpeningsIndexRouteImport } from './routes/_base/_auth/settings/channels/whatsapp/openings/index'
import { Route as BaseAuthSettingsChannelsWhatsappOpeningsIdRouteImport } from './routes/_base/_auth/settings/channels/whatsapp/openings/$id'
import { Route as BaseAuthSettingsChannelsWhatsappOpeningsCreateRouteImport } from './routes/_base/_auth/settings/channels/whatsapp/openings/create'
import { Route as BaseAuthSettingsChannelsWhatsappTemplatesIndexRouteImport } from './routes/_base/_auth/settings/channels/whatsapp/templates/index'
import { Route as BaseAuthSettingsChannelsWhatsappTemplatesIdRouteImport } from './routes/_base/_auth/settings/channels/whatsapp/templates/$id'
import { Route as BaseAuthSettingsChannelsWhatsappTemplatesCreateRouteImport } from './routes/_base/_auth/settings/channels/whatsapp/templates/create'
import { Route as BaseAuthSettingsKeysAndSecretsVaultKeyReplaceRouteImport } from './routes/_base/_auth/settings/keys-and-secrets/vault.$key.replace'
import { Route as BaseAuthBackofficeOrganizationsIdCompaniesCompanyIdIndexRouteImport } from './routes/_base/_auth/backoffice/organizations/$id/companies/$companyId/index'
import { Route as BaseAuthBackofficeOrganizationsIdCompaniesCompanyIdCanonicalTopicsRouteRouteImport } from './routes/_base/_auth/backoffice/organizations/$id/companies/$companyId/canonical-topics/route'
import { Route as BaseAuthBackofficeOrganizationsIdCompaniesCompanyIdCustomersRouteRouteImport } from './routes/_base/_auth/backoffice/organizations/$id/companies/$companyId/customers/route'
import { Route as BaseAuthBackofficeOrganizationsIdCompaniesCompanyIdCanonicalTopicsListRouteImport } from './routes/_base/_auth/backoffice/organizations/$id/companies/$companyId/canonical-topics/list'
import { Route as BaseAuthBackofficeOrganizationsIdCompaniesCompanyIdCustomersListRouteImport } from './routes/_base/_auth/backoffice/organizations/$id/companies/$companyId/customers/list'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const BaseRouteRoute = BaseRouteRouteImport.update({
  id: '/_base',
  getParentRoute: () => rootRouteImport,
} as any)
const BaseAuthRouteRoute = BaseAuthRouteRouteImport.update({
  id: '/_auth',
  getParentRoute: () => BaseRouteRoute,
} as any)
const BasePublicRouteRoute = BasePublicRouteRouteImport.update({
  id: '/_public',
  getParentRoute: () => BaseRouteRoute,
} as any)
const BaseAuthBackofficeRouteRoute = BaseAuthBackofficeRouteRouteImport.update({
  id: '/backoffice',
  path: '/backoffice',
  getParentRoute: () => BaseAuthRouteRoute,
} as any)
const BaseAuthCampaignsRouteRoute = BaseAuthCampaignsRouteRouteImport.update({
  id: '/campaigns',
  path: '/campaigns',
  getParentRoute: () => BaseAuthRouteRoute,
} as any)
const BaseAuthCapabilitiesRouteRoute =
  BaseAuthCapabilitiesRouteRouteImport.update({
    id: '/capabilities',
    path: '/capabilities',
    getParentRoute: () => BaseAuthRouteRoute,
  } as any)
const BaseAuthConversationsRouteRoute =
  BaseAuthConversationsRouteRouteImport.update({
    id: '/conversations',
    path: '/conversations',
    getParentRoute: () => BaseAuthRouteRoute,
  } as any)
const BaseAuthCustomersRouteRoute = BaseAuthCustomersRouteRouteImport.update({
  id: '/customers',
  path: '/customers',
  getParentRoute: () => BaseAuthRouteRoute,
} as any)
const BaseAuthInsightsRouteRoute = BaseAuthInsightsRouteRouteImport.update({
  id: '/insights',
  path: '/insights',
  getParentRoute: () => BaseAuthRouteRoute,
} as any)
const BaseAuthKnowledgeRouteRoute = BaseAuthKnowledgeRouteRouteImport.update({
  id: '/knowledge',
  path: '/knowledge',
  getParentRoute: () => BaseAuthRouteRoute,
} as any)
const BaseAuthSettingsRouteRoute = BaseAuthSettingsRouteRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => BaseAuthRouteRoute,
} as any)
const BaseAuthSupportRouteRoute = BaseAuthSupportRouteRouteImport.update({
  id: '/support',
  path: '/support',
  getParentRoute: () => BaseAuthRouteRoute,
} as any)
const BasePublicForgotPasswordRoute =
  BasePublicForgotPasswordRouteImport.update({
    id: '/forgot-password',
    path: '/forgot-password',
    getParentRoute: () => BasePublicRouteRoute,
  } as any)
const BasePublicInviteRoute = BasePublicInviteRouteImport.update({
  id: '/invite',
  path: '/invite',
  getParentRoute: () => BasePublicRouteRoute,
} as any)
const BasePublicLoginRoute = BasePublicLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => BasePublicRouteRoute,
} as any)
const BasePublicResetPasswordRoute = BasePublicResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => BasePublicRouteRoute,
} as any)
const BasePublicSignupRoute = BasePublicSignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => BasePublicRouteRoute,
} as any)
const BasePublicSignupWebsiteRouteRoute =
  BasePublicSignupWebsiteRouteRouteImport.update({
    id: '/signup-website',
    path: '/signup-website',
    getParentRoute: () => BasePublicRouteRoute,
  } as any)
const BaseAuthBackofficeIndexRoute = BaseAuthBackofficeIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => BaseAuthBackofficeRouteRoute,
} as any)
const BaseAuthBackofficeBiRouteRoute =
  BaseAuthBackofficeBiRouteRouteImport.update({
    id: '/bi',
    path: '/bi',
    getParentRoute: () => BaseAuthBackofficeRouteRoute,
  } as any)
const BaseAuthBackofficeCampaignsRouteRoute =
  BaseAuthBackofficeCampaignsRouteRouteImport.update({
    id: '/campaigns',
    path: '/campaigns',
    getParentRoute: () => BaseAuthBackofficeRouteRoute,
  } as any)
const BaseAuthBackofficeCapabilityExecutionsRouteRoute =
  BaseAuthBackofficeCapabilityExecutionsRouteRouteImport.update({
    id: '/capabilityExecutions',
    path: '/capabilityExecutions',
    getParentRoute: () => BaseAuthBackofficeRouteRoute,
  } as any)
const BaseAuthBackofficeClustersRouteRoute =
  BaseAuthBackofficeClustersRouteRouteImport.update({
    id: '/clusters',
    path: '/clusters',
    getParentRoute: () => BaseAuthBackofficeRouteRoute,
  } as any)
const BaseAuthBackofficeConversationExperimentsRouteRoute =
  BaseAuthBackofficeConversationExperimentsRouteRouteImport.update({
    id: '/conversationExperiments',
    path: '/conversationExperiments',
    getParentRoute: () => BaseAuthBackofficeRouteRoute,
  } as any)
const BaseAuthBackofficeConversationSalesReportsRouteRoute =
  BaseAuthBackofficeConversationSalesReportsRouteRouteImport.update({
    id: '/conversationSalesReports',
    path: '/conversationSalesReports',
    getParentRoute: () => BaseAuthBackofficeRouteRoute,
  } as any)
const BaseAuthBackofficeEmailVerifierRouteRoute =
  BaseAuthBackofficeEmailVerifierRouteRouteImport.update({
    id: '/emailVerifier',
    path: '/emailVerifier',
    getParentRoute: () => BaseAuthBackofficeRouteRoute,
  } as any)
const BaseAuthBackofficeFlagsRouteRoute =
  BaseAuthBackofficeFlagsRouteRouteImport.update({
    id: '/flags',
    path: '/flags',
    getParentRoute: () => BaseAuthBackofficeRouteRoute,
  } as any)
const BaseAuthBackofficeGmailReaderRouteRoute =
  BaseAuthBackofficeGmailReaderRouteRouteImport.update({
    id: '/gmailReader',
    path: '/gmailReader',
    getParentRoute: () => BaseAuthBackofficeRouteRoute,
  } as any)
const BaseAuthBackofficeJobSearchRouteRoute =
  BaseAuthBackofficeJobSearchRouteRouteImport.update({
    id: '/jobSearch',
    path: '/jobSearch',
    getParentRoute: () => BaseAuthBackofficeRouteRoute,
  } as any)
const BaseAuthBackofficeKnowledgeRouteRoute =
  BaseAuthBackofficeKnowledgeRouteRouteImport.update({
    id: '/knowledge',
    path: '/knowledge',
    getParentRoute: () => BaseAuthBackofficeRouteRoute,
  } as any)
const BaseAuthBackofficeOrganizationsRouteRoute =
  BaseAuthBackofficeOrganizationsRouteRouteImport.update({
    id: '/organizations',
    path: '/organizations',
    getParentRoute: () => BaseAuthBackofficeRouteRoute,
  } as any)
const BaseAuthBackofficeOutlookReaderRouteRoute =
  BaseAuthBackofficeOutlookReaderRouteRouteImport.update({
    id: '/outlookReader',
    path: '/outlookReader',
    getParentRoute: () => BaseAuthBackofficeRouteRoute,
  } as any)
const BaseAuthBackofficeReferralsRouteRoute =
  BaseAuthBackofficeReferralsRouteRouteImport.update({
    id: '/referrals',
    path: '/referrals',
    getParentRoute: () => BaseAuthBackofficeRouteRoute,
  } as any)
const BaseAuthBackofficeScheduledReportsRouteRoute =
  BaseAuthBackofficeScheduledReportsRouteRouteImport.update({
    id: '/scheduledReports',
    path: '/scheduledReports',
    getParentRoute: () => BaseAuthBackofficeRouteRoute,
  } as any)
const BaseAuthBackofficeSupportRouteRoute =
  BaseAuthBackofficeSupportRouteRouteImport.update({
    id: '/support',
    path: '/support',
    getParentRoute: () => BaseAuthBackofficeRouteRoute,
  } as any)
const BaseAuthBackofficeWhatsappRoutesRouteRoute =
  BaseAuthBackofficeWhatsappRoutesRouteRouteImport.update({
    id: '/whatsappRoutes',
    path: '/whatsappRoutes',
    getParentRoute: () => BaseAuthBackofficeRouteRoute,
  } as any)
const BaseAuthCampaignsIndexRoute = BaseAuthCampaignsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => BaseAuthCampaignsRouteRoute,
} as any)
const BaseAuthCampaignsIdRouteRoute =
  BaseAuthCampaignsIdRouteRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => BaseAuthCampaignsRouteRoute,
  } as any)
const BaseAuthCampaignsGoalsRouteRoute =
  BaseAuthCampaignsGoalsRouteRouteImport.update({
    id: '/goals',
    path: '/goals',
    getParentRoute: () => BaseAuthCampaignsRouteRoute,
  } as any)
const BaseAuthCampaignsListRouteRoute =
  BaseAuthCampaignsListRouteRouteImport.update({
    id: '/list',
    path: '/list',
    getParentRoute: () => BaseAuthCampaignsRouteRoute,
  } as any)
const BaseAuthCapabilitiesIndexRoute =
  BaseAuthCapabilitiesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => BaseAuthCapabilitiesRouteRoute,
  } as any)
const BaseAuthCapabilitiesListRouteRoute =
  BaseAuthCapabilitiesListRouteRouteImport.update({
    id: '/list',
    path: '/list',
    getParentRoute: () => BaseAuthCapabilitiesRouteRoute,
  } as any)
const BaseAuthConversationsIndexRoute =
  BaseAuthConversationsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => BaseAuthConversationsRouteRoute,
  } as any)
const BaseAuthConversationsListRouteRoute =
  BaseAuthConversationsListRouteRouteImport.update({
    id: '/list',
    path: '/list',
    getParentRoute: () => BaseAuthConversationsRouteRoute,
  } as any)
const BaseAuthCustomersIndexRoute = BaseAuthCustomersIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => BaseAuthCustomersRouteRoute,
} as any)
const BaseAuthCustomersListRouteRoute =
  BaseAuthCustomersListRouteRouteImport.update({
    id: '/list',
    path: '/list',
    getParentRoute: () => BaseAuthCustomersRouteRoute,
  } as any)
const BaseAuthCustomersSegmentsRouteRoute =
  BaseAuthCustomersSegmentsRouteRouteImport.update({
    id: '/segments',
    path: '/segments',
    getParentRoute: () => BaseAuthCustomersRouteRoute,
  } as any)
const BaseAuthInsightsIndexRoute = BaseAuthInsightsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => BaseAuthInsightsRouteRoute,
} as any)
const BaseAuthKnowledgeIndexRoute = BaseAuthKnowledgeIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => BaseAuthKnowledgeRouteRoute,
} as any)
const BaseAuthKnowledgeCustomizationRoute =
  BaseAuthKnowledgeCustomizationRouteImport.update({
    id: '/customization',
    path: '/customization',
    getParentRoute: () => BaseAuthKnowledgeRouteRoute,
  } as any)
const BaseAuthKnowledgeKnowledgeBaseRoute =
  BaseAuthKnowledgeKnowledgeBaseRouteImport.update({
    id: '/knowledge-base',
    path: '/knowledge-base',
    getParentRoute: () => BaseAuthKnowledgeRouteRoute,
  } as any)
const BaseAuthKnowledgeSuggestionsRoute =
  BaseAuthKnowledgeSuggestionsRouteImport.update({
    id: '/suggestions',
    path: '/suggestions',
    getParentRoute: () => BaseAuthKnowledgeRouteRoute,
  } as any)
const BaseAuthSettingsIndexRoute = BaseAuthSettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => BaseAuthSettingsRouteRoute,
} as any)
const BaseAuthSettingsChannelsRouteRoute =
  BaseAuthSettingsChannelsRouteRouteImport.update({
    id: '/channels',
    path: '/channels',
    getParentRoute: () => BaseAuthSettingsRouteRoute,
  } as any)
const BaseAuthSettingsCustomizationRouteRoute =
  BaseAuthSettingsCustomizationRouteRouteImport.update({
    id: '/customization',
    path: '/customization',
    getParentRoute: () => BaseAuthSettingsRouteRoute,
  } as any)
const BaseAuthSettingsIntegrationsRouteRoute =
  BaseAuthSettingsIntegrationsRouteRouteImport.update({
    id: '/integrations',
    path: '/integrations',
    getParentRoute: () => BaseAuthSettingsRouteRoute,
  } as any)
const BaseAuthSettingsKeysAndSecretsRouteRoute =
  BaseAuthSettingsKeysAndSecretsRouteRouteImport.update({
    id: '/keys-and-secrets',
    path: '/keys-and-secrets',
    getParentRoute: () => BaseAuthSettingsRouteRoute,
  } as any)
const BaseAuthSettingsReferralsRouteRoute =
  BaseAuthSettingsReferralsRouteRouteImport.update({
    id: '/referrals',
    path: '/referrals',
    getParentRoute: () => BaseAuthSettingsRouteRoute,
  } as any)
const BaseAuthSettingsSubscriptionRouteRoute =
  BaseAuthSettingsSubscriptionRouteRouteImport.update({
    id: '/subscription',
    path: '/subscription',
    getParentRoute: () => BaseAuthSettingsRouteRoute,
  } as any)
const BaseAuthSettingsTeamRouteRoute =
  BaseAuthSettingsTeamRouteRouteImport.update({
    id: '/team',
    path: '/team',
    getParentRoute: () => BaseAuthSettingsRouteRoute,
  } as any)
const BaseAuthSettingsWorkflowsRouteRoute =
  BaseAuthSettingsWorkflowsRouteRouteImport.update({
    id: '/workflows',
    path: '/workflows',
    getParentRoute: () => BaseAuthSettingsRouteRoute,
  } as any)
const BaseAuthSupportIndexRoute = BaseAuthSupportIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => BaseAuthSupportRouteRoute,
} as any)
const BaseAuthSupportListRouteRoute =
  BaseAuthSupportListRouteRouteImport.update({
    id: '/list',
    path: '/list',
    getParentRoute: () => BaseAuthSupportRouteRoute,
  } as any)
const BasePublicSignupWebsiteIndexRoute =
  BasePublicSignupWebsiteIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => BasePublicSignupWebsiteRouteRoute,
  } as any)
const BasePublicSignupWebsitePreviewRoute =
  BasePublicSignupWebsitePreviewRouteImport.update({
    id: '/preview',
    path: '/preview',
    getParentRoute: () => BasePublicSignupWebsiteRouteRoute,
  } as any)
const BaseAuthBackofficeCampaignsHealthRouteRoute =
  BaseAuthBackofficeCampaignsHealthRouteRouteImport.update({
    id: '/health',
    path: '/health',
    getParentRoute: () => BaseAuthBackofficeCampaignsRouteRoute,
  } as any)
const BaseAuthBackofficeClustersIndexRoute =
  BaseAuthBackofficeClustersIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => BaseAuthBackofficeClustersRouteRoute,
  } as any)
const BaseAuthBackofficeCompaniesCreateRoute =
  BaseAuthBackofficeCompaniesCreateRouteImport.update({
    id: '/companies/create',
    path: '/companies/create',
    getParentRoute: () => BaseAuthBackofficeRouteRoute,
  } as any)
const BaseAuthBackofficeConversationExperimentsListRouteRoute =
  BaseAuthBackofficeConversationExperimentsListRouteRouteImport.update({
    id: '/list',
    path: '/list',
    getParentRoute: () => BaseAuthBackofficeConversationExperimentsRouteRoute,
  } as any)
const BaseAuthBackofficeFlagsIndexRoute =
  BaseAuthBackofficeFlagsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => BaseAuthBackofficeFlagsRouteRoute,
  } as any)
const BaseAuthBackofficeOrganizationsIndexRoute =
  BaseAuthBackofficeOrganizationsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => BaseAuthBackofficeOrganizationsRouteRoute,
  } as any)
const BaseAuthBackofficeOrganizationsIdRouteRoute =
  BaseAuthBackofficeOrganizationsIdRouteRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => BaseAuthBackofficeOrganizationsRouteRoute,
  } as any)
const BaseAuthBackofficeOrganizationsListRoute =
  BaseAuthBackofficeOrganizationsListRouteImport.update({
    id: '/list',
    path: '/list',
    getParentRoute: () => BaseAuthBackofficeOrganizationsRouteRoute,
  } as any)
const BaseAuthBackofficeReferralsIndexRoute =
  BaseAuthBackofficeReferralsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => BaseAuthBackofficeReferralsRouteRoute,
  } as any)
const BaseAuthBackofficeReferralsListRoute =
  BaseAuthBackofficeReferralsListRouteImport.update({
    id: '/list',
    path: '/list',
    getParentRoute: () => BaseAuthBackofficeReferralsRouteRoute,
  } as any)
const BaseAuthBackofficeScheduledReportsIndexRoute =
  BaseAuthBackofficeScheduledReportsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => BaseAuthBackofficeScheduledReportsRouteRoute,
  } as any)
const BaseAuthBackofficeScheduledReportsIdRoute =
  BaseAuthBackofficeScheduledReportsIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => BaseAuthBackofficeScheduledReportsRouteRoute,
  } as any)
const BaseAuthBackofficeScheduledReportsCreateRoute =
  BaseAuthBackofficeScheduledReportsCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => BaseAuthBackofficeScheduledReportsRouteRoute,
  } as any)
const BaseAuthBackofficeScheduledReportsListRouteRoute =
  BaseAuthBackofficeScheduledReportsListRouteRouteImport.update({
    id: '/list',
    path: '/list',
    getParentRoute: () => BaseAuthBackofficeScheduledReportsRouteRoute,
  } as any)
const BaseAuthBackofficeSupportListRouteRoute =
  BaseAuthBackofficeSupportListRouteRouteImport.update({
    id: '/list',
    path: '/list',
    getParentRoute: () => BaseAuthBackofficeSupportRouteRoute,
  } as any)
const BaseAuthCampaignsIdIndexRoute =
  BaseAuthCampaignsIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => BaseAuthCampaignsIdRouteRoute,
  } as any)
const BaseAuthCampaignsIdActivityRouteRoute =
  BaseAuthCampaignsIdActivityRouteRouteImport.update({
    id: '/activity',
    path: '/activity',
    getParentRoute: () => BaseAuthCampaignsIdRouteRoute,
  } as any)
const BaseAuthCampaignsIdCapabilitiesRouteRoute =
  BaseAuthCampaignsIdCapabilitiesRouteRouteImport.update({
    id: '/capabilities',
    path: '/capabilities',
    getParentRoute: () => BaseAuthCampaignsIdRouteRoute,
  } as any)
const BaseAuthCampaignsIdConfigurationRouteRoute =
  BaseAuthCampaignsIdConfigurationRouteRouteImport.update({
    id: '/configuration',
    path: '/configuration',
    getParentRoute: () => BaseAuthCampaignsIdRouteRoute,
  } as any)
const BaseAuthCampaignsIdInsightsRouteRoute =
  BaseAuthCampaignsIdInsightsRouteRouteImport.update({
    id: '/insights',
    path: '/insights',
    getParentRoute: () => BaseAuthCampaignsIdRouteRoute,
  } as any)
const BaseAuthCampaignsIdKnowledgeBaseRouteRoute =
  BaseAuthCampaignsIdKnowledgeBaseRouteRouteImport.update({
    id: '/knowledge-base',
    path: '/knowledge-base',
    getParentRoute: () => BaseAuthCampaignsIdRouteRoute,
  } as any)
const BaseAuthCampaignsIdWorkflowsRouteRoute =
  BaseAuthCampaignsIdWorkflowsRouteRouteImport.update({
    id: '/workflows',
    path: '/workflows',
    getParentRoute: () => BaseAuthCampaignsIdRouteRoute,
  } as any)
const BaseAuthCampaignsGoalsIndexRoute =
  BaseAuthCampaignsGoalsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => BaseAuthCampaignsGoalsRouteRoute,
  } as any)
const BaseAuthCampaignsGoalsListRouteRoute =
  BaseAuthCampaignsGoalsListRouteRouteImport.update({
    id: '/list',
    path: '/list',
    getParentRoute: () => BaseAuthCampaignsGoalsRouteRoute,
  } as any)
const BaseAuthCapabilitiesListCreateCustomRoute =
  BaseAuthCapabilitiesListCreateCustomRouteImport.update({
    id: '/create-custom',
    path: '/create-custom',
    getParentRoute: () => BaseAuthCapabilitiesListRouteRoute,
  } as any)
const BaseAuthConversationsListCustomerIdRouteRoute =
  BaseAuthConversationsListCustomerIdRouteRouteImport.update({
    id: '/$customerId',
    path: '/$customerId',
    getParentRoute: () => BaseAuthConversationsListRouteRoute,
  } as any)
const BaseAuthCustomersListIdRoute = BaseAuthCustomersListIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => BaseAuthCustomersListRouteRoute,
} as any)
const BaseAuthCustomersListCreateRoute =
  BaseAuthCustomersListCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => BaseAuthCustomersListRouteRoute,
  } as any)
const BaseAuthCustomersListImportRoute =
  BaseAuthCustomersListImportRouteImport.update({
    id: '/import',
    path: '/import',
    getParentRoute: () => BaseAuthCustomersListRouteRoute,
  } as any)
const BaseAuthCustomersSegmentsIndexRoute =
  BaseAuthCustomersSegmentsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => BaseAuthCustomersSegmentsRouteRoute,
  } as any)
const BaseAuthCustomersSegmentsIdRouteRoute =
  BaseAuthCustomersSegmentsIdRouteRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => BaseAuthCustomersSegmentsRouteRoute,
  } as any)
const BaseAuthCustomersSegmentsListRouteRoute =
  BaseAuthCustomersSegmentsListRouteRouteImport.update({
    id: '/list',
    path: '/list',
    getParentRoute: () => BaseAuthCustomersSegmentsRouteRoute,
  } as any)
const BaseAuthSettingsChannelsIndexRoute =
  BaseAuthSettingsChannelsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => BaseAuthSettingsChannelsRouteRoute,
  } as any)
const BaseAuthSettingsChannelsGmailRouteRoute =
  BaseAuthSettingsChannelsGmailRouteRouteImport.update({
    id: '/gmail',
    path: '/gmail',
    getParentRoute: () => BaseAuthSettingsChannelsRouteRoute,
  } as any)
const BaseAuthSettingsChannelsInstagramRouteRoute =
  BaseAuthSettingsChannelsInstagramRouteRouteImport.update({
    id: '/instagram',
    path: '/instagram',
    getParentRoute: () => BaseAuthSettingsChannelsRouteRoute,
  } as any)
const BaseAuthSettingsChannelsOutlookRouteRoute =
  BaseAuthSettingsChannelsOutlookRouteRouteImport.update({
    id: '/outlook',
    path: '/outlook',
    getParentRoute: () => BaseAuthSettingsChannelsRouteRoute,
  } as any)
const BaseAuthSettingsChannelsQrRouteRoute =
  BaseAuthSettingsChannelsQrRouteRouteImport.update({
    id: '/qr',
    path: '/qr',
    getParentRoute: () => BaseAuthSettingsChannelsRouteRoute,
  } as any)
const BaseAuthSettingsChannelsWhatsappRouteRoute =
  BaseAuthSettingsChannelsWhatsappRouteRouteImport.update({
    id: '/whatsapp',
    path: '/whatsapp',
    getParentRoute: () => BaseAuthSettingsChannelsRouteRoute,
  } as any)
const BaseAuthSettingsChannelsWidgetRouteRoute =
  BaseAuthSettingsChannelsWidgetRouteRouteImport.update({
    id: '/widget',
    path: '/widget',
    getParentRoute: () => BaseAuthSettingsChannelsRouteRoute,
  } as any)
const BaseAuthSettingsIntegrationsIndexRoute =
  BaseAuthSettingsIntegrationsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => BaseAuthSettingsIntegrationsRouteRoute,
  } as any)
const BaseAuthSettingsIntegrationsAmphoraRouteRoute =
  BaseAuthSettingsIntegrationsAmphoraRouteRouteImport.update({
    id: '/amphora',
    path: '/amphora',
    getParentRoute: () => BaseAuthSettingsIntegrationsRouteRoute,
  } as any)
const BaseAuthSettingsIntegrationsBigblueRouteRoute =
  BaseAuthSettingsIntegrationsBigblueRouteRouteImport.update({
    id: '/bigblue',
    path: '/bigblue',
    getParentRoute: () => BaseAuthSettingsIntegrationsRouteRoute,
  } as any)
const BaseAuthSettingsIntegrationsFrontappRouteRoute =
  BaseAuthSettingsIntegrationsFrontappRouteRouteImport.update({
    id: '/frontapp',
    path: '/frontapp',
    getParentRoute: () => BaseAuthSettingsIntegrationsRouteRoute,
  } as any)
const BaseAuthSettingsIntegrationsGorgiasRouteRoute =
  BaseAuthSettingsIntegrationsGorgiasRouteRouteImport.update({
    id: '/gorgias',
    path: '/gorgias',
    getParentRoute: () => BaseAuthSettingsIntegrationsRouteRoute,
  } as any)
const BaseAuthSettingsIntegrationsKlaviyoRouteRoute =
  BaseAuthSettingsIntegrationsKlaviyoRouteRouteImport.update({
    id: '/klaviyo',
    path: '/klaviyo',
    getParentRoute: () => BaseAuthSettingsIntegrationsRouteRoute,
  } as any)
const BaseAuthSettingsIntegrationsLoopReturnsRouteRoute =
  BaseAuthSettingsIntegrationsLoopReturnsRouteRouteImport.update({
    id: '/loopReturns',
    path: '/loopReturns',
    getParentRoute: () => BaseAuthSettingsIntegrationsRouteRoute,
  } as any)
const BaseAuthSettingsIntegrationsReveniRouteRoute =
  BaseAuthSettingsIntegrationsReveniRouteRouteImport.update({
    id: '/reveni',
    path: '/reveni',
    getParentRoute: () => BaseAuthSettingsIntegrationsRouteRoute,
  } as any)
const BaseAuthSettingsIntegrationsReverRouteRoute =
  BaseAuthSettingsIntegrationsReverRouteRouteImport.update({
    id: '/rever',
    path: '/rever',
    getParentRoute: () => BaseAuthSettingsIntegrationsRouteRoute,
  } as any)
const BaseAuthSettingsIntegrationsSalesForceRouteRoute =
  BaseAuthSettingsIntegrationsSalesForceRouteRouteImport.update({
    id: '/salesForce',
    path: '/salesForce',
    getParentRoute: () => BaseAuthSettingsIntegrationsRouteRoute,
  } as any)
const BaseAuthSettingsIntegrationsShopifyRouteRoute =
  BaseAuthSettingsIntegrationsShopifyRouteRouteImport.update({
    id: '/shopify',
    path: '/shopify',
    getParentRoute: () => BaseAuthSettingsIntegrationsRouteRoute,
  } as any)
const BaseAuthSettingsIntegrationsZendeskRouteRoute =
  BaseAuthSettingsIntegrationsZendeskRouteRouteImport.update({
    id: '/zendesk',
    path: '/zendesk',
    getParentRoute: () => BaseAuthSettingsIntegrationsRouteRoute,
  } as any)
const BaseAuthSettingsSubscriptionIndexRoute =
  BaseAuthSettingsSubscriptionIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => BaseAuthSettingsSubscriptionRouteRoute,
  } as any)
const BaseAuthSettingsSubscriptionPlansRouteRoute =
  BaseAuthSettingsSubscriptionPlansRouteRouteImport.update({
    id: '/plans',
    path: '/plans',
    getParentRoute: () => BaseAuthSettingsSubscriptionRouteRoute,
  } as any)
const BaseAuthSettingsSubscriptionReferralsRouteRoute =
  BaseAuthSettingsSubscriptionReferralsRouteRouteImport.update({
    id: '/referrals',
    path: '/referrals',
    getParentRoute: () => BaseAuthSettingsSubscriptionRouteRoute,
  } as any)
const BaseAuthSettingsSubscriptionUsageRouteRoute =
  BaseAuthSettingsSubscriptionUsageRouteRouteImport.update({
    id: '/usage',
    path: '/usage',
    getParentRoute: () => BaseAuthSettingsSubscriptionRouteRoute,
  } as any)
const BaseAuthSettingsTeamIndexRoute =
  BaseAuthSettingsTeamIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => BaseAuthSettingsTeamRouteRoute,
  } as any)
const BaseAuthSettingsTeamInviteRoute =
  BaseAuthSettingsTeamInviteRouteImport.update({
    id: '/invite',
    path: '/invite',
    getParentRoute: () => BaseAuthSettingsTeamRouteRoute,
  } as any)
const BaseAuthSettingsWorkflowsIndexRoute =
  BaseAuthSettingsWorkflowsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => BaseAuthSettingsWorkflowsRouteRoute,
  } as any)
const BaseAuthSupportListCustomerIdRouteRoute =
  BaseAuthSupportListCustomerIdRouteRouteImport.update({
    id: '/$customerId',
    path: '/$customerId',
    getParentRoute: () => BaseAuthSupportListRouteRoute,
  } as any)
const BaseAuthBackofficeConversationExperimentsListPromptExperimentRoute =
  BaseAuthBackofficeConversationExperimentsListPromptExperimentRouteImport.update(
    {
      id: '/prompt-experiment',
      path: '/prompt-experiment',
      getParentRoute: () =>
        BaseAuthBackofficeConversationExperimentsListRouteRoute,
    } as any,
  )
const BaseAuthBackofficeKnowledgeTopicsTopicIdRoute =
  BaseAuthBackofficeKnowledgeTopicsTopicIdRouteImport.update({
    id: '/topics/$topicId',
    path: '/topics/$topicId',
    getParentRoute: () => BaseAuthBackofficeKnowledgeRouteRoute,
  } as any)
const BaseAuthBackofficeOrganizationsIdIndexRoute =
  BaseAuthBackofficeOrganizationsIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => BaseAuthBackofficeOrganizationsIdRouteRoute,
  } as any)
const BaseAuthBackofficeOrganizationsIdCompaniesRouteRoute =
  BaseAuthBackofficeOrganizationsIdCompaniesRouteRouteImport.update({
    id: '/companies',
    path: '/companies',
    getParentRoute: () => BaseAuthBackofficeOrganizationsIdRouteRoute,
  } as any)
const BaseAuthBackofficeOrganizationsIdCreditsRouteRoute =
  BaseAuthBackofficeOrganizationsIdCreditsRouteRouteImport.update({
    id: '/credits',
    path: '/credits',
    getParentRoute: () => BaseAuthBackofficeOrganizationsIdRouteRoute,
  } as any)
const BaseAuthBackofficeOrganizationsListCreateRoute =
  BaseAuthBackofficeOrganizationsListCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => BaseAuthBackofficeOrganizationsListRoute,
  } as any)
const BaseAuthBackofficeOrganizationsListCreateFromWebsiteRoute =
  BaseAuthBackofficeOrganizationsListCreateFromWebsiteRouteImport.update({
    id: '/create-from-website',
    path: '/create-from-website',
    getParentRoute: () => BaseAuthBackofficeOrganizationsListRoute,
  } as any)
const BaseAuthCampaignsIdActivityCustomerIdRoute =
  BaseAuthCampaignsIdActivityCustomerIdRouteImport.update({
    id: '/$customerId',
    path: '/$customerId',
    getParentRoute: () => BaseAuthCampaignsIdActivityRouteRoute,
  } as any)
const BaseAuthCampaignsIdInsightsLaunchRoute =
  BaseAuthCampaignsIdInsightsLaunchRouteImport.update({
    id: '/launch',
    path: '/launch',
    getParentRoute: () => BaseAuthCampaignsIdInsightsRouteRoute,
  } as any)
const BaseAuthCampaignsGoalsListCreateRoute =
  BaseAuthCampaignsGoalsListCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => BaseAuthCampaignsGoalsListRouteRoute,
  } as any)
const BaseAuthKnowledgeSuggestionsGapIdDismissRoute =
  BaseAuthKnowledgeSuggestionsGapIdDismissRouteImport.update({
    id: '/$gapId/dismiss',
    path: '/$gapId/dismiss',
    getParentRoute: () => BaseAuthKnowledgeSuggestionsRoute,
  } as any)
const BaseAuthKnowledgeSuggestionsGapIdEvidenceRoute =
  BaseAuthKnowledgeSuggestionsGapIdEvidenceRouteImport.update({
    id: '/$gapId/evidence',
    path: '/$gapId/evidence',
    getParentRoute: () => BaseAuthKnowledgeSuggestionsRoute,
  } as any)
const BaseAuthSettingsChannelsGmailNewRoute =
  BaseAuthSettingsChannelsGmailNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => BaseAuthSettingsChannelsGmailRouteRoute,
  } as any)
const BaseAuthSettingsChannelsInstagramNewRoute =
  BaseAuthSettingsChannelsInstagramNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => BaseAuthSettingsChannelsInstagramRouteRoute,
  } as any)
const BaseAuthSettingsChannelsOutlookNewRoute =
  BaseAuthSettingsChannelsOutlookNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => BaseAuthSettingsChannelsOutlookRouteRoute,
  } as any)
const BaseAuthSettingsChannelsQrIdRoute =
  BaseAuthSettingsChannelsQrIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => BaseAuthSettingsChannelsQrRouteRoute,
  } as any)
const BaseAuthSettingsChannelsQrCreateRoute =
  BaseAuthSettingsChannelsQrCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => BaseAuthSettingsChannelsQrRouteRoute,
  } as any)
const BaseAuthSettingsChannelsWhatsappIndexRoute =
  BaseAuthSettingsChannelsWhatsappIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => BaseAuthSettingsChannelsWhatsappRouteRoute,
  } as any)
const BaseAuthSettingsChannelsWhatsappAlertsRoute =
  BaseAuthSettingsChannelsWhatsappAlertsRouteImport.update({
    id: '/alerts',
    path: '/alerts',
    getParentRoute: () => BaseAuthSettingsChannelsWhatsappRouteRoute,
  } as any)
const BaseAuthSettingsChannelsWhatsappOpeningsRouteRoute =
  BaseAuthSettingsChannelsWhatsappOpeningsRouteRouteImport.update({
    id: '/openings',
    path: '/openings',
    getParentRoute: () => BaseAuthSettingsChannelsWhatsappRouteRoute,
  } as any)
const BaseAuthSettingsChannelsWhatsappTemplatesRouteRoute =
  BaseAuthSettingsChannelsWhatsappTemplatesRouteRouteImport.update({
    id: '/templates',
    path: '/templates',
    getParentRoute: () => BaseAuthSettingsChannelsWhatsappRouteRoute,
  } as any)
const BaseAuthSettingsChannelsWidgetIndexRoute =
  BaseAuthSettingsChannelsWidgetIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => BaseAuthSettingsChannelsWidgetRouteRoute,
  } as any)
const BaseAuthSettingsChannelsWidgetPhoneMockupRoute =
  BaseAuthSettingsChannelsWidgetPhoneMockupRouteImport.update({
    id: '/phone-mockup',
    path: '/phone-mockup',
    getParentRoute: () => BaseAuthSettingsChannelsWidgetRouteRoute,
  } as any)
const BaseAuthSettingsIntegrationsAmphoraConnectRoute =
  BaseAuthSettingsIntegrationsAmphoraConnectRouteImport.update({
    id: '/connect',
    path: '/connect',
    getParentRoute: () => BaseAuthSettingsIntegrationsAmphoraRouteRoute,
  } as any)
const BaseAuthSettingsIntegrationsBigblueConnectRoute =
  BaseAuthSettingsIntegrationsBigblueConnectRouteImport.update({
    id: '/connect',
    path: '/connect',
    getParentRoute: () => BaseAuthSettingsIntegrationsBigblueRouteRoute,
  } as any)
const BaseAuthSettingsIntegrationsFrontappConnectRoute =
  BaseAuthSettingsIntegrationsFrontappConnectRouteImport.update({
    id: '/connect',
    path: '/connect',
    getParentRoute: () => BaseAuthSettingsIntegrationsFrontappRouteRoute,
  } as any)
const BaseAuthSettingsIntegrationsGorgiasConnectRoute =
  BaseAuthSettingsIntegrationsGorgiasConnectRouteImport.update({
    id: '/connect',
    path: '/connect',
    getParentRoute: () => BaseAuthSettingsIntegrationsGorgiasRouteRoute,
  } as any)
const BaseAuthSettingsIntegrationsKlaviyoConnectRoute =
  BaseAuthSettingsIntegrationsKlaviyoConnectRouteImport.update({
    id: '/connect',
    path: '/connect',
    getParentRoute: () => BaseAuthSettingsIntegrationsKlaviyoRouteRoute,
  } as any)
const BaseAuthSettingsIntegrationsLoopReturnsConnectRoute =
  BaseAuthSettingsIntegrationsLoopReturnsConnectRouteImport.update({
    id: '/connect',
    path: '/connect',
    getParentRoute: () => BaseAuthSettingsIntegrationsLoopReturnsRouteRoute,
  } as any)
const BaseAuthSettingsIntegrationsReveniConnectRoute =
  BaseAuthSettingsIntegrationsReveniConnectRouteImport.update({
    id: '/connect',
    path: '/connect',
    getParentRoute: () => BaseAuthSettingsIntegrationsReveniRouteRoute,
  } as any)
const BaseAuthSettingsIntegrationsReverConnectRoute =
  BaseAuthSettingsIntegrationsReverConnectRouteImport.update({
    id: '/connect',
    path: '/connect',
    getParentRoute: () => BaseAuthSettingsIntegrationsReverRouteRoute,
  } as any)
const BaseAuthSettingsIntegrationsSalesForceConnectRoute =
  BaseAuthSettingsIntegrationsSalesForceConnectRouteImport.update({
    id: '/connect',
    path: '/connect',
    getParentRoute: () => BaseAuthSettingsIntegrationsSalesForceRouteRoute,
  } as any)
const BaseAuthSettingsIntegrationsShopifySizeChartRoute =
  BaseAuthSettingsIntegrationsShopifySizeChartRouteImport.update({
    id: '/SizeChart',
    path: '/SizeChart',
    getParentRoute: () => BaseAuthSettingsIntegrationsShopifyRouteRoute,
  } as any)
const BaseAuthSettingsIntegrationsShopifyConnectRoute =
  BaseAuthSettingsIntegrationsShopifyConnectRouteImport.update({
    id: '/connect',
    path: '/connect',
    getParentRoute: () => BaseAuthSettingsIntegrationsShopifyRouteRoute,
  } as any)
const BaseAuthSettingsIntegrationsZendeskConnectRoute =
  BaseAuthSettingsIntegrationsZendeskConnectRouteImport.update({
    id: '/connect',
    path: '/connect',
    getParentRoute: () => BaseAuthSettingsIntegrationsZendeskRouteRoute,
  } as any)
const BaseAuthSettingsKeysAndSecretsApiTokensCreateRoute =
  BaseAuthSettingsKeysAndSecretsApiTokensCreateRouteImport.update({
    id: '/api-tokens/create',
    path: '/api-tokens/create',
    getParentRoute: () => BaseAuthSettingsKeysAndSecretsRouteRoute,
  } as any)
const BaseAuthSettingsKeysAndSecretsVaultCreateRoute =
  BaseAuthSettingsKeysAndSecretsVaultCreateRouteImport.update({
    id: '/vault/create',
    path: '/vault/create',
    getParentRoute: () => BaseAuthSettingsKeysAndSecretsRouteRoute,
  } as any)
const BaseAuthSettingsSubscriptionUsageConfigureTopupsRoute =
  BaseAuthSettingsSubscriptionUsageConfigureTopupsRouteImport.update({
    id: '/configure-topups',
    path: '/configure-topups',
    getParentRoute: () => BaseAuthSettingsSubscriptionUsageRouteRoute,
  } as any)
const BaseAuthSettingsTeamEmployeeIdAccessRoute =
  BaseAuthSettingsTeamEmployeeIdAccessRouteImport.update({
    id: '/$employeeId/access',
    path: '/$employeeId/access',
    getParentRoute: () => BaseAuthSettingsTeamRouteRoute,
  } as any)
const BaseAuthBackofficeOrganizationsIdCompaniesCompanyIdRouteRoute =
  BaseAuthBackofficeOrganizationsIdCompaniesCompanyIdRouteRouteImport.update({
    id: '/$companyId',
    path: '/$companyId',
    getParentRoute: () => BaseAuthBackofficeOrganizationsIdCompaniesRouteRoute,
  } as any)
const BaseAuthBackofficeOrganizationsIdCreditsListRoute =
  BaseAuthBackofficeOrganizationsIdCreditsListRouteImport.update({
    id: '/list',
    path: '/list',
    getParentRoute: () => BaseAuthBackofficeOrganizationsIdCreditsRouteRoute,
  } as any)
const BaseAuthCampaignsGoalsListEditIdRoute =
  BaseAuthCampaignsGoalsListEditIdRouteImport.update({
    id: '/edit/$id',
    path: '/edit/$id',
    getParentRoute: () => BaseAuthCampaignsGoalsListRouteRoute,
  } as any)
const BaseAuthSettingsChannelsGmailDeleteIntegrationIdRoute =
  BaseAuthSettingsChannelsGmailDeleteIntegrationIdRouteImport.update({
    id: '/deleteIntegration/$id',
    path: '/deleteIntegration/$id',
    getParentRoute: () => BaseAuthSettingsChannelsGmailRouteRoute,
  } as any)
const BaseAuthSettingsChannelsOutlookDeleteIntegrationIdRoute =
  BaseAuthSettingsChannelsOutlookDeleteIntegrationIdRouteImport.update({
    id: '/deleteIntegration/$id',
    path: '/deleteIntegration/$id',
    getParentRoute: () => BaseAuthSettingsChannelsOutlookRouteRoute,
  } as any)
const BaseAuthSettingsChannelsWhatsappOpeningsIndexRoute =
  BaseAuthSettingsChannelsWhatsappOpeningsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => BaseAuthSettingsChannelsWhatsappOpeningsRouteRoute,
  } as any)
const BaseAuthSettingsChannelsWhatsappOpeningsIdRoute =
  BaseAuthSettingsChannelsWhatsappOpeningsIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => BaseAuthSettingsChannelsWhatsappOpeningsRouteRoute,
  } as any)
const BaseAuthSettingsChannelsWhatsappOpeningsCreateRoute =
  BaseAuthSettingsChannelsWhatsappOpeningsCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => BaseAuthSettingsChannelsWhatsappOpeningsRouteRoute,
  } as any)
const BaseAuthSettingsChannelsWhatsappTemplatesIndexRoute =
  BaseAuthSettingsChannelsWhatsappTemplatesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => BaseAuthSettingsChannelsWhatsappTemplatesRouteRoute,
  } as any)
const BaseAuthSettingsChannelsWhatsappTemplatesIdRoute =
  BaseAuthSettingsChannelsWhatsappTemplatesIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => BaseAuthSettingsChannelsWhatsappTemplatesRouteRoute,
  } as any)
const BaseAuthSettingsChannelsWhatsappTemplatesCreateRoute =
  BaseAuthSettingsChannelsWhatsappTemplatesCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => BaseAuthSettingsChannelsWhatsappTemplatesRouteRoute,
  } as any)
const BaseAuthSettingsKeysAndSecretsVaultKeyReplaceRoute =
  BaseAuthSettingsKeysAndSecretsVaultKeyReplaceRouteImport.update({
    id: '/vault/$key/replace',
    path: '/vault/$key/replace',
    getParentRoute: () => BaseAuthSettingsKeysAndSecretsRouteRoute,
  } as any)
const BaseAuthBackofficeOrganizationsIdCompaniesCompanyIdIndexRoute =
  BaseAuthBackofficeOrganizationsIdCompaniesCompanyIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      BaseAuthBackofficeOrganizationsIdCompaniesCompanyIdRouteRoute,
  } as any)
const BaseAuthBackofficeOrganizationsIdCompaniesCompanyIdCanonicalTopicsRouteRoute =
  BaseAuthBackofficeOrganizationsIdCompaniesCompanyIdCanonicalTopicsRouteRouteImport.update(
    {
      id: '/canonical-topics',
      path: '/canonical-topics',
      getParentRoute: () =>
        BaseAuthBackofficeOrganizationsIdCompaniesCompanyIdRouteRoute,
    } as any,
  )
const BaseAuthBackofficeOrganizationsIdCompaniesCompanyIdCustomersRouteRoute =
  BaseAuthBackofficeOrganizationsIdCompaniesCompanyIdCustomersRouteRouteImport.update(
    {
      id: '/customers',
      path: '/customers',
      getParentRoute: () =>
        BaseAuthBackofficeOrganizationsIdCompaniesCompanyIdRouteRoute,
    } as any,
  )
const BaseAuthBackofficeOrganizationsIdCompaniesCompanyIdCanonicalTopicsListRoute =
  BaseAuthBackofficeOrganizationsIdCompaniesCompanyIdCanonicalTopicsListRouteImport.update(
    {
      id: '/list',
      path: '/list',
      getParentRoute: () =>
        BaseAuthBackofficeOrganizationsIdCompaniesCompanyIdCanonicalTopicsRouteRoute,
    } as any,
  )
const BaseAuthBackofficeOrganizationsIdCompaniesCompanyIdCustomersListRoute =
  BaseAuthBackofficeOrganizationsIdCompaniesCompanyIdCustomersListRouteImport.update(
    {
      id: '/list',
      path: '/list',
      getParentRoute: () =>
        BaseAuthBackofficeOrganizationsIdCompaniesCompanyIdCustomersRouteRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/backoffice': typeof BaseAuthBackofficeRouteRouteWithChildren
  '/campaigns': typeof BaseAuthCampaignsRouteRouteWithChildren
  '/capabilities': typeof BaseAuthCapabilitiesRouteRouteWithChildren
  '/conversations': typeof BaseAuthConversationsRouteRouteWithChildren
  '/customers': typeof BaseAuthCustomersRouteRouteWithChildren
  '/insights': typeof BaseAuthInsightsRouteRouteWithChildren
  '/knowledge': typeof BaseAuthKnowledgeRouteRouteWithChildren
  '/settings': typeof BaseAuthSettingsRouteRouteWithChildren
  '/support': typeof BaseAuthSupportRouteRouteWithChildren
  '/signup-website': typeof BasePublicSignupWebsiteRouteRouteWithChildren
  '/forgot-password': typeof BasePublicForgotPasswordRoute
  '/invite': typeof BasePublicInviteRoute
  '/login': typeof BasePublicLoginRoute
  '/reset-password': typeof BasePublicResetPasswordRoute
  '/signup': typeof BasePublicSignupRoute
  '/backoffice/bi': typeof BaseAuthBackofficeBiRouteRoute
  '/backoffice/campaigns': typeof BaseAuthBackofficeCampaignsRouteRouteWithChildren
  '/backoffice/capabilityExecutions': typeof BaseAuthBackofficeCapabilityExecutionsRouteRoute
  '/backoffice/clusters': typeof BaseAuthBackofficeClustersRouteRouteWithChildren
  '/backoffice/conversationExperiments': typeof BaseAuthBackofficeConversationExperimentsRouteRouteWithChildren
  '/backoffice/conversationSalesReports': typeof BaseAuthBackofficeConversationSalesReportsRouteRoute
  '/backoffice/emailVerifier': typeof BaseAuthBackofficeEmailVerifierRouteRoute
  '/backoffice/flags': typeof BaseAuthBackofficeFlagsRouteRouteWithChildren
  '/backoffice/gmailReader': typeof BaseAuthBackofficeGmailReaderRouteRoute
  '/backoffice/jobSearch': typeof BaseAuthBackofficeJobSearchRouteRoute
  '/backoffice/knowledge': typeof BaseAuthBackofficeKnowledgeRouteRouteWithChildren
  '/backoffice/organizations': typeof BaseAuthBackofficeOrganizationsRouteRouteWithChildren
  '/backoffice/outlookReader': typeof BaseAuthBackofficeOutlookReaderRouteRoute
  '/backoffice/referrals': typeof BaseAuthBackofficeReferralsRouteRouteWithChildren
  '/backoffice/scheduledReports': typeof BaseAuthBackofficeScheduledReportsRouteRouteWithChildren
  '/backoffice/support': typeof BaseAuthBackofficeSupportRouteRouteWithChildren
  '/backoffice/whatsappRoutes': typeof BaseAuthBackofficeWhatsappRoutesRouteRoute
  '/campaigns/$id': typeof BaseAuthCampaignsIdRouteRouteWithChildren
  '/campaigns/goals': typeof BaseAuthCampaignsGoalsRouteRouteWithChildren
  '/campaigns/list': typeof BaseAuthCampaignsListRouteRoute
  '/capabilities/list': typeof BaseAuthCapabilitiesListRouteRouteWithChildren
  '/conversations/list': typeof BaseAuthConversationsListRouteRouteWithChildren
  '/customers/list': typeof BaseAuthCustomersListRouteRouteWithChildren
  '/customers/segments': typeof BaseAuthCustomersSegmentsRouteRouteWithChildren
  '/settings/channels': typeof BaseAuthSettingsChannelsRouteRouteWithChildren
  '/settings/customization': typeof BaseAuthSettingsCustomizationRouteRoute
  '/settings/integrations': typeof BaseAuthSettingsIntegrationsRouteRouteWithChildren
  '/settings/keys-and-secrets': typeof BaseAuthSettingsKeysAndSecretsRouteRouteWithChildren
  '/settings/referrals': typeof BaseAuthSettingsReferralsRouteRoute
  '/settings/subscription': typeof BaseAuthSettingsSubscriptionRouteRouteWithChildren
  '/settings/team': typeof BaseAuthSettingsTeamRouteRouteWithChildren
  '/settings/workflows': typeof BaseAuthSettingsWorkflowsRouteRouteWithChildren
  '/support/list': typeof BaseAuthSupportListRouteRouteWithChildren
  '/knowledge/customization': typeof BaseAuthKnowledgeCustomizationRoute
  '/knowledge/knowledge-base': typeof BaseAuthKnowledgeKnowledgeBaseRoute
  '/knowledge/suggestions': typeof BaseAuthKnowledgeSuggestionsRouteWithChildren
  '/signup-website/preview': typeof BasePublicSignupWebsitePreviewRoute
  '/backoffice/': typeof BaseAuthBackofficeIndexRoute
  '/campaigns/': typeof BaseAuthCampaignsIndexRoute
  '/capabilities/': typeof BaseAuthCapabilitiesIndexRoute
  '/conversations/': typeof BaseAuthConversationsIndexRoute
  '/customers/': typeof BaseAuthCustomersIndexRoute
  '/insights/': typeof BaseAuthInsightsIndexRoute
  '/knowledge/': typeof BaseAuthKnowledgeIndexRoute
  '/settings/': typeof BaseAuthSettingsIndexRoute
  '/support/': typeof BaseAuthSupportIndexRoute
  '/signup-website/': typeof BasePublicSignupWebsiteIndexRoute
  '/backoffice/campaigns/health': typeof BaseAuthBackofficeCampaignsHealthRouteRoute
  '/backoffice/conversationExperiments/list': typeof BaseAuthBackofficeConversationExperimentsListRouteRouteWithChildren
  '/backoffice/organizations/$id': typeof BaseAuthBackofficeOrganizationsIdRouteRouteWithChildren
  '/backoffice/scheduledReports/list': typeof BaseAuthBackofficeScheduledReportsListRouteRoute
  '/backoffice/support/list': typeof BaseAuthBackofficeSupportListRouteRoute
  '/campaigns/$id/activity': typeof BaseAuthCampaignsIdActivityRouteRouteWithChildren
  '/campaigns/$id/capabilities': typeof BaseAuthCampaignsIdCapabilitiesRouteRoute
  '/campaigns/$id/configuration': typeof BaseAuthCampaignsIdConfigurationRouteRoute
  '/campaigns/$id/insights': typeof BaseAuthCampaignsIdInsightsRouteRouteWithChildren
  '/campaigns/$id/knowledge-base': typeof BaseAuthCampaignsIdKnowledgeBaseRouteRoute
  '/campaigns/$id/workflows': typeof BaseAuthCampaignsIdWorkflowsRouteRoute
  '/campaigns/goals/list': typeof BaseAuthCampaignsGoalsListRouteRouteWithChildren
  '/conversations/list/$customerId': typeof BaseAuthConversationsListCustomerIdRouteRoute
  '/customers/segments/$id': typeof BaseAuthCustomersSegmentsIdRouteRoute
  '/customers/segments/list': typeof BaseAuthCustomersSegmentsListRouteRoute
  '/settings/channels/gmail': typeof BaseAuthSettingsChannelsGmailRouteRouteWithChildren
  '/settings/channels/instagram': typeof BaseAuthSettingsChannelsInstagramRouteRouteWithChildren
  '/settings/channels/outlook': typeof BaseAuthSettingsChannelsOutlookRouteRouteWithChildren
  '/settings/channels/qr': typeof BaseAuthSettingsChannelsQrRouteRouteWithChildren
  '/settings/channels/whatsapp': typeof BaseAuthSettingsChannelsWhatsappRouteRouteWithChildren
  '/settings/channels/widget': typeof BaseAuthSettingsChannelsWidgetRouteRouteWithChildren
  '/settings/integrations/amphora': typeof BaseAuthSettingsIntegrationsAmphoraRouteRouteWithChildren
  '/settings/integrations/bigblue': typeof BaseAuthSettingsIntegrationsBigblueRouteRouteWithChildren
  '/settings/integrations/frontapp': typeof BaseAuthSettingsIntegrationsFrontappRouteRouteWithChildren
  '/settings/integrations/gorgias': typeof BaseAuthSettingsIntegrationsGorgiasRouteRouteWithChildren
  '/settings/integrations/klaviyo': typeof BaseAuthSettingsIntegrationsKlaviyoRouteRouteWithChildren
  '/settings/integrations/loopReturns': typeof BaseAuthSettingsIntegrationsLoopReturnsRouteRouteWithChildren
  '/settings/integrations/reveni': typeof BaseAuthSettingsIntegrationsReveniRouteRouteWithChildren
  '/settings/integrations/rever': typeof BaseAuthSettingsIntegrationsReverRouteRouteWithChildren
  '/settings/integrations/salesForce': typeof BaseAuthSettingsIntegrationsSalesForceRouteRouteWithChildren
  '/settings/integrations/shopify': typeof BaseAuthSettingsIntegrationsShopifyRouteRouteWithChildren
  '/settings/integrations/zendesk': typeof BaseAuthSettingsIntegrationsZendeskRouteRouteWithChildren
  '/settings/subscription/plans': typeof BaseAuthSettingsSubscriptionPlansRouteRoute
  '/settings/subscription/referrals': typeof BaseAuthSettingsSubscriptionReferralsRouteRoute
  '/settings/subscription/usage': typeof BaseAuthSettingsSubscriptionUsageRouteRouteWithChildren
  '/support/list/$customerId': typeof BaseAuthSupportListCustomerIdRouteRoute
  '/backoffice/companies/create': typeof BaseAuthBackofficeCompaniesCreateRoute
  '/backoffice/organizations/list': typeof BaseAuthBackofficeOrganizationsListRouteWithChildren
  '/backoffice/referrals/list': typeof BaseAuthBackofficeReferralsListRoute
  '/backoffice/scheduledReports/$id': typeof BaseAuthBackofficeScheduledReportsIdRoute
  '/backoffice/scheduledReports/create': typeof BaseAuthBackofficeScheduledReportsCreateRoute
  '/capabilities/list/create-custom': typeof BaseAuthCapabilitiesListCreateCustomRoute
  '/customers/list/$id': typeof BaseAuthCustomersListIdRoute
  '/customers/list/create': typeof BaseAuthCustomersListCreateRoute
  '/customers/list/import': typeof BaseAuthCustomersListImportRoute
  '/settings/team/invite': typeof BaseAuthSettingsTeamInviteRoute
  '/backoffice/clusters/': typeof BaseAuthBackofficeClustersIndexRoute
  '/backoffice/flags/': typeof BaseAuthBackofficeFlagsIndexRoute
  '/backoffice/organizations/': typeof BaseAuthBackofficeOrganizationsIndexRoute
  '/backoffice/referrals/': typeof BaseAuthBackofficeReferralsIndexRoute
  '/backoffice/scheduledReports/': typeof BaseAuthBackofficeScheduledReportsIndexRoute
  '/campaigns/$id/': typeof BaseAuthCampaignsIdIndexRoute
  '/campaigns/goals/': typeof BaseAuthCampaignsGoalsIndexRoute
  '/customers/segments/': typeof BaseAuthCustomersSegmentsIndexRoute
  '/settings/channels/': typeof BaseAuthSettingsChannelsIndexRoute
  '/settings/integrations/': typeof BaseAuthSettingsIntegrationsIndexRoute
  '/settings/subscription/': typeof BaseAuthSettingsSubscriptionIndexRoute
  '/settings/team/': typeof BaseAuthSettingsTeamIndexRoute
  '/settings/workflows/': typeof BaseAuthSettingsWorkflowsIndexRoute
  '/backoffice/organizations/$id/companies': typeof BaseAuthBackofficeOrganizationsIdCompaniesRouteRouteWithChildren
  '/backoffice/organizations/$id/credits': typeof BaseAuthBackofficeOrganizationsIdCreditsRouteRouteWithChildren
  '/settings/channels/whatsapp/openings': typeof BaseAuthSettingsChannelsWhatsappOpeningsRouteRouteWithChildren
  '/settings/channels/whatsapp/templates': typeof BaseAuthSettingsChannelsWhatsappTemplatesRouteRouteWithChildren
  '/backoffice/conversationExperiments/list/prompt-experiment': typeof BaseAuthBackofficeConversationExperimentsListPromptExperimentRoute
  '/backoffice/knowledge/topics/$topicId': typeof BaseAuthBackofficeKnowledgeTopicsTopicIdRoute
  '/backoffice/organizations/list/create': typeof BaseAuthBackofficeOrganizationsListCreateRoute
  '/backoffice/organizations/list/create-from-website': typeof BaseAuthBackofficeOrganizationsListCreateFromWebsiteRoute
  '/campaigns/$id/activity/$customerId': typeof BaseAuthCampaignsIdActivityCustomerIdRoute
  '/campaigns/$id/insights/launch': typeof BaseAuthCampaignsIdInsightsLaunchRoute
  '/campaigns/goals/list/create': typeof BaseAuthCampaignsGoalsListCreateRoute
  '/knowledge/suggestions/$gapId/dismiss': typeof BaseAuthKnowledgeSuggestionsGapIdDismissRoute
  '/knowledge/suggestions/$gapId/evidence': typeof BaseAuthKnowledgeSuggestionsGapIdEvidenceRoute
  '/settings/channels/gmail/new': typeof BaseAuthSettingsChannelsGmailNewRoute
  '/settings/channels/instagram/new': typeof BaseAuthSettingsChannelsInstagramNewRoute
  '/settings/channels/outlook/new': typeof BaseAuthSettingsChannelsOutlookNewRoute
  '/settings/channels/qr/$id': typeof BaseAuthSettingsChannelsQrIdRoute
  '/settings/channels/qr/create': typeof BaseAuthSettingsChannelsQrCreateRoute
  '/settings/channels/whatsapp/alerts': typeof BaseAuthSettingsChannelsWhatsappAlertsRoute
  '/settings/channels/widget/phone-mockup': typeof BaseAuthSettingsChannelsWidgetPhoneMockupRoute
  '/settings/integrations/amphora/connect': typeof BaseAuthSettingsIntegrationsAmphoraConnectRoute
  '/settings/integrations/bigblue/connect': typeof BaseAuthSettingsIntegrationsBigblueConnectRoute
  '/settings/integrations/frontapp/connect': typeof BaseAuthSettingsIntegrationsFrontappConnectRoute
  '/settings/integrations/gorgias/connect': typeof BaseAuthSettingsIntegrationsGorgiasConnectRoute
  '/settings/integrations/klaviyo/connect': typeof BaseAuthSettingsIntegrationsKlaviyoConnectRoute
  '/settings/integrations/loopReturns/connect': typeof BaseAuthSettingsIntegrationsLoopReturnsConnectRoute
  '/settings/integrations/reveni/connect': typeof BaseAuthSettingsIntegrationsReveniConnectRoute
  '/settings/integrations/rever/connect': typeof BaseAuthSettingsIntegrationsReverConnectRoute
  '/settings/integrations/salesForce/connect': typeof BaseAuthSettingsIntegrationsSalesForceConnectRoute
  '/settings/integrations/shopify/SizeChart': typeof BaseAuthSettingsIntegrationsShopifySizeChartRoute
  '/settings/integrations/shopify/connect': typeof BaseAuthSettingsIntegrationsShopifyConnectRoute
  '/settings/integrations/zendesk/connect': typeof BaseAuthSettingsIntegrationsZendeskConnectRoute
  '/settings/keys-and-secrets/api-tokens/create': typeof BaseAuthSettingsKeysAndSecretsApiTokensCreateRoute
  '/settings/keys-and-secrets/vault/create': typeof BaseAuthSettingsKeysAndSecretsVaultCreateRoute
  '/settings/subscription/usage/configure-topups': typeof BaseAuthSettingsSubscriptionUsageConfigureTopupsRoute
  '/settings/team/$employeeId/access': typeof BaseAuthSettingsTeamEmployeeIdAccessRoute
  '/backoffice/organizations/$id/': typeof BaseAuthBackofficeOrganizationsIdIndexRoute
  '/settings/channels/whatsapp/': typeof BaseAuthSettingsChannelsWhatsappIndexRoute
  '/settings/channels/widget/': typeof BaseAuthSettingsChannelsWidgetIndexRoute
  '/backoffice/organizations/$id/companies/$companyId': typeof BaseAuthBackofficeOrganizationsIdCompaniesCompanyIdRouteRouteWithChildren
  '/backoffice/organizations/$id/credits/list': typeof BaseAuthBackofficeOrganizationsIdCreditsListRoute
  '/campaigns/goals/list/edit/$id': typeof BaseAuthCampaignsGoalsListEditIdRoute
  '/settings/channels/gmail/deleteIntegration/$id': typeof BaseAuthSettingsChannelsGmailDeleteIntegrationIdRoute
  '/settings/channels/outlook/deleteIntegration/$id': typeof BaseAuthSettingsChannelsOutlookDeleteIntegrationIdRoute
  '/settings/channels/whatsapp/openings/$id': typeof BaseAuthSettingsChannelsWhatsappOpeningsIdRoute
  '/settings/channels/whatsapp/openings/create': typeof BaseAuthSettingsChannelsWhatsappOpeningsCreateRoute
  '/settings/channels/whatsapp/templates/$id': typeof BaseAuthSettingsChannelsWhatsappTemplatesIdRoute
  '/settings/channels/whatsapp/templates/create': typeof BaseAuthSettingsChannelsWhatsappTemplatesCreateRoute
  '/settings/keys-and-secrets/vault/$key/replace': typeof BaseAuthSettingsKeysAndSecretsVaultKeyReplaceRoute
  '/settings/channels/whatsapp/openings/': typeof BaseAuthSettingsChannelsWhatsappOpeningsIndexRoute
  '/settings/channels/whatsapp/templates/': typeof BaseAuthSettingsChannelsWhatsappTemplatesIndexRoute
  '/backoffice/organizations/$id/companies/$companyId/canonical-topics': typeof BaseAuthBackofficeOrganizationsIdCompaniesCompanyIdCanonicalTopicsRouteRouteWithChildren
  '/backoffice/organizations/$id/companies/$companyId/customers': typeof BaseAuthBackofficeOrganizationsIdCompaniesCompanyIdCustomersRouteRouteWithChildren
  '/backoffice/organizations/$id/companies/$companyId/': typeof BaseAuthBackofficeOrganizationsIdCompaniesCompanyIdIndexRoute
  '/backoffice/organizations/$id/companies/$companyId/canonical-topics/list': typeof BaseAuthBackofficeOrganizationsIdCompaniesCompanyIdCanonicalTopicsListRoute
  '/backoffice/organizations/$id/companies/$companyId/customers/list': typeof BaseAuthBackofficeOrganizationsIdCompaniesCompanyIdCustomersListRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/forgot-password': typeof BasePublicForgotPasswordRoute
  '/invite': typeof BasePublicInviteRoute
  '/login': typeof BasePublicLoginRoute
  '/reset-password': typeof BasePublicResetPasswordRoute
  '/signup': typeof BasePublicSignupRoute
  '/backoffice/bi': typeof BaseAuthBackofficeBiRouteRoute
  '/backoffice/campaigns': typeof BaseAuthBackofficeCampaignsRouteRouteWithChildren
  '/backoffice/capabilityExecutions': typeof BaseAuthBackofficeCapabilityExecutionsRouteRoute
  '/backoffice/conversationExperiments': typeof BaseAuthBackofficeConversationExperimentsRouteRouteWithChildren
  '/backoffice/conversationSalesReports': typeof BaseAuthBackofficeConversationSalesReportsRouteRoute
  '/backoffice/emailVerifier': typeof BaseAuthBackofficeEmailVerifierRouteRoute
  '/backoffice/gmailReader': typeof BaseAuthBackofficeGmailReaderRouteRoute
  '/backoffice/jobSearch': typeof BaseAuthBackofficeJobSearchRouteRoute
  '/backoffice/knowledge': typeof BaseAuthBackofficeKnowledgeRouteRouteWithChildren
  '/backoffice/outlookReader': typeof BaseAuthBackofficeOutlookReaderRouteRoute
  '/backoffice/support': typeof BaseAuthBackofficeSupportRouteRouteWithChildren
  '/backoffice/whatsappRoutes': typeof BaseAuthBackofficeWhatsappRoutesRouteRoute
  '/campaigns/list': typeof BaseAuthCampaignsListRouteRoute
  '/capabilities/list': typeof BaseAuthCapabilitiesListRouteRouteWithChildren
  '/conversations/list': typeof BaseAuthConversationsListRouteRouteWithChildren
  '/customers/list': typeof BaseAuthCustomersListRouteRouteWithChildren
  '/settings/customization': typeof BaseAuthSettingsCustomizationRouteRoute
  '/settings/keys-and-secrets': typeof BaseAuthSettingsKeysAndSecretsRouteRouteWithChildren
  '/settings/referrals': typeof BaseAuthSettingsReferralsRouteRoute
  '/support/list': typeof BaseAuthSupportListRouteRouteWithChildren
  '/knowledge/customization': typeof BaseAuthKnowledgeCustomizationRoute
  '/knowledge/knowledge-base': typeof BaseAuthKnowledgeKnowledgeBaseRoute
  '/knowledge/suggestions': typeof BaseAuthKnowledgeSuggestionsRouteWithChildren
  '/signup-website/preview': typeof BasePublicSignupWebsitePreviewRoute
  '/backoffice': typeof BaseAuthBackofficeIndexRoute
  '/campaigns': typeof BaseAuthCampaignsIndexRoute
  '/capabilities': typeof BaseAuthCapabilitiesIndexRoute
  '/conversations': typeof BaseAuthConversationsIndexRoute
  '/customers': typeof BaseAuthCustomersIndexRoute
  '/insights': typeof BaseAuthInsightsIndexRoute
  '/knowledge': typeof BaseAuthKnowledgeIndexRoute
  '/settings': typeof BaseAuthSettingsIndexRoute
  '/support': typeof BaseAuthSupportIndexRoute
  '/signup-website': typeof BasePublicSignupWebsiteIndexRoute
  '/backoffice/campaigns/health': typeof BaseAuthBackofficeCampaignsHealthRouteRoute
  '/backoffice/conversationExperiments/list': typeof BaseAuthBackofficeConversationExperimentsListRouteRouteWithChildren
  '/backoffice/scheduledReports/list': typeof BaseAuthBackofficeScheduledReportsListRouteRoute
  '/backoffice/support/list': typeof BaseAuthBackofficeSupportListRouteRoute
  '/campaigns/$id/activity': typeof BaseAuthCampaignsIdActivityRouteRouteWithChildren
  '/campaigns/$id/capabilities': typeof BaseAuthCampaignsIdCapabilitiesRouteRoute
  '/campaigns/$id/configuration': typeof BaseAuthCampaignsIdConfigurationRouteRoute
  '/campaigns/$id/insights': typeof BaseAuthCampaignsIdInsightsRouteRouteWithChildren
  '/campaigns/$id/knowledge-base': typeof BaseAuthCampaignsIdKnowledgeBaseRouteRoute
  '/campaigns/$id/workflows': typeof BaseAuthCampaignsIdWorkflowsRouteRoute
  '/campaigns/goals/list': typeof BaseAuthCampaignsGoalsListRouteRouteWithChildren
  '/conversations/list/$customerId': typeof BaseAuthConversationsListCustomerIdRouteRoute
  '/customers/segments/$id': typeof BaseAuthCustomersSegmentsIdRouteRoute
  '/customers/segments/list': typeof BaseAuthCustomersSegmentsListRouteRoute
  '/settings/channels/gmail': typeof BaseAuthSettingsChannelsGmailRouteRouteWithChildren
  '/settings/channels/instagram': typeof BaseAuthSettingsChannelsInstagramRouteRouteWithChildren
  '/settings/channels/outlook': typeof BaseAuthSettingsChannelsOutlookRouteRouteWithChildren
  '/settings/channels/qr': typeof BaseAuthSettingsChannelsQrRouteRouteWithChildren
  '/settings/integrations/amphora': typeof BaseAuthSettingsIntegrationsAmphoraRouteRouteWithChildren
  '/settings/integrations/bigblue': typeof BaseAuthSettingsIntegrationsBigblueRouteRouteWithChildren
  '/settings/integrations/frontapp': typeof BaseAuthSettingsIntegrationsFrontappRouteRouteWithChildren
  '/settings/integrations/gorgias': typeof BaseAuthSettingsIntegrationsGorgiasRouteRouteWithChildren
  '/settings/integrations/klaviyo': typeof BaseAuthSettingsIntegrationsKlaviyoRouteRouteWithChildren
  '/settings/integrations/loopReturns': typeof BaseAuthSettingsIntegrationsLoopReturnsRouteRouteWithChildren
  '/settings/integrations/reveni': typeof BaseAuthSettingsIntegrationsReveniRouteRouteWithChildren
  '/settings/integrations/rever': typeof BaseAuthSettingsIntegrationsReverRouteRouteWithChildren
  '/settings/integrations/salesForce': typeof BaseAuthSettingsIntegrationsSalesForceRouteRouteWithChildren
  '/settings/integrations/shopify': typeof BaseAuthSettingsIntegrationsShopifyRouteRouteWithChildren
  '/settings/integrations/zendesk': typeof BaseAuthSettingsIntegrationsZendeskRouteRouteWithChildren
  '/settings/subscription/plans': typeof BaseAuthSettingsSubscriptionPlansRouteRoute
  '/settings/subscription/referrals': typeof BaseAuthSettingsSubscriptionReferralsRouteRoute
  '/settings/subscription/usage': typeof BaseAuthSettingsSubscriptionUsageRouteRouteWithChildren
  '/support/list/$customerId': typeof BaseAuthSupportListCustomerIdRouteRoute
  '/backoffice/companies/create': typeof BaseAuthBackofficeCompaniesCreateRoute
  '/backoffice/organizations/list': typeof BaseAuthBackofficeOrganizationsListRouteWithChildren
  '/backoffice/referrals/list': typeof BaseAuthBackofficeReferralsListRoute
  '/backoffice/scheduledReports/$id': typeof BaseAuthBackofficeScheduledReportsIdRoute
  '/backoffice/scheduledReports/create': typeof BaseAuthBackofficeScheduledReportsCreateRoute
  '/capabilities/list/create-custom': typeof BaseAuthCapabilitiesListCreateCustomRoute
  '/customers/list/$id': typeof BaseAuthCustomersListIdRoute
  '/customers/list/create': typeof BaseAuthCustomersListCreateRoute
  '/customers/list/import': typeof BaseAuthCustomersListImportRoute
  '/settings/team/invite': typeof BaseAuthSettingsTeamInviteRoute
  '/backoffice/clusters': typeof BaseAuthBackofficeClustersIndexRoute
  '/backoffice/flags': typeof BaseAuthBackofficeFlagsIndexRoute
  '/backoffice/organizations': typeof BaseAuthBackofficeOrganizationsIndexRoute
  '/backoffice/referrals': typeof BaseAuthBackofficeReferralsIndexRoute
  '/backoffice/scheduledReports': typeof BaseAuthBackofficeScheduledReportsIndexRoute
  '/campaigns/$id': typeof BaseAuthCampaignsIdIndexRoute
  '/campaigns/goals': typeof BaseAuthCampaignsGoalsIndexRoute
  '/customers/segments': typeof BaseAuthCustomersSegmentsIndexRoute
  '/settings/channels': typeof BaseAuthSettingsChannelsIndexRoute
  '/settings/integrations': typeof BaseAuthSettingsIntegrationsIndexRoute
  '/settings/subscription': typeof BaseAuthSettingsSubscriptionIndexRoute
  '/settings/team': typeof BaseAuthSettingsTeamIndexRoute
  '/settings/workflows': typeof BaseAuthSettingsWorkflowsIndexRoute
  '/backoffice/organizations/$id/companies': typeof BaseAuthBackofficeOrganizationsIdCompaniesRouteRouteWithChildren
  '/backoffice/organizations/$id/credits': typeof BaseAuthBackofficeOrganizationsIdCreditsRouteRouteWithChildren
  '/backoffice/conversationExperiments/list/prompt-experiment': typeof BaseAuthBackofficeConversationExperimentsListPromptExperimentRoute
  '/backoffice/knowledge/topics/$topicId': typeof BaseAuthBackofficeKnowledgeTopicsTopicIdRoute
  '/backoffice/organizations/list/create': typeof BaseAuthBackofficeOrganizationsListCreateRoute
  '/backoffice/organizations/list/create-from-website': typeof BaseAuthBackofficeOrganizationsListCreateFromWebsiteRoute
  '/campaigns/$id/activity/$customerId': typeof BaseAuthCampaignsIdActivityCustomerIdRoute
  '/campaigns/$id/insights/launch': typeof BaseAuthCampaignsIdInsightsLaunchRoute
  '/campaigns/goals/list/create': typeof BaseAuthCampaignsGoalsListCreateRoute
  '/knowledge/suggestions/$gapId/dismiss': typeof BaseAuthKnowledgeSuggestionsGapIdDismissRoute
  '/knowledge/suggestions/$gapId/evidence': typeof BaseAuthKnowledgeSuggestionsGapIdEvidenceRoute
  '/settings/channels/gmail/new': typeof BaseAuthSettingsChannelsGmailNewRoute
  '/settings/channels/instagram/new': typeof BaseAuthSettingsChannelsInstagramNewRoute
  '/settings/channels/outlook/new': typeof BaseAuthSettingsChannelsOutlookNewRoute
  '/settings/channels/qr/$id': typeof BaseAuthSettingsChannelsQrIdRoute
  '/settings/channels/qr/create': typeof BaseAuthSettingsChannelsQrCreateRoute
  '/settings/channels/whatsapp/alerts': typeof BaseAuthSettingsChannelsWhatsappAlertsRoute
  '/settings/channels/widget/phone-mockup': typeof BaseAuthSettingsChannelsWidgetPhoneMockupRoute
  '/settings/integrations/amphora/connect': typeof BaseAuthSettingsIntegrationsAmphoraConnectRoute
  '/settings/integrations/bigblue/connect': typeof BaseAuthSettingsIntegrationsBigblueConnectRoute
  '/settings/integrations/frontapp/connect': typeof BaseAuthSettingsIntegrationsFrontappConnectRoute
  '/settings/integrations/gorgias/connect': typeof BaseAuthSettingsIntegrationsGorgiasConnectRoute
  '/settings/integrations/klaviyo/connect': typeof BaseAuthSettingsIntegrationsKlaviyoConnectRoute
  '/settings/integrations/loopReturns/connect': typeof BaseAuthSettingsIntegrationsLoopReturnsConnectRoute
  '/settings/integrations/reveni/connect': typeof BaseAuthSettingsIntegrationsReveniConnectRoute
  '/settings/integrations/rever/connect': typeof BaseAuthSettingsIntegrationsReverConnectRoute
  '/settings/integrations/salesForce/connect': typeof BaseAuthSettingsIntegrationsSalesForceConnectRoute
  '/settings/integrations/shopify/SizeChart': typeof BaseAuthSettingsIntegrationsShopifySizeChartRoute
  '/settings/integrations/shopify/connect': typeof BaseAuthSettingsIntegrationsShopifyConnectRoute
  '/settings/integrations/zendesk/connect': typeof BaseAuthSettingsIntegrationsZendeskConnectRoute
  '/settings/keys-and-secrets/api-tokens/create': typeof BaseAuthSettingsKeysAndSecretsApiTokensCreateRoute
  '/settings/keys-and-secrets/vault/create': typeof BaseAuthSettingsKeysAndSecretsVaultCreateRoute
  '/settings/subscription/usage/configure-topups': typeof BaseAuthSettingsSubscriptionUsageConfigureTopupsRoute
  '/settings/team/$employeeId/access': typeof BaseAuthSettingsTeamEmployeeIdAccessRoute
  '/backoffice/organizations/$id': typeof BaseAuthBackofficeOrganizationsIdIndexRoute
  '/settings/channels/whatsapp': typeof BaseAuthSettingsChannelsWhatsappIndexRoute
  '/settings/channels/widget': typeof BaseAuthSettingsChannelsWidgetIndexRoute
  '/backoffice/organizations/$id/credits/list': typeof BaseAuthBackofficeOrganizationsIdCreditsListRoute
  '/campaigns/goals/list/edit/$id': typeof BaseAuthCampaignsGoalsListEditIdRoute
  '/settings/channels/gmail/deleteIntegration/$id': typeof BaseAuthSettingsChannelsGmailDeleteIntegrationIdRoute
  '/settings/channels/outlook/deleteIntegration/$id': typeof BaseAuthSettingsChannelsOutlookDeleteIntegrationIdRoute
  '/settings/channels/whatsapp/openings/$id': typeof BaseAuthSettingsChannelsWhatsappOpeningsIdRoute
  '/settings/channels/whatsapp/openings/create': typeof BaseAuthSettingsChannelsWhatsappOpeningsCreateRoute
  '/settings/channels/whatsapp/templates/$id': typeof BaseAuthSettingsChannelsWhatsappTemplatesIdRoute
  '/settings/channels/whatsapp/templates/create': typeof BaseAuthSettingsChannelsWhatsappTemplatesCreateRoute
  '/settings/keys-and-secrets/vault/$key/replace': typeof BaseAuthSettingsKeysAndSecretsVaultKeyReplaceRoute
  '/settings/channels/whatsapp/openings': typeof BaseAuthSettingsChannelsWhatsappOpeningsIndexRoute
  '/settings/channels/whatsapp/templates': typeof BaseAuthSettingsChannelsWhatsappTemplatesIndexRoute
  '/backoffice/organizations/$id/companies/$companyId/canonical-topics': typeof BaseAuthBackofficeOrganizationsIdCompaniesCompanyIdCanonicalTopicsRouteRouteWithChildren
  '/backoffice/organizations/$id/companies/$companyId/customers': typeof BaseAuthBackofficeOrganizationsIdCompaniesCompanyIdCustomersRouteRouteWithChildren
  '/backoffice/organizations/$id/companies/$companyId': typeof BaseAuthBackofficeOrganizationsIdCompaniesCompanyIdIndexRoute
  '/backoffice/organizations/$id/companies/$companyId/canonical-topics/list': typeof BaseAuthBackofficeOrganizationsIdCompaniesCompanyIdCanonicalTopicsListRoute
  '/backoffice/organizations/$id/companies/$companyId/customers/list': typeof BaseAuthBackofficeOrganizationsIdCompaniesCompanyIdCustomersListRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_base': typeof BaseRouteRouteWithChildren
  '/_base/_auth': typeof BaseAuthRouteRouteWithChildren
  '/_base/_public': typeof BasePublicRouteRouteWithChildren
  '/_base/_auth/backoffice': typeof BaseAuthBackofficeRouteRouteWithChildren
  '/_base/_auth/campaigns': typeof BaseAuthCampaignsRouteRouteWithChildren
  '/_base/_auth/capabilities': typeof BaseAuthCapabilitiesRouteRouteWithChildren
  '/_base/_auth/conversations': typeof BaseAuthConversationsRouteRouteWithChildren
  '/_base/_auth/customers': typeof BaseAuthCustomersRouteRouteWithChildren
  '/_base/_auth/insights': typeof BaseAuthInsightsRouteRouteWithChildren
  '/_base/_auth/knowledge': typeof BaseAuthKnowledgeRouteRouteWithChildren
  '/_base/_auth/settings': typeof BaseAuthSettingsRouteRouteWithChildren
  '/_base/_auth/support': typeof BaseAuthSupportRouteRouteWithChildren
  '/_base/_public/signup-website': typeof BasePublicSignupWebsiteRouteRouteWithChildren
  '/_base/_public/forgot-password': typeof BasePublicForgotPasswordRoute
  '/_base/_public/invite': typeof BasePublicInviteRoute
  '/_base/_public/login': typeof BasePublicLoginRoute
  '/_base/_public/reset-password': typeof BasePublicResetPasswordRoute
  '/_base/_public/signup': typeof BasePublicSignupRoute
  '/_base/_auth/backoffice/bi': typeof BaseAuthBackofficeBiRouteRoute
  '/_base/_auth/backoffice/campaigns': typeof BaseAuthBackofficeCampaignsRouteRouteWithChildren
  '/_base/_auth/backoffice/capabilityExecutions': typeof BaseAuthBackofficeCapabilityExecutionsRouteRoute
  '/_base/_auth/backoffice/clusters': typeof BaseAuthBackofficeClustersRouteRouteWithChildren
  '/_base/_auth/backoffice/conversationExperiments': typeof BaseAuthBackofficeConversationExperimentsRouteRouteWithChildren
  '/_base/_auth/backoffice/conversationSalesReports': typeof BaseAuthBackofficeConversationSalesReportsRouteRoute
  '/_base/_auth/backoffice/emailVerifier': typeof BaseAuthBackofficeEmailVerifierRouteRoute
  '/_base/_auth/backoffice/flags': typeof BaseAuthBackofficeFlagsRouteRouteWithChildren
  '/_base/_auth/backoffice/gmailReader': typeof BaseAuthBackofficeGmailReaderRouteRoute
  '/_base/_auth/backoffice/jobSearch': typeof BaseAuthBackofficeJobSearchRouteRoute
  '/_base/_auth/backoffice/knowledge': typeof BaseAuthBackofficeKnowledgeRouteRouteWithChildren
  '/_base/_auth/backoffice/organizations': typeof BaseAuthBackofficeOrganizationsRouteRouteWithChildren
  '/_base/_auth/backoffice/outlookReader': typeof BaseAuthBackofficeOutlookReaderRouteRoute
  '/_base/_auth/backoffice/referrals': typeof BaseAuthBackofficeReferralsRouteRouteWithChildren
  '/_base/_auth/backoffice/scheduledReports': typeof BaseAuthBackofficeScheduledReportsRouteRouteWithChildren
  '/_base/_auth/backoffice/support': typeof BaseAuthBackofficeSupportRouteRouteWithChildren
  '/_base/_auth/backoffice/whatsappRoutes': typeof BaseAuthBackofficeWhatsappRoutesRouteRoute
  '/_base/_auth/campaigns/$id': typeof BaseAuthCampaignsIdRouteRouteWithChildren
  '/_base/_auth/campaigns/goals': typeof BaseAuthCampaignsGoalsRouteRouteWithChildren
  '/_base/_auth/campaigns/list': typeof BaseAuthCampaignsListRouteRoute
  '/_base/_auth/capabilities/list': typeof BaseAuthCapabilitiesListRouteRouteWithChildren
  '/_base/_auth/conversations/list': typeof BaseAuthConversationsListRouteRouteWithChildren
  '/_base/_auth/customers/list': typeof BaseAuthCustomersListRouteRouteWithChildren
  '/_base/_auth/customers/segments': typeof BaseAuthCustomersSegmentsRouteRouteWithChildren
  '/_base/_auth/settings/channels': typeof BaseAuthSettingsChannelsRouteRouteWithChildren
  '/_base/_auth/settings/customization': typeof BaseAuthSettingsCustomizationRouteRoute
  '/_base/_auth/settings/integrations': typeof BaseAuthSettingsIntegrationsRouteRouteWithChildren
  '/_base/_auth/settings/keys-and-secrets': typeof BaseAuthSettingsKeysAndSecretsRouteRouteWithChildren
  '/_base/_auth/settings/referrals': typeof BaseAuthSettingsReferralsRouteRoute
  '/_base/_auth/settings/subscription': typeof BaseAuthSettingsSubscriptionRouteRouteWithChildren
  '/_base/_auth/settings/team': typeof BaseAuthSettingsTeamRouteRouteWithChildren
  '/_base/_auth/settings/workflows': typeof BaseAuthSettingsWorkflowsRouteRouteWithChildren
  '/_base/_auth/support/list': typeof BaseAuthSupportListRouteRouteWithChildren
  '/_base/_auth/knowledge/customization': typeof BaseAuthKnowledgeCustomizationRoute
  '/_base/_auth/knowledge/knowledge-base': typeof BaseAuthKnowledgeKnowledgeBaseRoute
  '/_base/_auth/knowledge/suggestions': typeof BaseAuthKnowledgeSuggestionsRouteWithChildren
  '/_base/_public/signup-website/preview': typeof BasePublicSignupWebsitePreviewRoute
  '/_base/_auth/backoffice/': typeof BaseAuthBackofficeIndexRoute
  '/_base/_auth/campaigns/': typeof BaseAuthCampaignsIndexRoute
  '/_base/_auth/capabilities/': typeof BaseAuthCapabilitiesIndexRoute
  '/_base/_auth/conversations/': typeof BaseAuthConversationsIndexRoute
  '/_base/_auth/customers/': typeof BaseAuthCustomersIndexRoute
  '/_base/_auth/insights/': typeof BaseAuthInsightsIndexRoute
  '/_base/_auth/knowledge/': typeof BaseAuthKnowledgeIndexRoute
  '/_base/_auth/settings/': typeof BaseAuthSettingsIndexRoute
  '/_base/_auth/support/': typeof BaseAuthSupportIndexRoute
  '/_base/_public/signup-website/': typeof BasePublicSignupWebsiteIndexRoute
  '/_base/_auth/backoffice/campaigns/health': typeof BaseAuthBackofficeCampaignsHealthRouteRoute
  '/_base/_auth/backoffice/conversationExperiments/list': typeof BaseAuthBackofficeConversationExperimentsListRouteRouteWithChildren
  '/_base/_auth/backoffice/organizations/$id': typeof BaseAuthBackofficeOrganizationsIdRouteRouteWithChildren
  '/_base/_auth/backoffice/scheduledReports/list': typeof BaseAuthBackofficeScheduledReportsListRouteRoute
  '/_base/_auth/backoffice/support/list': typeof BaseAuthBackofficeSupportListRouteRoute
  '/_base/_auth/campaigns/$id/activity': typeof BaseAuthCampaignsIdActivityRouteRouteWithChildren
  '/_base/_auth/campaigns/$id/capabilities': typeof BaseAuthCampaignsIdCapabilitiesRouteRoute
  '/_base/_auth/campaigns/$id/configuration': typeof BaseAuthCampaignsIdConfigurationRouteRoute
  '/_base/_auth/campaigns/$id/insights': typeof BaseAuthCampaignsIdInsightsRouteRouteWithChildren
  '/_base/_auth/campaigns/$id/knowledge-base': typeof BaseAuthCampaignsIdKnowledgeBaseRouteRoute
  '/_base/_auth/campaigns/$id/workflows': typeof BaseAuthCampaignsIdWorkflowsRouteRoute
  '/_base/_auth/campaigns/goals/list': typeof BaseAuthCampaignsGoalsListRouteRouteWithChildren
  '/_base/_auth/conversations/list/$customerId': typeof BaseAuthConversationsListCustomerIdRouteRoute
  '/_base/_auth/customers/segments/$id': typeof BaseAuthCustomersSegmentsIdRouteRoute
  '/_base/_auth/customers/segments/list': typeof BaseAuthCustomersSegmentsListRouteRoute
  '/_base/_auth/settings/channels/gmail': typeof BaseAuthSettingsChannelsGmailRouteRouteWithChildren
  '/_base/_auth/settings/channels/instagram': typeof BaseAuthSettingsChannelsInstagramRouteRouteWithChildren
  '/_base/_auth/settings/channels/outlook': typeof BaseAuthSettingsChannelsOutlookRouteRouteWithChildren
  '/_base/_auth/settings/channels/qr': typeof BaseAuthSettingsChannelsQrRouteRouteWithChildren
  '/_base/_auth/settings/channels/whatsapp': typeof BaseAuthSettingsChannelsWhatsappRouteRouteWithChildren
  '/_base/_auth/settings/channels/widget': typeof BaseAuthSettingsChannelsWidgetRouteRouteWithChildren
  '/_base/_auth/settings/integrations/amphora': typeof BaseAuthSettingsIntegrationsAmphoraRouteRouteWithChildren
  '/_base/_auth/settings/integrations/bigblue': typeof BaseAuthSettingsIntegrationsBigblueRouteRouteWithChildren
  '/_base/_auth/settings/integrations/frontapp': typeof BaseAuthSettingsIntegrationsFrontappRouteRouteWithChildren
  '/_base/_auth/settings/integrations/gorgias': typeof BaseAuthSettingsIntegrationsGorgiasRouteRouteWithChildren
  '/_base/_auth/settings/integrations/klaviyo': typeof BaseAuthSettingsIntegrationsKlaviyoRouteRouteWithChildren
  '/_base/_auth/settings/integrations/loopReturns': typeof BaseAuthSettingsIntegrationsLoopReturnsRouteRouteWithChildren
  '/_base/_auth/settings/integrations/reveni': typeof BaseAuthSettingsIntegrationsReveniRouteRouteWithChildren
  '/_base/_auth/settings/integrations/rever': typeof BaseAuthSettingsIntegrationsReverRouteRouteWithChildren
  '/_base/_auth/settings/integrations/salesForce': typeof BaseAuthSettingsIntegrationsSalesForceRouteRouteWithChildren
  '/_base/_auth/settings/integrations/shopify': typeof BaseAuthSettingsIntegrationsShopifyRouteRouteWithChildren
  '/_base/_auth/settings/integrations/zendesk': typeof BaseAuthSettingsIntegrationsZendeskRouteRouteWithChildren
  '/_base/_auth/settings/subscription/plans': typeof BaseAuthSettingsSubscriptionPlansRouteRoute
  '/_base/_auth/settings/subscription/referrals': typeof BaseAuthSettingsSubscriptionReferralsRouteRoute
  '/_base/_auth/settings/subscription/usage': typeof BaseAuthSettingsSubscriptionUsageRouteRouteWithChildren
  '/_base/_auth/support/list/$customerId': typeof BaseAuthSupportListCustomerIdRouteRoute
  '/_base/_auth/backoffice/companies/create': typeof BaseAuthBackofficeCompaniesCreateRoute
  '/_base/_auth/backoffice/organizations/list': typeof BaseAuthBackofficeOrganizationsListRouteWithChildren
  '/_base/_auth/backoffice/referrals/list': typeof BaseAuthBackofficeReferralsListRoute
  '/_base/_auth/backoffice/scheduledReports/$id': typeof BaseAuthBackofficeScheduledReportsIdRoute
  '/_base/_auth/backoffice/scheduledReports/create': typeof BaseAuthBackofficeScheduledReportsCreateRoute
  '/_base/_auth/capabilities/list/create-custom': typeof BaseAuthCapabilitiesListCreateCustomRoute
  '/_base/_auth/customers/list/$id': typeof BaseAuthCustomersListIdRoute
  '/_base/_auth/customers/list/create': typeof BaseAuthCustomersListCreateRoute
  '/_base/_auth/customers/list/import': typeof BaseAuthCustomersListImportRoute
  '/_base/_auth/settings/team/invite': typeof BaseAuthSettingsTeamInviteRoute
  '/_base/_auth/backoffice/clusters/': typeof BaseAuthBackofficeClustersIndexRoute
  '/_base/_auth/backoffice/flags/': typeof BaseAuthBackofficeFlagsIndexRoute
  '/_base/_auth/backoffice/organizations/': typeof BaseAuthBackofficeOrganizationsIndexRoute
  '/_base/_auth/backoffice/referrals/': typeof BaseAuthBackofficeReferralsIndexRoute
  '/_base/_auth/backoffice/scheduledReports/': typeof BaseAuthBackofficeScheduledReportsIndexRoute
  '/_base/_auth/campaigns/$id/': typeof BaseAuthCampaignsIdIndexRoute
  '/_base/_auth/campaigns/goals/': typeof BaseAuthCampaignsGoalsIndexRoute
  '/_base/_auth/customers/segments/': typeof BaseAuthCustomersSegmentsIndexRoute
  '/_base/_auth/settings/channels/': typeof BaseAuthSettingsChannelsIndexRoute
  '/_base/_auth/settings/integrations/': typeof BaseAuthSettingsIntegrationsIndexRoute
  '/_base/_auth/settings/subscription/': typeof BaseAuthSettingsSubscriptionIndexRoute
  '/_base/_auth/settings/team/': typeof BaseAuthSettingsTeamIndexRoute
  '/_base/_auth/settings/workflows/': typeof BaseAuthSettingsWorkflowsIndexRoute
  '/_base/_auth/backoffice/organizations/$id/companies': typeof BaseAuthBackofficeOrganizationsIdCompaniesRouteRouteWithChildren
  '/_base/_auth/backoffice/organizations/$id/credits': typeof BaseAuthBackofficeOrganizationsIdCreditsRouteRouteWithChildren
  '/_base/_auth/settings/channels/whatsapp/openings': typeof BaseAuthSettingsChannelsWhatsappOpeningsRouteRouteWithChildren
  '/_base/_auth/settings/channels/whatsapp/templates': typeof BaseAuthSettingsChannelsWhatsappTemplatesRouteRouteWithChildren
  '/_base/_auth/backoffice/conversationExperiments/list/prompt-experiment': typeof BaseAuthBackofficeConversationExperimentsListPromptExperimentRoute
  '/_base/_auth/backoffice/knowledge/topics/$topicId': typeof BaseAuthBackofficeKnowledgeTopicsTopicIdRoute
  '/_base/_auth/backoffice/organizations/list/create': typeof BaseAuthBackofficeOrganizationsListCreateRoute
  '/_base/_auth/backoffice/organizations/list/create-from-website': typeof BaseAuthBackofficeOrganizationsListCreateFromWebsiteRoute
  '/_base/_auth/campaigns/$id/activity/$customerId': typeof BaseAuthCampaignsIdActivityCustomerIdRoute
  '/_base/_auth/campaigns/$id/insights/launch': typeof BaseAuthCampaignsIdInsightsLaunchRoute
  '/_base/_auth/campaigns/goals/list/create': typeof BaseAuthCampaignsGoalsListCreateRoute
  '/_base/_auth/knowledge/suggestions/$gapId/dismiss': typeof BaseAuthKnowledgeSuggestionsGapIdDismissRoute
  '/_base/_auth/knowledge/suggestions/$gapId/evidence': typeof BaseAuthKnowledgeSuggestionsGapIdEvidenceRoute
  '/_base/_auth/settings/channels/gmail/new': typeof BaseAuthSettingsChannelsGmailNewRoute
  '/_base/_auth/settings/channels/instagram/new': typeof BaseAuthSettingsChannelsInstagramNewRoute
  '/_base/_auth/settings/channels/outlook/new': typeof BaseAuthSettingsChannelsOutlookNewRoute
  '/_base/_auth/settings/channels/qr/$id': typeof BaseAuthSettingsChannelsQrIdRoute
  '/_base/_auth/settings/channels/qr/create': typeof BaseAuthSettingsChannelsQrCreateRoute
  '/_base/_auth/settings/channels/whatsapp/alerts': typeof BaseAuthSettingsChannelsWhatsappAlertsRoute
  '/_base/_auth/settings/channels/widget/phone-mockup': typeof BaseAuthSettingsChannelsWidgetPhoneMockupRoute
  '/_base/_auth/settings/integrations/amphora/connect': typeof BaseAuthSettingsIntegrationsAmphoraConnectRoute
  '/_base/_auth/settings/integrations/bigblue/connect': typeof BaseAuthSettingsIntegrationsBigblueConnectRoute
  '/_base/_auth/settings/integrations/frontapp/connect': typeof BaseAuthSettingsIntegrationsFrontappConnectRoute
  '/_base/_auth/settings/integrations/gorgias/connect': typeof BaseAuthSettingsIntegrationsGorgiasConnectRoute
  '/_base/_auth/settings/integrations/klaviyo/connect': typeof BaseAuthSettingsIntegrationsKlaviyoConnectRoute
  '/_base/_auth/settings/integrations/loopReturns/connect': typeof BaseAuthSettingsIntegrationsLoopReturnsConnectRoute
  '/_base/_auth/settings/integrations/reveni/connect': typeof BaseAuthSettingsIntegrationsReveniConnectRoute
  '/_base/_auth/settings/integrations/rever/connect': typeof BaseAuthSettingsIntegrationsReverConnectRoute
  '/_base/_auth/settings/integrations/salesForce/connect': typeof BaseAuthSettingsIntegrationsSalesForceConnectRoute
  '/_base/_auth/settings/integrations/shopify/SizeChart': typeof BaseAuthSettingsIntegrationsShopifySizeChartRoute
  '/_base/_auth/settings/integrations/shopify/connect': typeof BaseAuthSettingsIntegrationsShopifyConnectRoute
  '/_base/_auth/settings/integrations/zendesk/connect': typeof BaseAuthSettingsIntegrationsZendeskConnectRoute
  '/_base/_auth/settings/keys-and-secrets/api-tokens/create': typeof BaseAuthSettingsKeysAndSecretsApiTokensCreateRoute
  '/_base/_auth/settings/keys-and-secrets/vault/create': typeof BaseAuthSettingsKeysAndSecretsVaultCreateRoute
  '/_base/_auth/settings/subscription/usage/configure-topups': typeof BaseAuthSettingsSubscriptionUsageConfigureTopupsRoute
  '/_base/_auth/settings/team/$employeeId/access': typeof BaseAuthSettingsTeamEmployeeIdAccessRoute
  '/_base/_auth/backoffice/organizations/$id/': typeof BaseAuthBackofficeOrganizationsIdIndexRoute
  '/_base/_auth/settings/channels/whatsapp/': typeof BaseAuthSettingsChannelsWhatsappIndexRoute
  '/_base/_auth/settings/channels/widget/': typeof BaseAuthSettingsChannelsWidgetIndexRoute
  '/_base/_auth/backoffice/organizations/$id/companies/$companyId': typeof BaseAuthBackofficeOrganizationsIdCompaniesCompanyIdRouteRouteWithChildren
  '/_base/_auth/backoffice/organizations/$id/credits/list': typeof BaseAuthBackofficeOrganizationsIdCreditsListRoute
  '/_base/_auth/campaigns/goals/list/edit/$id': typeof BaseAuthCampaignsGoalsListEditIdRoute
  '/_base/_auth/settings/channels/gmail/deleteIntegration/$id': typeof BaseAuthSettingsChannelsGmailDeleteIntegrationIdRoute
  '/_base/_auth/settings/channels/outlook/deleteIntegration/$id': typeof BaseAuthSettingsChannelsOutlookDeleteIntegrationIdRoute
  '/_base/_auth/settings/channels/whatsapp/openings/$id': typeof BaseAuthSettingsChannelsWhatsappOpeningsIdRoute
  '/_base/_auth/settings/channels/whatsapp/openings/create': typeof BaseAuthSettingsChannelsWhatsappOpeningsCreateRoute
  '/_base/_auth/settings/channels/whatsapp/templates/$id': typeof BaseAuthSettingsChannelsWhatsappTemplatesIdRoute
  '/_base/_auth/settings/channels/whatsapp/templates/create': typeof BaseAuthSettingsChannelsWhatsappTemplatesCreateRoute
  '/_base/_auth/settings/keys-and-secrets/vault/$key/replace': typeof BaseAuthSettingsKeysAndSecretsVaultKeyReplaceRoute
  '/_base/_auth/settings/channels/whatsapp/openings/': typeof BaseAuthSettingsChannelsWhatsappOpeningsIndexRoute
  '/_base/_auth/settings/channels/whatsapp/templates/': typeof BaseAuthSettingsChannelsWhatsappTemplatesIndexRoute
  '/_base/_auth/backoffice/organizations/$id/companies/$companyId/canonical-topics': typeof BaseAuthBackofficeOrganizationsIdCompaniesCompanyIdCanonicalTopicsRouteRouteWithChildren
  '/_base/_auth/backoffice/organizations/$id/companies/$companyId/customers': typeof BaseAuthBackofficeOrganizationsIdCompaniesCompanyIdCustomersRouteRouteWithChildren
  '/_base/_auth/backoffice/organizations/$id/companies/$companyId/': typeof BaseAuthBackofficeOrganizationsIdCompaniesCompanyIdIndexRoute
  '/_base/_auth/backoffice/organizations/$id/companies/$companyId/canonical-topics/list': typeof BaseAuthBackofficeOrganizationsIdCompaniesCompanyIdCanonicalTopicsListRoute
  '/_base/_auth/backoffice/organizations/$id/companies/$companyId/customers/list': typeof BaseAuthBackofficeOrganizationsIdCompaniesCompanyIdCustomersListRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/backoffice'
    | '/campaigns'
    | '/capabilities'
    | '/conversations'
    | '/customers'
    | '/insights'
    | '/knowledge'
    | '/settings'
    | '/support'
    | '/signup-website'
    | '/forgot-password'
    | '/invite'
    | '/login'
    | '/reset-password'
    | '/signup'
    | '/backoffice/bi'
    | '/backoffice/campaigns'
    | '/backoffice/capabilityExecutions'
    | '/backoffice/clusters'
    | '/backoffice/conversationExperiments'
    | '/backoffice/conversationSalesReports'
    | '/backoffice/emailVerifier'
    | '/backoffice/flags'
    | '/backoffice/gmailReader'
    | '/backoffice/jobSearch'
    | '/backoffice/knowledge'
    | '/backoffice/organizations'
    | '/backoffice/outlookReader'
    | '/backoffice/referrals'
    | '/backoffice/scheduledReports'
    | '/backoffice/support'
    | '/backoffice/whatsappRoutes'
    | '/campaigns/$id'
    | '/campaigns/goals'
    | '/campaigns/list'
    | '/capabilities/list'
    | '/conversations/list'
    | '/customers/list'
    | '/customers/segments'
    | '/settings/channels'
    | '/settings/customization'
    | '/settings/integrations'
    | '/settings/keys-and-secrets'
    | '/settings/referrals'
    | '/settings/subscription'
    | '/settings/team'
    | '/settings/workflows'
    | '/support/list'
    | '/knowledge/customization'
    | '/knowledge/knowledge-base'
    | '/knowledge/suggestions'
    | '/signup-website/preview'
    | '/backoffice/'
    | '/campaigns/'
    | '/capabilities/'
    | '/conversations/'
    | '/customers/'
    | '/insights/'
    | '/knowledge/'
    | '/settings/'
    | '/support/'
    | '/signup-website/'
    | '/backoffice/campaigns/health'
    | '/backoffice/conversationExperiments/list'
    | '/backoffice/organizations/$id'
    | '/backoffice/scheduledReports/list'
    | '/backoffice/support/list'
    | '/campaigns/$id/activity'
    | '/campaigns/$id/capabilities'
    | '/campaigns/$id/configuration'
    | '/campaigns/$id/insights'
    | '/campaigns/$id/knowledge-base'
    | '/campaigns/$id/workflows'
    | '/campaigns/goals/list'
    | '/conversations/list/$customerId'
    | '/customers/segments/$id'
    | '/customers/segments/list'
    | '/settings/channels/gmail'
    | '/settings/channels/instagram'
    | '/settings/channels/outlook'
    | '/settings/channels/qr'
    | '/settings/channels/whatsapp'
    | '/settings/channels/widget'
    | '/settings/integrations/amphora'
    | '/settings/integrations/bigblue'
    | '/settings/integrations/frontapp'
    | '/settings/integrations/gorgias'
    | '/settings/integrations/klaviyo'
    | '/settings/integrations/loopReturns'
    | '/settings/integrations/reveni'
    | '/settings/integrations/rever'
    | '/settings/integrations/salesForce'
    | '/settings/integrations/shopify'
    | '/settings/integrations/zendesk'
    | '/settings/subscription/plans'
    | '/settings/subscription/referrals'
    | '/settings/subscription/usage'
    | '/support/list/$customerId'
    | '/backoffice/companies/create'
    | '/backoffice/organizations/list'
    | '/backoffice/referrals/list'
    | '/backoffice/scheduledReports/$id'
    | '/backoffice/scheduledReports/create'
    | '/capabilities/list/create-custom'
    | '/customers/list/$id'
    | '/customers/list/create'
    | '/customers/list/import'
    | '/settings/team/invite'
    | '/backoffice/clusters/'
    | '/backoffice/flags/'
    | '/backoffice/organizations/'
    | '/backoffice/referrals/'
    | '/backoffice/scheduledReports/'
    | '/campaigns/$id/'
    | '/campaigns/goals/'
    | '/customers/segments/'
    | '/settings/channels/'
    | '/settings/integrations/'
    | '/settings/subscription/'
    | '/settings/team/'
    | '/settings/workflows/'
    | '/backoffice/organizations/$id/companies'
    | '/backoffice/organizations/$id/credits'
    | '/settings/channels/whatsapp/openings'
    | '/settings/channels/whatsapp/templates'
    | '/backoffice/conversationExperiments/list/prompt-experiment'
    | '/backoffice/knowledge/topics/$topicId'
    | '/backoffice/organizations/list/create'
    | '/backoffice/organizations/list/create-from-website'
    | '/campaigns/$id/activity/$customerId'
    | '/campaigns/$id/insights/launch'
    | '/campaigns/goals/list/create'
    | '/knowledge/suggestions/$gapId/dismiss'
    | '/knowledge/suggestions/$gapId/evidence'
    | '/settings/channels/gmail/new'
    | '/settings/channels/instagram/new'
    | '/settings/channels/outlook/new'
    | '/settings/channels/qr/$id'
    | '/settings/channels/qr/create'
    | '/settings/channels/whatsapp/alerts'
    | '/settings/channels/widget/phone-mockup'
    | '/settings/integrations/amphora/connect'
    | '/settings/integrations/bigblue/connect'
    | '/settings/integrations/frontapp/connect'
    | '/settings/integrations/gorgias/connect'
    | '/settings/integrations/klaviyo/connect'
    | '/settings/integrations/loopReturns/connect'
    | '/settings/integrations/reveni/connect'
    | '/settings/integrations/rever/connect'
    | '/settings/integrations/salesForce/connect'
    | '/settings/integrations/shopify/SizeChart'
    | '/settings/integrations/shopify/connect'
    | '/settings/integrations/zendesk/connect'
    | '/settings/keys-and-secrets/api-tokens/create'
    | '/settings/keys-and-secrets/vault/create'
    | '/settings/subscription/usage/configure-topups'
    | '/settings/team/$employeeId/access'
    | '/backoffice/organizations/$id/'
    | '/settings/channels/whatsapp/'
    | '/settings/channels/widget/'
    | '/backoffice/organizations/$id/companies/$companyId'
    | '/backoffice/organizations/$id/credits/list'
    | '/campaigns/goals/list/edit/$id'
    | '/settings/channels/gmail/deleteIntegration/$id'
    | '/settings/channels/outlook/deleteIntegration/$id'
    | '/settings/channels/whatsapp/openings/$id'
    | '/settings/channels/whatsapp/openings/create'
    | '/settings/channels/whatsapp/templates/$id'
    | '/settings/channels/whatsapp/templates/create'
    | '/settings/keys-and-secrets/vault/$key/replace'
    | '/settings/channels/whatsapp/openings/'
    | '/settings/channels/whatsapp/templates/'
    | '/backoffice/organizations/$id/companies/$companyId/canonical-topics'
    | '/backoffice/organizations/$id/companies/$companyId/customers'
    | '/backoffice/organizations/$id/companies/$companyId/'
    | '/backoffice/organizations/$id/companies/$companyId/canonical-topics/list'
    | '/backoffice/organizations/$id/companies/$companyId/customers/list'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/forgot-password'
    | '/invite'
    | '/login'
    | '/reset-password'
    | '/signup'
    | '/backoffice/bi'
    | '/backoffice/campaigns'
    | '/backoffice/capabilityExecutions'
    | '/backoffice/conversationExperiments'
    | '/backoffice/conversationSalesReports'
    | '/backoffice/emailVerifier'
    | '/backoffice/gmailReader'
    | '/backoffice/jobSearch'
    | '/backoffice/knowledge'
    | '/backoffice/outlookReader'
    | '/backoffice/support'
    | '/backoffice/whatsappRoutes'
    | '/campaigns/list'
    | '/capabilities/list'
    | '/conversations/list'
    | '/customers/list'
    | '/settings/customization'
    | '/settings/keys-and-secrets'
    | '/settings/referrals'
    | '/support/list'
    | '/knowledge/customization'
    | '/knowledge/knowledge-base'
    | '/knowledge/suggestions'
    | '/signup-website/preview'
    | '/backoffice'
    | '/campaigns'
    | '/capabilities'
    | '/conversations'
    | '/customers'
    | '/insights'
    | '/knowledge'
    | '/settings'
    | '/support'
    | '/signup-website'
    | '/backoffice/campaigns/health'
    | '/backoffice/conversationExperiments/list'
    | '/backoffice/scheduledReports/list'
    | '/backoffice/support/list'
    | '/campaigns/$id/activity'
    | '/campaigns/$id/capabilities'
    | '/campaigns/$id/configuration'
    | '/campaigns/$id/insights'
    | '/campaigns/$id/knowledge-base'
    | '/campaigns/$id/workflows'
    | '/campaigns/goals/list'
    | '/conversations/list/$customerId'
    | '/customers/segments/$id'
    | '/customers/segments/list'
    | '/settings/channels/gmail'
    | '/settings/channels/instagram'
    | '/settings/channels/outlook'
    | '/settings/channels/qr'
    | '/settings/integrations/amphora'
    | '/settings/integrations/bigblue'
    | '/settings/integrations/frontapp'
    | '/settings/integrations/gorgias'
    | '/settings/integrations/klaviyo'
    | '/settings/integrations/loopReturns'
    | '/settings/integrations/reveni'
    | '/settings/integrations/rever'
    | '/settings/integrations/salesForce'
    | '/settings/integrations/shopify'
    | '/settings/integrations/zendesk'
    | '/settings/subscription/plans'
    | '/settings/subscription/referrals'
    | '/settings/subscription/usage'
    | '/support/list/$customerId'
    | '/backoffice/companies/create'
    | '/backoffice/organizations/list'
    | '/backoffice/referrals/list'
    | '/backoffice/scheduledReports/$id'
    | '/backoffice/scheduledReports/create'
    | '/capabilities/list/create-custom'
    | '/customers/list/$id'
    | '/customers/list/create'
    | '/customers/list/import'
    | '/settings/team/invite'
    | '/backoffice/clusters'
    | '/backoffice/flags'
    | '/backoffice/organizations'
    | '/backoffice/referrals'
    | '/backoffice/scheduledReports'
    | '/campaigns/$id'
    | '/campaigns/goals'
    | '/customers/segments'
    | '/settings/channels'
    | '/settings/integrations'
    | '/settings/subscription'
    | '/settings/team'
    | '/settings/workflows'
    | '/backoffice/organizations/$id/companies'
    | '/backoffice/organizations/$id/credits'
    | '/backoffice/conversationExperiments/list/prompt-experiment'
    | '/backoffice/knowledge/topics/$topicId'
    | '/backoffice/organizations/list/create'
    | '/backoffice/organizations/list/create-from-website'
    | '/campaigns/$id/activity/$customerId'
    | '/campaigns/$id/insights/launch'
    | '/campaigns/goals/list/create'
    | '/knowledge/suggestions/$gapId/dismiss'
    | '/knowledge/suggestions/$gapId/evidence'
    | '/settings/channels/gmail/new'
    | '/settings/channels/instagram/new'
    | '/settings/channels/outlook/new'
    | '/settings/channels/qr/$id'
    | '/settings/channels/qr/create'
    | '/settings/channels/whatsapp/alerts'
    | '/settings/channels/widget/phone-mockup'
    | '/settings/integrations/amphora/connect'
    | '/settings/integrations/bigblue/connect'
    | '/settings/integrations/frontapp/connect'
    | '/settings/integrations/gorgias/connect'
    | '/settings/integrations/klaviyo/connect'
    | '/settings/integrations/loopReturns/connect'
    | '/settings/integrations/reveni/connect'
    | '/settings/integrations/rever/connect'
    | '/settings/integrations/salesForce/connect'
    | '/settings/integrations/shopify/SizeChart'
    | '/settings/integrations/shopify/connect'
    | '/settings/integrations/zendesk/connect'
    | '/settings/keys-and-secrets/api-tokens/create'
    | '/settings/keys-and-secrets/vault/create'
    | '/settings/subscription/usage/configure-topups'
    | '/settings/team/$employeeId/access'
    | '/backoffice/organizations/$id'
    | '/settings/channels/whatsapp'
    | '/settings/channels/widget'
    | '/backoffice/organizations/$id/credits/list'
    | '/campaigns/goals/list/edit/$id'
    | '/settings/channels/gmail/deleteIntegration/$id'
    | '/settings/channels/outlook/deleteIntegration/$id'
    | '/settings/channels/whatsapp/openings/$id'
    | '/settings/channels/whatsapp/openings/create'
    | '/settings/channels/whatsapp/templates/$id'
    | '/settings/channels/whatsapp/templates/create'
    | '/settings/keys-and-secrets/vault/$key/replace'
    | '/settings/channels/whatsapp/openings'
    | '/settings/channels/whatsapp/templates'
    | '/backoffice/organizations/$id/companies/$companyId/canonical-topics'
    | '/backoffice/organizations/$id/companies/$companyId/customers'
    | '/backoffice/organizations/$id/companies/$companyId'
    | '/backoffice/organizations/$id/companies/$companyId/canonical-topics/list'
    | '/backoffice/organizations/$id/companies/$companyId/customers/list'
  id:
    | '__root__'
    | '/'
    | '/_base'
    | '/_base/_auth'
    | '/_base/_public'
    | '/_base/_auth/backoffice'
    | '/_base/_auth/campaigns'
    | '/_base/_auth/capabilities'
    | '/_base/_auth/conversations'
    | '/_base/_auth/customers'
    | '/_base/_auth/insights'
    | '/_base/_auth/knowledge'
    | '/_base/_auth/settings'
    | '/_base/_auth/support'
    | '/_base/_public/signup-website'
    | '/_base/_public/forgot-password'
    | '/_base/_public/invite'
    | '/_base/_public/login'
    | '/_base/_public/reset-password'
    | '/_base/_public/signup'
    | '/_base/_auth/backoffice/bi'
    | '/_base/_auth/backoffice/campaigns'
    | '/_base/_auth/backoffice/capabilityExecutions'
    | '/_base/_auth/backoffice/clusters'
    | '/_base/_auth/backoffice/conversationExperiments'
    | '/_base/_auth/backoffice/conversationSalesReports'
    | '/_base/_auth/backoffice/emailVerifier'
    | '/_base/_auth/backoffice/flags'
    | '/_base/_auth/backoffice/gmailReader'
    | '/_base/_auth/backoffice/jobSearch'
    | '/_base/_auth/backoffice/knowledge'
    | '/_base/_auth/backoffice/organizations'
    | '/_base/_auth/backoffice/outlookReader'
    | '/_base/_auth/backoffice/referrals'
    | '/_base/_auth/backoffice/scheduledReports'
    | '/_base/_auth/backoffice/support'
    | '/_base/_auth/backoffice/whatsappRoutes'
    | '/_base/_auth/campaigns/$id'
    | '/_base/_auth/campaigns/goals'
    | '/_base/_auth/campaigns/list'
    | '/_base/_auth/capabilities/list'
    | '/_base/_auth/conversations/list'
    | '/_base/_auth/customers/list'
    | '/_base/_auth/customers/segments'
    | '/_base/_auth/settings/channels'
    | '/_base/_auth/settings/customization'
    | '/_base/_auth/settings/integrations'
    | '/_base/_auth/settings/keys-and-secrets'
    | '/_base/_auth/settings/referrals'
    | '/_base/_auth/settings/subscription'
    | '/_base/_auth/settings/team'
    | '/_base/_auth/settings/workflows'
    | '/_base/_auth/support/list'
    | '/_base/_auth/knowledge/customization'
    | '/_base/_auth/knowledge/knowledge-base'
    | '/_base/_auth/knowledge/suggestions'
    | '/_base/_public/signup-website/preview'
    | '/_base/_auth/backoffice/'
    | '/_base/_auth/campaigns/'
    | '/_base/_auth/capabilities/'
    | '/_base/_auth/conversations/'
    | '/_base/_auth/customers/'
    | '/_base/_auth/insights/'
    | '/_base/_auth/knowledge/'
    | '/_base/_auth/settings/'
    | '/_base/_auth/support/'
    | '/_base/_public/signup-website/'
    | '/_base/_auth/backoffice/campaigns/health'
    | '/_base/_auth/backoffice/conversationExperiments/list'
    | '/_base/_auth/backoffice/organizations/$id'
    | '/_base/_auth/backoffice/scheduledReports/list'
    | '/_base/_auth/backoffice/support/list'
    | '/_base/_auth/campaigns/$id/activity'
    | '/_base/_auth/campaigns/$id/capabilities'
    | '/_base/_auth/campaigns/$id/configuration'
    | '/_base/_auth/campaigns/$id/insights'
    | '/_base/_auth/campaigns/$id/knowledge-base'
    | '/_base/_auth/campaigns/$id/workflows'
    | '/_base/_auth/campaigns/goals/list'
    | '/_base/_auth/conversations/list/$customerId'
    | '/_base/_auth/customers/segments/$id'
    | '/_base/_auth/customers/segments/list'
    | '/_base/_auth/settings/channels/gmail'
    | '/_base/_auth/settings/channels/instagram'
    | '/_base/_auth/settings/channels/outlook'
    | '/_base/_auth/settings/channels/qr'
    | '/_base/_auth/settings/channels/whatsapp'
    | '/_base/_auth/settings/channels/widget'
    | '/_base/_auth/settings/integrations/amphora'
    | '/_base/_auth/settings/integrations/bigblue'
    | '/_base/_auth/settings/integrations/frontapp'
    | '/_base/_auth/settings/integrations/gorgias'
    | '/_base/_auth/settings/integrations/klaviyo'
    | '/_base/_auth/settings/integrations/loopReturns'
    | '/_base/_auth/settings/integrations/reveni'
    | '/_base/_auth/settings/integrations/rever'
    | '/_base/_auth/settings/integrations/salesForce'
    | '/_base/_auth/settings/integrations/shopify'
    | '/_base/_auth/settings/integrations/zendesk'
    | '/_base/_auth/settings/subscription/plans'
    | '/_base/_auth/settings/subscription/referrals'
    | '/_base/_auth/settings/subscription/usage'
    | '/_base/_auth/support/list/$customerId'
    | '/_base/_auth/backoffice/companies/create'
    | '/_base/_auth/backoffice/organizations/list'
    | '/_base/_auth/backoffice/referrals/list'
    | '/_base/_auth/backoffice/scheduledReports/$id'
    | '/_base/_auth/backoffice/scheduledReports/create'
    | '/_base/_auth/capabilities/list/create-custom'
    | '/_base/_auth/customers/list/$id'
    | '/_base/_auth/customers/list/create'
    | '/_base/_auth/customers/list/import'
    | '/_base/_auth/settings/team/invite'
    | '/_base/_auth/backoffice/clusters/'
    | '/_base/_auth/backoffice/flags/'
    | '/_base/_auth/backoffice/organizations/'
    | '/_base/_auth/backoffice/referrals/'
    | '/_base/_auth/backoffice/scheduledReports/'
    | '/_base/_auth/campaigns/$id/'
    | '/_base/_auth/campaigns/goals/'
    | '/_base/_auth/customers/segments/'
    | '/_base/_auth/settings/channels/'
    | '/_base/_auth/settings/integrations/'
    | '/_base/_auth/settings/subscription/'
    | '/_base/_auth/settings/team/'
    | '/_base/_auth/settings/workflows/'
    | '/_base/_auth/backoffice/organizations/$id/companies'
    | '/_base/_auth/backoffice/organizations/$id/credits'
    | '/_base/_auth/settings/channels/whatsapp/openings'
    | '/_base/_auth/settings/channels/whatsapp/templates'
    | '/_base/_auth/backoffice/conversationExperiments/list/prompt-experiment'
    | '/_base/_auth/backoffice/knowledge/topics/$topicId'
    | '/_base/_auth/backoffice/organizations/list/create'
    | '/_base/_auth/backoffice/organizations/list/create-from-website'
    | '/_base/_auth/campaigns/$id/activity/$customerId'
    | '/_base/_auth/campaigns/$id/insights/launch'
    | '/_base/_auth/campaigns/goals/list/create'
    | '/_base/_auth/knowledge/suggestions/$gapId/dismiss'
    | '/_base/_auth/knowledge/suggestions/$gapId/evidence'
    | '/_base/_auth/settings/channels/gmail/new'
    | '/_base/_auth/settings/channels/instagram/new'
    | '/_base/_auth/settings/channels/outlook/new'
    | '/_base/_auth/settings/channels/qr/$id'
    | '/_base/_auth/settings/channels/qr/create'
    | '/_base/_auth/settings/channels/whatsapp/alerts'
    | '/_base/_auth/settings/channels/widget/phone-mockup'
    | '/_base/_auth/settings/integrations/amphora/connect'
    | '/_base/_auth/settings/integrations/bigblue/connect'
    | '/_base/_auth/settings/integrations/frontapp/connect'
    | '/_base/_auth/settings/integrations/gorgias/connect'
    | '/_base/_auth/settings/integrations/klaviyo/connect'
    | '/_base/_auth/settings/integrations/loopReturns/connect'
    | '/_base/_auth/settings/integrations/reveni/connect'
    | '/_base/_auth/settings/integrations/rever/connect'
    | '/_base/_auth/settings/integrations/salesForce/connect'
    | '/_base/_auth/settings/integrations/shopify/SizeChart'
    | '/_base/_auth/settings/integrations/shopify/connect'
    | '/_base/_auth/settings/integrations/zendesk/connect'
    | '/_base/_auth/settings/keys-and-secrets/api-tokens/create'
    | '/_base/_auth/settings/keys-and-secrets/vault/create'
    | '/_base/_auth/settings/subscription/usage/configure-topups'
    | '/_base/_auth/settings/team/$employeeId/access'
    | '/_base/_auth/backoffice/organizations/$id/'
    | '/_base/_auth/settings/channels/whatsapp/'
    | '/_base/_auth/settings/channels/widget/'
    | '/_base/_auth/backoffice/organizations/$id/companies/$companyId'
    | '/_base/_auth/backoffice/organizations/$id/credits/list'
    | '/_base/_auth/campaigns/goals/list/edit/$id'
    | '/_base/_auth/settings/channels/gmail/deleteIntegration/$id'
    | '/_base/_auth/settings/channels/outlook/deleteIntegration/$id'
    | '/_base/_auth/settings/channels/whatsapp/openings/$id'
    | '/_base/_auth/settings/channels/whatsapp/openings/create'
    | '/_base/_auth/settings/channels/whatsapp/templates/$id'
    | '/_base/_auth/settings/channels/whatsapp/templates/create'
    | '/_base/_auth/settings/keys-and-secrets/vault/$key/replace'
    | '/_base/_auth/settings/channels/whatsapp/openings/'
    | '/_base/_auth/settings/channels/whatsapp/templates/'
    | '/_base/_auth/backoffice/organizations/$id/companies/$companyId/canonical-topics'
    | '/_base/_auth/backoffice/organizations/$id/companies/$companyId/customers'
    | '/_base/_auth/backoffice/organizations/$id/companies/$companyId/'
    | '/_base/_auth/backoffice/organizations/$id/companies/$companyId/canonical-topics/list'
    | '/_base/_auth/backoffice/organizations/$id/companies/$companyId/customers/list'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  BaseRouteRoute: typeof BaseRouteRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_base': {
      id: '/_base'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof BaseRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_base/_auth': {
      id: '/_base/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof BaseAuthRouteRouteImport
      parentRoute: typeof BaseRouteRoute
    }
    '/_base/_public': {
      id: '/_base/_public'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof BasePublicRouteRouteImport
      parentRoute: typeof BaseRouteRoute
    }
    '/_base/_auth/backoffice': {
      id: '/_base/_auth/backoffice'
      path: '/backoffice'
      fullPath: '/backoffice'
      preLoaderRoute: typeof BaseAuthBackofficeRouteRouteImport
      parentRoute: typeof BaseAuthRouteRoute
    }
    '/_base/_auth/campaigns': {
      id: '/_base/_auth/campaigns'
      path: '/campaigns'
      fullPath: '/campaigns'
      preLoaderRoute: typeof BaseAuthCampaignsRouteRouteImport
      parentRoute: typeof BaseAuthRouteRoute
    }
    '/_base/_auth/capabilities': {
      id: '/_base/_auth/capabilities'
      path: '/capabilities'
      fullPath: '/capabilities'
      preLoaderRoute: typeof BaseAuthCapabilitiesRouteRouteImport
      parentRoute: typeof BaseAuthRouteRoute
    }
    '/_base/_auth/conversations': {
      id: '/_base/_auth/conversations'
      path: '/conversations'
      fullPath: '/conversations'
      preLoaderRoute: typeof BaseAuthConversationsRouteRouteImport
      parentRoute: typeof BaseAuthRouteRoute
    }
    '/_base/_auth/customers': {
      id: '/_base/_auth/customers'
      path: '/customers'
      fullPath: '/customers'
      preLoaderRoute: typeof BaseAuthCustomersRouteRouteImport
      parentRoute: typeof BaseAuthRouteRoute
    }
    '/_base/_auth/insights': {
      id: '/_base/_auth/insights'
      path: '/insights'
      fullPath: '/insights'
      preLoaderRoute: typeof BaseAuthInsightsRouteRouteImport
      parentRoute: typeof BaseAuthRouteRoute
    }
    '/_base/_auth/knowledge': {
      id: '/_base/_auth/knowledge'
      path: '/knowledge'
      fullPath: '/knowledge'
      preLoaderRoute: typeof BaseAuthKnowledgeRouteRouteImport
      parentRoute: typeof BaseAuthRouteRoute
    }
    '/_base/_auth/settings': {
      id: '/_base/_auth/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof BaseAuthSettingsRouteRouteImport
      parentRoute: typeof BaseAuthRouteRoute
    }
    '/_base/_auth/support': {
      id: '/_base/_auth/support'
      path: '/support'
      fullPath: '/support'
      preLoaderRoute: typeof BaseAuthSupportRouteRouteImport
      parentRoute: typeof BaseAuthRouteRoute
    }
    '/_base/_public/forgot-password': {
      id: '/_base/_public/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof BasePublicForgotPasswordRouteImport
      parentRoute: typeof BasePublicRouteRoute
    }
    '/_base/_public/invite': {
      id: '/_base/_public/invite'
      path: '/invite'
      fullPath: '/invite'
      preLoaderRoute: typeof BasePublicInviteRouteImport
      parentRoute: typeof BasePublicRouteRoute
    }
    '/_base/_public/login': {
      id: '/_base/_public/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof BasePublicLoginRouteImport
      parentRoute: typeof BasePublicRouteRoute
    }
    '/_base/_public/reset-password': {
      id: '/_base/_public/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof BasePublicResetPasswordRouteImport
      parentRoute: typeof BasePublicRouteRoute
    }
    '/_base/_public/signup': {
      id: '/_base/_public/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof BasePublicSignupRouteImport
      parentRoute: typeof BasePublicRouteRoute
    }
    '/_base/_public/signup-website': {
      id: '/_base/_public/signup-website'
      path: '/signup-website'
      fullPath: '/signup-website'
      preLoaderRoute: typeof BasePublicSignupWebsiteRouteRouteImport
      parentRoute: typeof BasePublicRouteRoute
    }
    '/_base/_auth/backoffice/': {
      id: '/_base/_auth/backoffice/'
      path: '/'
      fullPath: '/backoffice/'
      preLoaderRoute: typeof BaseAuthBackofficeIndexRouteImport
      parentRoute: typeof BaseAuthBackofficeRouteRoute
    }
    '/_base/_auth/backoffice/bi': {
      id: '/_base/_auth/backoffice/bi'
      path: '/bi'
      fullPath: '/backoffice/bi'
      preLoaderRoute: typeof BaseAuthBackofficeBiRouteRouteImport
      parentRoute: typeof BaseAuthBackofficeRouteRoute
    }
    '/_base/_auth/backoffice/campaigns': {
      id: '/_base/_auth/backoffice/campaigns'
      path: '/campaigns'
      fullPath: '/backoffice/campaigns'
      preLoaderRoute: typeof BaseAuthBackofficeCampaignsRouteRouteImport
      parentRoute: typeof BaseAuthBackofficeRouteRoute
    }
    '/_base/_auth/backoffice/capabilityExecutions': {
      id: '/_base/_auth/backoffice/capabilityExecutions'
      path: '/capabilityExecutions'
      fullPath: '/backoffice/capabilityExecutions'
      preLoaderRoute: typeof BaseAuthBackofficeCapabilityExecutionsRouteRouteImport
      parentRoute: typeof BaseAuthBackofficeRouteRoute
    }
    '/_base/_auth/backoffice/clusters': {
      id: '/_base/_auth/backoffice/clusters'
      path: '/clusters'
      fullPath: '/backoffice/clusters'
      preLoaderRoute: typeof BaseAuthBackofficeClustersRouteRouteImport
      parentRoute: typeof BaseAuthBackofficeRouteRoute
    }
    '/_base/_auth/backoffice/conversationExperiments': {
      id: '/_base/_auth/backoffice/conversationExperiments'
      path: '/conversationExperiments'
      fullPath: '/backoffice/conversationExperiments'
      preLoaderRoute: typeof BaseAuthBackofficeConversationExperimentsRouteRouteImport
      parentRoute: typeof BaseAuthBackofficeRouteRoute
    }
    '/_base/_auth/backoffice/conversationSalesReports': {
      id: '/_base/_auth/backoffice/conversationSalesReports'
      path: '/conversationSalesReports'
      fullPath: '/backoffice/conversationSalesReports'
      preLoaderRoute: typeof BaseAuthBackofficeConversationSalesReportsRouteRouteImport
      parentRoute: typeof BaseAuthBackofficeRouteRoute
    }
    '/_base/_auth/backoffice/emailVerifier': {
      id: '/_base/_auth/backoffice/emailVerifier'
      path: '/emailVerifier'
      fullPath: '/backoffice/emailVerifier'
      preLoaderRoute: typeof BaseAuthBackofficeEmailVerifierRouteRouteImport
      parentRoute: typeof BaseAuthBackofficeRouteRoute
    }
    '/_base/_auth/backoffice/flags': {
      id: '/_base/_auth/backoffice/flags'
      path: '/flags'
      fullPath: '/backoffice/flags'
      preLoaderRoute: typeof BaseAuthBackofficeFlagsRouteRouteImport
      parentRoute: typeof BaseAuthBackofficeRouteRoute
    }
    '/_base/_auth/backoffice/gmailReader': {
      id: '/_base/_auth/backoffice/gmailReader'
      path: '/gmailReader'
      fullPath: '/backoffice/gmailReader'
      preLoaderRoute: typeof BaseAuthBackofficeGmailReaderRouteRouteImport
      parentRoute: typeof BaseAuthBackofficeRouteRoute
    }
    '/_base/_auth/backoffice/jobSearch': {
      id: '/_base/_auth/backoffice/jobSearch'
      path: '/jobSearch'
      fullPath: '/backoffice/jobSearch'
      preLoaderRoute: typeof BaseAuthBackofficeJobSearchRouteRouteImport
      parentRoute: typeof BaseAuthBackofficeRouteRoute
    }
    '/_base/_auth/backoffice/knowledge': {
      id: '/_base/_auth/backoffice/knowledge'
      path: '/knowledge'
      fullPath: '/backoffice/knowledge'
      preLoaderRoute: typeof BaseAuthBackofficeKnowledgeRouteRouteImport
      parentRoute: typeof BaseAuthBackofficeRouteRoute
    }
    '/_base/_auth/backoffice/organizations': {
      id: '/_base/_auth/backoffice/organizations'
      path: '/organizations'
      fullPath: '/backoffice/organizations'
      preLoaderRoute: typeof BaseAuthBackofficeOrganizationsRouteRouteImport
      parentRoute: typeof BaseAuthBackofficeRouteRoute
    }
    '/_base/_auth/backoffice/outlookReader': {
      id: '/_base/_auth/backoffice/outlookReader'
      path: '/outlookReader'
      fullPath: '/backoffice/outlookReader'
      preLoaderRoute: typeof BaseAuthBackofficeOutlookReaderRouteRouteImport
      parentRoute: typeof BaseAuthBackofficeRouteRoute
    }
    '/_base/_auth/backoffice/referrals': {
      id: '/_base/_auth/backoffice/referrals'
      path: '/referrals'
      fullPath: '/backoffice/referrals'
      preLoaderRoute: typeof BaseAuthBackofficeReferralsRouteRouteImport
      parentRoute: typeof BaseAuthBackofficeRouteRoute
    }
    '/_base/_auth/backoffice/scheduledReports': {
      id: '/_base/_auth/backoffice/scheduledReports'
      path: '/scheduledReports'
      fullPath: '/backoffice/scheduledReports'
      preLoaderRoute: typeof BaseAuthBackofficeScheduledReportsRouteRouteImport
      parentRoute: typeof BaseAuthBackofficeRouteRoute
    }
    '/_base/_auth/backoffice/support': {
      id: '/_base/_auth/backoffice/support'
      path: '/support'
      fullPath: '/backoffice/support'
      preLoaderRoute: typeof BaseAuthBackofficeSupportRouteRouteImport
      parentRoute: typeof BaseAuthBackofficeRouteRoute
    }
    '/_base/_auth/backoffice/whatsappRoutes': {
      id: '/_base/_auth/backoffice/whatsappRoutes'
      path: '/whatsappRoutes'
      fullPath: '/backoffice/whatsappRoutes'
      preLoaderRoute: typeof BaseAuthBackofficeWhatsappRoutesRouteRouteImport
      parentRoute: typeof BaseAuthBackofficeRouteRoute
    }
    '/_base/_auth/campaigns/': {
      id: '/_base/_auth/campaigns/'
      path: '/'
      fullPath: '/campaigns/'
      preLoaderRoute: typeof BaseAuthCampaignsIndexRouteImport
      parentRoute: typeof BaseAuthCampaignsRouteRoute
    }
    '/_base/_auth/campaigns/$id': {
      id: '/_base/_auth/campaigns/$id'
      path: '/$id'
      fullPath: '/campaigns/$id'
      preLoaderRoute: typeof BaseAuthCampaignsIdRouteRouteImport
      parentRoute: typeof BaseAuthCampaignsRouteRoute
    }
    '/_base/_auth/campaigns/goals': {
      id: '/_base/_auth/campaigns/goals'
      path: '/goals'
      fullPath: '/campaigns/goals'
      preLoaderRoute: typeof BaseAuthCampaignsGoalsRouteRouteImport
      parentRoute: typeof BaseAuthCampaignsRouteRoute
    }
    '/_base/_auth/campaigns/list': {
      id: '/_base/_auth/campaigns/list'
      path: '/list'
      fullPath: '/campaigns/list'
      preLoaderRoute: typeof BaseAuthCampaignsListRouteRouteImport
      parentRoute: typeof BaseAuthCampaignsRouteRoute
    }
    '/_base/_auth/capabilities/': {
      id: '/_base/_auth/capabilities/'
      path: '/'
      fullPath: '/capabilities/'
      preLoaderRoute: typeof BaseAuthCapabilitiesIndexRouteImport
      parentRoute: typeof BaseAuthCapabilitiesRouteRoute
    }
    '/_base/_auth/capabilities/list': {
      id: '/_base/_auth/capabilities/list'
      path: '/list'
      fullPath: '/capabilities/list'
      preLoaderRoute: typeof BaseAuthCapabilitiesListRouteRouteImport
      parentRoute: typeof BaseAuthCapabilitiesRouteRoute
    }
    '/_base/_auth/conversations/': {
      id: '/_base/_auth/conversations/'
      path: '/'
      fullPath: '/conversations/'
      preLoaderRoute: typeof BaseAuthConversationsIndexRouteImport
      parentRoute: typeof BaseAuthConversationsRouteRoute
    }
    '/_base/_auth/conversations/list': {
      id: '/_base/_auth/conversations/list'
      path: '/list'
      fullPath: '/conversations/list'
      preLoaderRoute: typeof BaseAuthConversationsListRouteRouteImport
      parentRoute: typeof BaseAuthConversationsRouteRoute
    }
    '/_base/_auth/customers/': {
      id: '/_base/_auth/customers/'
      path: '/'
      fullPath: '/customers/'
      preLoaderRoute: typeof BaseAuthCustomersIndexRouteImport
      parentRoute: typeof BaseAuthCustomersRouteRoute
    }
    '/_base/_auth/customers/list': {
      id: '/_base/_auth/customers/list'
      path: '/list'
      fullPath: '/customers/list'
      preLoaderRoute: typeof BaseAuthCustomersListRouteRouteImport
      parentRoute: typeof BaseAuthCustomersRouteRoute
    }
    '/_base/_auth/customers/segments': {
      id: '/_base/_auth/customers/segments'
      path: '/segments'
      fullPath: '/customers/segments'
      preLoaderRoute: typeof BaseAuthCustomersSegmentsRouteRouteImport
      parentRoute: typeof BaseAuthCustomersRouteRoute
    }
    '/_base/_auth/insights/': {
      id: '/_base/_auth/insights/'
      path: '/'
      fullPath: '/insights/'
      preLoaderRoute: typeof BaseAuthInsightsIndexRouteImport
      parentRoute: typeof BaseAuthInsightsRouteRoute
    }
    '/_base/_auth/knowledge/': {
      id: '/_base/_auth/knowledge/'
      path: '/'
      fullPath: '/knowledge/'
      preLoaderRoute: typeof BaseAuthKnowledgeIndexRouteImport
      parentRoute: typeof BaseAuthKnowledgeRouteRoute
    }
    '/_base/_auth/knowledge/customization': {
      id: '/_base/_auth/knowledge/customization'
      path: '/customization'
      fullPath: '/knowledge/customization'
      preLoaderRoute: typeof BaseAuthKnowledgeCustomizationRouteImport
      parentRoute: typeof BaseAuthKnowledgeRouteRoute
    }
    '/_base/_auth/knowledge/knowledge-base': {
      id: '/_base/_auth/knowledge/knowledge-base'
      path: '/knowledge-base'
      fullPath: '/knowledge/knowledge-base'
      preLoaderRoute: typeof BaseAuthKnowledgeKnowledgeBaseRouteImport
      parentRoute: typeof BaseAuthKnowledgeRouteRoute
    }
    '/_base/_auth/knowledge/suggestions': {
      id: '/_base/_auth/knowledge/suggestions'
      path: '/suggestions'
      fullPath: '/knowledge/suggestions'
      preLoaderRoute: typeof BaseAuthKnowledgeSuggestionsRouteImport
      parentRoute: typeof BaseAuthKnowledgeRouteRoute
    }
    '/_base/_auth/settings/': {
      id: '/_base/_auth/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof BaseAuthSettingsIndexRouteImport
      parentRoute: typeof BaseAuthSettingsRouteRoute
    }
    '/_base/_auth/settings/channels': {
      id: '/_base/_auth/settings/channels'
      path: '/channels'
      fullPath: '/settings/channels'
      preLoaderRoute: typeof BaseAuthSettingsChannelsRouteRouteImport
      parentRoute: typeof BaseAuthSettingsRouteRoute
    }
    '/_base/_auth/settings/customization': {
      id: '/_base/_auth/settings/customization'
      path: '/customization'
      fullPath: '/settings/customization'
      preLoaderRoute: typeof BaseAuthSettingsCustomizationRouteRouteImport
      parentRoute: typeof BaseAuthSettingsRouteRoute
    }
    '/_base/_auth/settings/integrations': {
      id: '/_base/_auth/settings/integrations'
      path: '/integrations'
      fullPath: '/settings/integrations'
      preLoaderRoute: typeof BaseAuthSettingsIntegrationsRouteRouteImport
      parentRoute: typeof BaseAuthSettingsRouteRoute
    }
    '/_base/_auth/settings/keys-and-secrets': {
      id: '/_base/_auth/settings/keys-and-secrets'
      path: '/keys-and-secrets'
      fullPath: '/settings/keys-and-secrets'
      preLoaderRoute: typeof BaseAuthSettingsKeysAndSecretsRouteRouteImport
      parentRoute: typeof BaseAuthSettingsRouteRoute
    }
    '/_base/_auth/settings/referrals': {
      id: '/_base/_auth/settings/referrals'
      path: '/referrals'
      fullPath: '/settings/referrals'
      preLoaderRoute: typeof BaseAuthSettingsReferralsRouteRouteImport
      parentRoute: typeof BaseAuthSettingsRouteRoute
    }
    '/_base/_auth/settings/subscription': {
      id: '/_base/_auth/settings/subscription'
      path: '/subscription'
      fullPath: '/settings/subscription'
      preLoaderRoute: typeof BaseAuthSettingsSubscriptionRouteRouteImport
      parentRoute: typeof BaseAuthSettingsRouteRoute
    }
    '/_base/_auth/settings/team': {
      id: '/_base/_auth/settings/team'
      path: '/team'
      fullPath: '/settings/team'
      preLoaderRoute: typeof BaseAuthSettingsTeamRouteRouteImport
      parentRoute: typeof BaseAuthSettingsRouteRoute
    }
    '/_base/_auth/settings/workflows': {
      id: '/_base/_auth/settings/workflows'
      path: '/workflows'
      fullPath: '/settings/workflows'
      preLoaderRoute: typeof BaseAuthSettingsWorkflowsRouteRouteImport
      parentRoute: typeof BaseAuthSettingsRouteRoute
    }
    '/_base/_auth/support/': {
      id: '/_base/_auth/support/'
      path: '/'
      fullPath: '/support/'
      preLoaderRoute: typeof BaseAuthSupportIndexRouteImport
      parentRoute: typeof BaseAuthSupportRouteRoute
    }
    '/_base/_auth/support/list': {
      id: '/_base/_auth/support/list'
      path: '/list'
      fullPath: '/support/list'
      preLoaderRoute: typeof BaseAuthSupportListRouteRouteImport
      parentRoute: typeof BaseAuthSupportRouteRoute
    }
    '/_base/_public/signup-website/': {
      id: '/_base/_public/signup-website/'
      path: '/'
      fullPath: '/signup-website/'
      preLoaderRoute: typeof BasePublicSignupWebsiteIndexRouteImport
      parentRoute: typeof BasePublicSignupWebsiteRouteRoute
    }
    '/_base/_public/signup-website/preview': {
      id: '/_base/_public/signup-website/preview'
      path: '/preview'
      fullPath: '/signup-website/preview'
      preLoaderRoute: typeof BasePublicSignupWebsitePreviewRouteImport
      parentRoute: typeof BasePublicSignupWebsiteRouteRoute
    }
    '/_base/_auth/backoffice/campaigns/health': {
      id: '/_base/_auth/backoffice/campaigns/health'
      path: '/health'
      fullPath: '/backoffice/campaigns/health'
      preLoaderRoute: typeof BaseAuthBackofficeCampaignsHealthRouteRouteImport
      parentRoute: typeof BaseAuthBackofficeCampaignsRouteRoute
    }
    '/_base/_auth/backoffice/clusters/': {
      id: '/_base/_auth/backoffice/clusters/'
      path: '/'
      fullPath: '/backoffice/clusters/'
      preLoaderRoute: typeof BaseAuthBackofficeClustersIndexRouteImport
      parentRoute: typeof BaseAuthBackofficeClustersRouteRoute
    }
    '/_base/_auth/backoffice/companies/create': {
      id: '/_base/_auth/backoffice/companies/create'
      path: '/companies/create'
      fullPath: '/backoffice/companies/create'
      preLoaderRoute: typeof BaseAuthBackofficeCompaniesCreateRouteImport
      parentRoute: typeof BaseAuthBackofficeRouteRoute
    }
    '/_base/_auth/backoffice/conversationExperiments/list': {
      id: '/_base/_auth/backoffice/conversationExperiments/list'
      path: '/list'
      fullPath: '/backoffice/conversationExperiments/list'
      preLoaderRoute: typeof BaseAuthBackofficeConversationExperimentsListRouteRouteImport
      parentRoute: typeof BaseAuthBackofficeConversationExperimentsRouteRoute
    }
    '/_base/_auth/backoffice/flags/': {
      id: '/_base/_auth/backoffice/flags/'
      path: '/'
      fullPath: '/backoffice/flags/'
      preLoaderRoute: typeof BaseAuthBackofficeFlagsIndexRouteImport
      parentRoute: typeof BaseAuthBackofficeFlagsRouteRoute
    }
    '/_base/_auth/backoffice/organizations/': {
      id: '/_base/_auth/backoffice/organizations/'
      path: '/'
      fullPath: '/backoffice/organizations/'
      preLoaderRoute: typeof BaseAuthBackofficeOrganizationsIndexRouteImport
      parentRoute: typeof BaseAuthBackofficeOrganizationsRouteRoute
    }
    '/_base/_auth/backoffice/organizations/$id': {
      id: '/_base/_auth/backoffice/organizations/$id'
      path: '/$id'
      fullPath: '/backoffice/organizations/$id'
      preLoaderRoute: typeof BaseAuthBackofficeOrganizationsIdRouteRouteImport
      parentRoute: typeof BaseAuthBackofficeOrganizationsRouteRoute
    }
    '/_base/_auth/backoffice/organizations/list': {
      id: '/_base/_auth/backoffice/organizations/list'
      path: '/list'
      fullPath: '/backoffice/organizations/list'
      preLoaderRoute: typeof BaseAuthBackofficeOrganizationsListRouteImport
      parentRoute: typeof BaseAuthBackofficeOrganizationsRouteRoute
    }
    '/_base/_auth/backoffice/referrals/': {
      id: '/_base/_auth/backoffice/referrals/'
      path: '/'
      fullPath: '/backoffice/referrals/'
      preLoaderRoute: typeof BaseAuthBackofficeReferralsIndexRouteImport
      parentRoute: typeof BaseAuthBackofficeReferralsRouteRoute
    }
    '/_base/_auth/backoffice/referrals/list': {
      id: '/_base/_auth/backoffice/referrals/list'
      path: '/list'
      fullPath: '/backoffice/referrals/list'
      preLoaderRoute: typeof BaseAuthBackofficeReferralsListRouteImport
      parentRoute: typeof BaseAuthBackofficeReferralsRouteRoute
    }
    '/_base/_auth/backoffice/scheduledReports/': {
      id: '/_base/_auth/backoffice/scheduledReports/'
      path: '/'
      fullPath: '/backoffice/scheduledReports/'
      preLoaderRoute: typeof BaseAuthBackofficeScheduledReportsIndexRouteImport
      parentRoute: typeof BaseAuthBackofficeScheduledReportsRouteRoute
    }
    '/_base/_auth/backoffice/scheduledReports/$id': {
      id: '/_base/_auth/backoffice/scheduledReports/$id'
      path: '/$id'
      fullPath: '/backoffice/scheduledReports/$id'
      preLoaderRoute: typeof BaseAuthBackofficeScheduledReportsIdRouteImport
      parentRoute: typeof BaseAuthBackofficeScheduledReportsRouteRoute
    }
    '/_base/_auth/backoffice/scheduledReports/create': {
      id: '/_base/_auth/backoffice/scheduledReports/create'
      path: '/create'
      fullPath: '/backoffice/scheduledReports/create'
      preLoaderRoute: typeof BaseAuthBackofficeScheduledReportsCreateRouteImport
      parentRoute: typeof BaseAuthBackofficeScheduledReportsRouteRoute
    }
    '/_base/_auth/backoffice/scheduledReports/list': {
      id: '/_base/_auth/backoffice/scheduledReports/list'
      path: '/list'
      fullPath: '/backoffice/scheduledReports/list'
      preLoaderRoute: typeof BaseAuthBackofficeScheduledReportsListRouteRouteImport
      parentRoute: typeof BaseAuthBackofficeScheduledReportsRouteRoute
    }
    '/_base/_auth/backoffice/support/list': {
      id: '/_base/_auth/backoffice/support/list'
      path: '/list'
      fullPath: '/backoffice/support/list'
      preLoaderRoute: typeof BaseAuthBackofficeSupportListRouteRouteImport
      parentRoute: typeof BaseAuthBackofficeSupportRouteRoute
    }
    '/_base/_auth/campaigns/$id/': {
      id: '/_base/_auth/campaigns/$id/'
      path: '/'
      fullPath: '/campaigns/$id/'
      preLoaderRoute: typeof BaseAuthCampaignsIdIndexRouteImport
      parentRoute: typeof BaseAuthCampaignsIdRouteRoute
    }
    '/_base/_auth/campaigns/$id/activity': {
      id: '/_base/_auth/campaigns/$id/activity'
      path: '/activity'
      fullPath: '/campaigns/$id/activity'
      preLoaderRoute: typeof BaseAuthCampaignsIdActivityRouteRouteImport
      parentRoute: typeof BaseAuthCampaignsIdRouteRoute
    }
    '/_base/_auth/campaigns/$id/capabilities': {
      id: '/_base/_auth/campaigns/$id/capabilities'
      path: '/capabilities'
      fullPath: '/campaigns/$id/capabilities'
      preLoaderRoute: typeof BaseAuthCampaignsIdCapabilitiesRouteRouteImport
      parentRoute: typeof BaseAuthCampaignsIdRouteRoute
    }
    '/_base/_auth/campaigns/$id/configuration': {
      id: '/_base/_auth/campaigns/$id/configuration'
      path: '/configuration'
      fullPath: '/campaigns/$id/configuration'
      preLoaderRoute: typeof BaseAuthCampaignsIdConfigurationRouteRouteImport
      parentRoute: typeof BaseAuthCampaignsIdRouteRoute
    }
    '/_base/_auth/campaigns/$id/insights': {
      id: '/_base/_auth/campaigns/$id/insights'
      path: '/insights'
      fullPath: '/campaigns/$id/insights'
      preLoaderRoute: typeof BaseAuthCampaignsIdInsightsRouteRouteImport
      parentRoute: typeof BaseAuthCampaignsIdRouteRoute
    }
    '/_base/_auth/campaigns/$id/knowledge-base': {
      id: '/_base/_auth/campaigns/$id/knowledge-base'
      path: '/knowledge-base'
      fullPath: '/campaigns/$id/knowledge-base'
      preLoaderRoute: typeof BaseAuthCampaignsIdKnowledgeBaseRouteRouteImport
      parentRoute: typeof BaseAuthCampaignsIdRouteRoute
    }
    '/_base/_auth/campaigns/$id/workflows': {
      id: '/_base/_auth/campaigns/$id/workflows'
      path: '/workflows'
      fullPath: '/campaigns/$id/workflows'
      preLoaderRoute: typeof BaseAuthCampaignsIdWorkflowsRouteRouteImport
      parentRoute: typeof BaseAuthCampaignsIdRouteRoute
    }
    '/_base/_auth/campaigns/goals/': {
      id: '/_base/_auth/campaigns/goals/'
      path: '/'
      fullPath: '/campaigns/goals/'
      preLoaderRoute: typeof BaseAuthCampaignsGoalsIndexRouteImport
      parentRoute: typeof BaseAuthCampaignsGoalsRouteRoute
    }
    '/_base/_auth/campaigns/goals/list': {
      id: '/_base/_auth/campaigns/goals/list'
      path: '/list'
      fullPath: '/campaigns/goals/list'
      preLoaderRoute: typeof BaseAuthCampaignsGoalsListRouteRouteImport
      parentRoute: typeof BaseAuthCampaignsGoalsRouteRoute
    }
    '/_base/_auth/capabilities/list/create-custom': {
      id: '/_base/_auth/capabilities/list/create-custom'
      path: '/create-custom'
      fullPath: '/capabilities/list/create-custom'
      preLoaderRoute: typeof BaseAuthCapabilitiesListCreateCustomRouteImport
      parentRoute: typeof BaseAuthCapabilitiesListRouteRoute
    }
    '/_base/_auth/conversations/list/$customerId': {
      id: '/_base/_auth/conversations/list/$customerId'
      path: '/$customerId'
      fullPath: '/conversations/list/$customerId'
      preLoaderRoute: typeof BaseAuthConversationsListCustomerIdRouteRouteImport
      parentRoute: typeof BaseAuthConversationsListRouteRoute
    }
    '/_base/_auth/customers/list/$id': {
      id: '/_base/_auth/customers/list/$id'
      path: '/$id'
      fullPath: '/customers/list/$id'
      preLoaderRoute: typeof BaseAuthCustomersListIdRouteImport
      parentRoute: typeof BaseAuthCustomersListRouteRoute
    }
    '/_base/_auth/customers/list/create': {
      id: '/_base/_auth/customers/list/create'
      path: '/create'
      fullPath: '/customers/list/create'
      preLoaderRoute: typeof BaseAuthCustomersListCreateRouteImport
      parentRoute: typeof BaseAuthCustomersListRouteRoute
    }
    '/_base/_auth/customers/list/import': {
      id: '/_base/_auth/customers/list/import'
      path: '/import'
      fullPath: '/customers/list/import'
      preLoaderRoute: typeof BaseAuthCustomersListImportRouteImport
      parentRoute: typeof BaseAuthCustomersListRouteRoute
    }
    '/_base/_auth/customers/segments/': {
      id: '/_base/_auth/customers/segments/'
      path: '/'
      fullPath: '/customers/segments/'
      preLoaderRoute: typeof BaseAuthCustomersSegmentsIndexRouteImport
      parentRoute: typeof BaseAuthCustomersSegmentsRouteRoute
    }
    '/_base/_auth/customers/segments/$id': {
      id: '/_base/_auth/customers/segments/$id'
      path: '/$id'
      fullPath: '/customers/segments/$id'
      preLoaderRoute: typeof BaseAuthCustomersSegmentsIdRouteRouteImport
      parentRoute: typeof BaseAuthCustomersSegmentsRouteRoute
    }
    '/_base/_auth/customers/segments/list': {
      id: '/_base/_auth/customers/segments/list'
      path: '/list'
      fullPath: '/customers/segments/list'
      preLoaderRoute: typeof BaseAuthCustomersSegmentsListRouteRouteImport
      parentRoute: typeof BaseAuthCustomersSegmentsRouteRoute
    }
    '/_base/_auth/settings/channels/': {
      id: '/_base/_auth/settings/channels/'
      path: '/'
      fullPath: '/settings/channels/'
      preLoaderRoute: typeof BaseAuthSettingsChannelsIndexRouteImport
      parentRoute: typeof BaseAuthSettingsChannelsRouteRoute
    }
    '/_base/_auth/settings/channels/gmail': {
      id: '/_base/_auth/settings/channels/gmail'
      path: '/gmail'
      fullPath: '/settings/channels/gmail'
      preLoaderRoute: typeof BaseAuthSettingsChannelsGmailRouteRouteImport
      parentRoute: typeof BaseAuthSettingsChannelsRouteRoute
    }
    '/_base/_auth/settings/channels/instagram': {
      id: '/_base/_auth/settings/channels/instagram'
      path: '/instagram'
      fullPath: '/settings/channels/instagram'
      preLoaderRoute: typeof BaseAuthSettingsChannelsInstagramRouteRouteImport
      parentRoute: typeof BaseAuthSettingsChannelsRouteRoute
    }
    '/_base/_auth/settings/channels/outlook': {
      id: '/_base/_auth/settings/channels/outlook'
      path: '/outlook'
      fullPath: '/settings/channels/outlook'
      preLoaderRoute: typeof BaseAuthSettingsChannelsOutlookRouteRouteImport
      parentRoute: typeof BaseAuthSettingsChannelsRouteRoute
    }
    '/_base/_auth/settings/channels/qr': {
      id: '/_base/_auth/settings/channels/qr'
      path: '/qr'
      fullPath: '/settings/channels/qr'
      preLoaderRoute: typeof BaseAuthSettingsChannelsQrRouteRouteImport
      parentRoute: typeof BaseAuthSettingsChannelsRouteRoute
    }
    '/_base/_auth/settings/channels/whatsapp': {
      id: '/_base/_auth/settings/channels/whatsapp'
      path: '/whatsapp'
      fullPath: '/settings/channels/whatsapp'
      preLoaderRoute: typeof BaseAuthSettingsChannelsWhatsappRouteRouteImport
      parentRoute: typeof BaseAuthSettingsChannelsRouteRoute
    }
    '/_base/_auth/settings/channels/widget': {
      id: '/_base/_auth/settings/channels/widget'
      path: '/widget'
      fullPath: '/settings/channels/widget'
      preLoaderRoute: typeof BaseAuthSettingsChannelsWidgetRouteRouteImport
      parentRoute: typeof BaseAuthSettingsChannelsRouteRoute
    }
    '/_base/_auth/settings/integrations/': {
      id: '/_base/_auth/settings/integrations/'
      path: '/'
      fullPath: '/settings/integrations/'
      preLoaderRoute: typeof BaseAuthSettingsIntegrationsIndexRouteImport
      parentRoute: typeof BaseAuthSettingsIntegrationsRouteRoute
    }
    '/_base/_auth/settings/integrations/amphora': {
      id: '/_base/_auth/settings/integrations/amphora'
      path: '/amphora'
      fullPath: '/settings/integrations/amphora'
      preLoaderRoute: typeof BaseAuthSettingsIntegrationsAmphoraRouteRouteImport
      parentRoute: typeof BaseAuthSettingsIntegrationsRouteRoute
    }
    '/_base/_auth/settings/integrations/bigblue': {
      id: '/_base/_auth/settings/integrations/bigblue'
      path: '/bigblue'
      fullPath: '/settings/integrations/bigblue'
      preLoaderRoute: typeof BaseAuthSettingsIntegrationsBigblueRouteRouteImport
      parentRoute: typeof BaseAuthSettingsIntegrationsRouteRoute
    }
    '/_base/_auth/settings/integrations/frontapp': {
      id: '/_base/_auth/settings/integrations/frontapp'
      path: '/frontapp'
      fullPath: '/settings/integrations/frontapp'
      preLoaderRoute: typeof BaseAuthSettingsIntegrationsFrontappRouteRouteImport
      parentRoute: typeof BaseAuthSettingsIntegrationsRouteRoute
    }
    '/_base/_auth/settings/integrations/gorgias': {
      id: '/_base/_auth/settings/integrations/gorgias'
      path: '/gorgias'
      fullPath: '/settings/integrations/gorgias'
      preLoaderRoute: typeof BaseAuthSettingsIntegrationsGorgiasRouteRouteImport
      parentRoute: typeof BaseAuthSettingsIntegrationsRouteRoute
    }
    '/_base/_auth/settings/integrations/klaviyo': {
      id: '/_base/_auth/settings/integrations/klaviyo'
      path: '/klaviyo'
      fullPath: '/settings/integrations/klaviyo'
      preLoaderRoute: typeof BaseAuthSettingsIntegrationsKlaviyoRouteRouteImport
      parentRoute: typeof BaseAuthSettingsIntegrationsRouteRoute
    }
    '/_base/_auth/settings/integrations/loopReturns': {
      id: '/_base/_auth/settings/integrations/loopReturns'
      path: '/loopReturns'
      fullPath: '/settings/integrations/loopReturns'
      preLoaderRoute: typeof BaseAuthSettingsIntegrationsLoopReturnsRouteRouteImport
      parentRoute: typeof BaseAuthSettingsIntegrationsRouteRoute
    }
    '/_base/_auth/settings/integrations/reveni': {
      id: '/_base/_auth/settings/integrations/reveni'
      path: '/reveni'
      fullPath: '/settings/integrations/reveni'
      preLoaderRoute: typeof BaseAuthSettingsIntegrationsReveniRouteRouteImport
      parentRoute: typeof BaseAuthSettingsIntegrationsRouteRoute
    }
    '/_base/_auth/settings/integrations/rever': {
      id: '/_base/_auth/settings/integrations/rever'
      path: '/rever'
      fullPath: '/settings/integrations/rever'
      preLoaderRoute: typeof BaseAuthSettingsIntegrationsReverRouteRouteImport
      parentRoute: typeof BaseAuthSettingsIntegrationsRouteRoute
    }
    '/_base/_auth/settings/integrations/salesForce': {
      id: '/_base/_auth/settings/integrations/salesForce'
      path: '/salesForce'
      fullPath: '/settings/integrations/salesForce'
      preLoaderRoute: typeof BaseAuthSettingsIntegrationsSalesForceRouteRouteImport
      parentRoute: typeof BaseAuthSettingsIntegrationsRouteRoute
    }
    '/_base/_auth/settings/integrations/shopify': {
      id: '/_base/_auth/settings/integrations/shopify'
      path: '/shopify'
      fullPath: '/settings/integrations/shopify'
      preLoaderRoute: typeof BaseAuthSettingsIntegrationsShopifyRouteRouteImport
      parentRoute: typeof BaseAuthSettingsIntegrationsRouteRoute
    }
    '/_base/_auth/settings/integrations/zendesk': {
      id: '/_base/_auth/settings/integrations/zendesk'
      path: '/zendesk'
      fullPath: '/settings/integrations/zendesk'
      preLoaderRoute: typeof BaseAuthSettingsIntegrationsZendeskRouteRouteImport
      parentRoute: typeof BaseAuthSettingsIntegrationsRouteRoute
    }
    '/_base/_auth/settings/subscription/': {
      id: '/_base/_auth/settings/subscription/'
      path: '/'
      fullPath: '/settings/subscription/'
      preLoaderRoute: typeof BaseAuthSettingsSubscriptionIndexRouteImport
      parentRoute: typeof BaseAuthSettingsSubscriptionRouteRoute
    }
    '/_base/_auth/settings/subscription/plans': {
      id: '/_base/_auth/settings/subscription/plans'
      path: '/plans'
      fullPath: '/settings/subscription/plans'
      preLoaderRoute: typeof BaseAuthSettingsSubscriptionPlansRouteRouteImport
      parentRoute: typeof BaseAuthSettingsSubscriptionRouteRoute
    }
    '/_base/_auth/settings/subscription/referrals': {
      id: '/_base/_auth/settings/subscription/referrals'
      path: '/referrals'
      fullPath: '/settings/subscription/referrals'
      preLoaderRoute: typeof BaseAuthSettingsSubscriptionReferralsRouteRouteImport
      parentRoute: typeof BaseAuthSettingsSubscriptionRouteRoute
    }
    '/_base/_auth/settings/subscription/usage': {
      id: '/_base/_auth/settings/subscription/usage'
      path: '/usage'
      fullPath: '/settings/subscription/usage'
      preLoaderRoute: typeof BaseAuthSettingsSubscriptionUsageRouteRouteImport
      parentRoute: typeof BaseAuthSettingsSubscriptionRouteRoute
    }
    '/_base/_auth/settings/team/': {
      id: '/_base/_auth/settings/team/'
      path: '/'
      fullPath: '/settings/team/'
      preLoaderRoute: typeof BaseAuthSettingsTeamIndexRouteImport
      parentRoute: typeof BaseAuthSettingsTeamRouteRoute
    }
    '/_base/_auth/settings/team/invite': {
      id: '/_base/_auth/settings/team/invite'
      path: '/invite'
      fullPath: '/settings/team/invite'
      preLoaderRoute: typeof BaseAuthSettingsTeamInviteRouteImport
      parentRoute: typeof BaseAuthSettingsTeamRouteRoute
    }
    '/_base/_auth/settings/workflows/': {
      id: '/_base/_auth/settings/workflows/'
      path: '/'
      fullPath: '/settings/workflows/'
      preLoaderRoute: typeof BaseAuthSettingsWorkflowsIndexRouteImport
      parentRoute: typeof BaseAuthSettingsWorkflowsRouteRoute
    }
    '/_base/_auth/support/list/$customerId': {
      id: '/_base/_auth/support/list/$customerId'
      path: '/$customerId'
      fullPath: '/support/list/$customerId'
      preLoaderRoute: typeof BaseAuthSupportListCustomerIdRouteRouteImport
      parentRoute: typeof BaseAuthSupportListRouteRoute
    }
    '/_base/_auth/backoffice/conversationExperiments/list/prompt-experiment': {
      id: '/_base/_auth/backoffice/conversationExperiments/list/prompt-experiment'
      path: '/prompt-experiment'
      fullPath: '/backoffice/conversationExperiments/list/prompt-experiment'
      preLoaderRoute: typeof BaseAuthBackofficeConversationExperimentsListPromptExperimentRouteImport
      parentRoute: typeof BaseAuthBackofficeConversationExperimentsListRouteRoute
    }
    '/_base/_auth/backoffice/knowledge/topics/$topicId': {
      id: '/_base/_auth/backoffice/knowledge/topics/$topicId'
      path: '/topics/$topicId'
      fullPath: '/backoffice/knowledge/topics/$topicId'
      preLoaderRoute: typeof BaseAuthBackofficeKnowledgeTopicsTopicIdRouteImport
      parentRoute: typeof BaseAuthBackofficeKnowledgeRouteRoute
    }
    '/_base/_auth/backoffice/organizations/$id/': {
      id: '/_base/_auth/backoffice/organizations/$id/'
      path: '/'
      fullPath: '/backoffice/organizations/$id/'
      preLoaderRoute: typeof BaseAuthBackofficeOrganizationsIdIndexRouteImport
      parentRoute: typeof BaseAuthBackofficeOrganizationsIdRouteRoute
    }
    '/_base/_auth/backoffice/organizations/$id/companies': {
      id: '/_base/_auth/backoffice/organizations/$id/companies'
      path: '/companies'
      fullPath: '/backoffice/organizations/$id/companies'
      preLoaderRoute: typeof BaseAuthBackofficeOrganizationsIdCompaniesRouteRouteImport
      parentRoute: typeof BaseAuthBackofficeOrganizationsIdRouteRoute
    }
    '/_base/_auth/backoffice/organizations/$id/credits': {
      id: '/_base/_auth/backoffice/organizations/$id/credits'
      path: '/credits'
      fullPath: '/backoffice/organizations/$id/credits'
      preLoaderRoute: typeof BaseAuthBackofficeOrganizationsIdCreditsRouteRouteImport
      parentRoute: typeof BaseAuthBackofficeOrganizationsIdRouteRoute
    }
    '/_base/_auth/backoffice/organizations/list/create': {
      id: '/_base/_auth/backoffice/organizations/list/create'
      path: '/create'
      fullPath: '/backoffice/organizations/list/create'
      preLoaderRoute: typeof BaseAuthBackofficeOrganizationsListCreateRouteImport
      parentRoute: typeof BaseAuthBackofficeOrganizationsListRoute
    }
    '/_base/_auth/backoffice/organizations/list/create-from-website': {
      id: '/_base/_auth/backoffice/organizations/list/create-from-website'
      path: '/create-from-website'
      fullPath: '/backoffice/organizations/list/create-from-website'
      preLoaderRoute: typeof BaseAuthBackofficeOrganizationsListCreateFromWebsiteRouteImport
      parentRoute: typeof BaseAuthBackofficeOrganizationsListRoute
    }
    '/_base/_auth/campaigns/$id/activity/$customerId': {
      id: '/_base/_auth/campaigns/$id/activity/$customerId'
      path: '/$customerId'
      fullPath: '/campaigns/$id/activity/$customerId'
      preLoaderRoute: typeof BaseAuthCampaignsIdActivityCustomerIdRouteImport
      parentRoute: typeof BaseAuthCampaignsIdActivityRouteRoute
    }
    '/_base/_auth/campaigns/$id/insights/launch': {
      id: '/_base/_auth/campaigns/$id/insights/launch'
      path: '/launch'
      fullPath: '/campaigns/$id/insights/launch'
      preLoaderRoute: typeof BaseAuthCampaignsIdInsightsLaunchRouteImport
      parentRoute: typeof BaseAuthCampaignsIdInsightsRouteRoute
    }
    '/_base/_auth/campaigns/goals/list/create': {
      id: '/_base/_auth/campaigns/goals/list/create'
      path: '/create'
      fullPath: '/campaigns/goals/list/create'
      preLoaderRoute: typeof BaseAuthCampaignsGoalsListCreateRouteImport
      parentRoute: typeof BaseAuthCampaignsGoalsListRouteRoute
    }
    '/_base/_auth/knowledge/suggestions/$gapId/dismiss': {
      id: '/_base/_auth/knowledge/suggestions/$gapId/dismiss'
      path: '/$gapId/dismiss'
      fullPath: '/knowledge/suggestions/$gapId/dismiss'
      preLoaderRoute: typeof BaseAuthKnowledgeSuggestionsGapIdDismissRouteImport
      parentRoute: typeof BaseAuthKnowledgeSuggestionsRoute
    }
    '/_base/_auth/knowledge/suggestions/$gapId/evidence': {
      id: '/_base/_auth/knowledge/suggestions/$gapId/evidence'
      path: '/$gapId/evidence'
      fullPath: '/knowledge/suggestions/$gapId/evidence'
      preLoaderRoute: typeof BaseAuthKnowledgeSuggestionsGapIdEvidenceRouteImport
      parentRoute: typeof BaseAuthKnowledgeSuggestionsRoute
    }
    '/_base/_auth/settings/channels/gmail/new': {
      id: '/_base/_auth/settings/channels/gmail/new'
      path: '/new'
      fullPath: '/settings/channels/gmail/new'
      preLoaderRoute: typeof BaseAuthSettingsChannelsGmailNewRouteImport
      parentRoute: typeof BaseAuthSettingsChannelsGmailRouteRoute
    }
    '/_base/_auth/settings/channels/instagram/new': {
      id: '/_base/_auth/settings/channels/instagram/new'
      path: '/new'
      fullPath: '/settings/channels/instagram/new'
      preLoaderRoute: typeof BaseAuthSettingsChannelsInstagramNewRouteImport
      parentRoute: typeof BaseAuthSettingsChannelsInstagramRouteRoute
    }
    '/_base/_auth/settings/channels/outlook/new': {
      id: '/_base/_auth/settings/channels/outlook/new'
      path: '/new'
      fullPath: '/settings/channels/outlook/new'
      preLoaderRoute: typeof BaseAuthSettingsChannelsOutlookNewRouteImport
      parentRoute: typeof BaseAuthSettingsChannelsOutlookRouteRoute
    }
    '/_base/_auth/settings/channels/qr/$id': {
      id: '/_base/_auth/settings/channels/qr/$id'
      path: '/$id'
      fullPath: '/settings/channels/qr/$id'
      preLoaderRoute: typeof BaseAuthSettingsChannelsQrIdRouteImport
      parentRoute: typeof BaseAuthSettingsChannelsQrRouteRoute
    }
    '/_base/_auth/settings/channels/qr/create': {
      id: '/_base/_auth/settings/channels/qr/create'
      path: '/create'
      fullPath: '/settings/channels/qr/create'
      preLoaderRoute: typeof BaseAuthSettingsChannelsQrCreateRouteImport
      parentRoute: typeof BaseAuthSettingsChannelsQrRouteRoute
    }
    '/_base/_auth/settings/channels/whatsapp/': {
      id: '/_base/_auth/settings/channels/whatsapp/'
      path: '/'
      fullPath: '/settings/channels/whatsapp/'
      preLoaderRoute: typeof BaseAuthSettingsChannelsWhatsappIndexRouteImport
      parentRoute: typeof BaseAuthSettingsChannelsWhatsappRouteRoute
    }
    '/_base/_auth/settings/channels/whatsapp/alerts': {
      id: '/_base/_auth/settings/channels/whatsapp/alerts'
      path: '/alerts'
      fullPath: '/settings/channels/whatsapp/alerts'
      preLoaderRoute: typeof BaseAuthSettingsChannelsWhatsappAlertsRouteImport
      parentRoute: typeof BaseAuthSettingsChannelsWhatsappRouteRoute
    }
    '/_base/_auth/settings/channels/whatsapp/openings': {
      id: '/_base/_auth/settings/channels/whatsapp/openings'
      path: '/openings'
      fullPath: '/settings/channels/whatsapp/openings'
      preLoaderRoute: typeof BaseAuthSettingsChannelsWhatsappOpeningsRouteRouteImport
      parentRoute: typeof BaseAuthSettingsChannelsWhatsappRouteRoute
    }
    '/_base/_auth/settings/channels/whatsapp/templates': {
      id: '/_base/_auth/settings/channels/whatsapp/templates'
      path: '/templates'
      fullPath: '/settings/channels/whatsapp/templates'
      preLoaderRoute: typeof BaseAuthSettingsChannelsWhatsappTemplatesRouteRouteImport
      parentRoute: typeof BaseAuthSettingsChannelsWhatsappRouteRoute
    }
    '/_base/_auth/settings/channels/widget/': {
      id: '/_base/_auth/settings/channels/widget/'
      path: '/'
      fullPath: '/settings/channels/widget/'
      preLoaderRoute: typeof BaseAuthSettingsChannelsWidgetIndexRouteImport
      parentRoute: typeof BaseAuthSettingsChannelsWidgetRouteRoute
    }
    '/_base/_auth/settings/channels/widget/phone-mockup': {
      id: '/_base/_auth/settings/channels/widget/phone-mockup'
      path: '/phone-mockup'
      fullPath: '/settings/channels/widget/phone-mockup'
      preLoaderRoute: typeof BaseAuthSettingsChannelsWidgetPhoneMockupRouteImport
      parentRoute: typeof BaseAuthSettingsChannelsWidgetRouteRoute
    }
    '/_base/_auth/settings/integrations/amphora/connect': {
      id: '/_base/_auth/settings/integrations/amphora/connect'
      path: '/connect'
      fullPath: '/settings/integrations/amphora/connect'
      preLoaderRoute: typeof BaseAuthSettingsIntegrationsAmphoraConnectRouteImport
      parentRoute: typeof BaseAuthSettingsIntegrationsAmphoraRouteRoute
    }
    '/_base/_auth/settings/integrations/bigblue/connect': {
      id: '/_base/_auth/settings/integrations/bigblue/connect'
      path: '/connect'
      fullPath: '/settings/integrations/bigblue/connect'
      preLoaderRoute: typeof BaseAuthSettingsIntegrationsBigblueConnectRouteImport
      parentRoute: typeof BaseAuthSettingsIntegrationsBigblueRouteRoute
    }
    '/_base/_auth/settings/integrations/frontapp/connect': {
      id: '/_base/_auth/settings/integrations/frontapp/connect'
      path: '/connect'
      fullPath: '/settings/integrations/frontapp/connect'
      preLoaderRoute: typeof BaseAuthSettingsIntegrationsFrontappConnectRouteImport
      parentRoute: typeof BaseAuthSettingsIntegrationsFrontappRouteRoute
    }
    '/_base/_auth/settings/integrations/gorgias/connect': {
      id: '/_base/_auth/settings/integrations/gorgias/connect'
      path: '/connect'
      fullPath: '/settings/integrations/gorgias/connect'
      preLoaderRoute: typeof BaseAuthSettingsIntegrationsGorgiasConnectRouteImport
      parentRoute: typeof BaseAuthSettingsIntegrationsGorgiasRouteRoute
    }
    '/_base/_auth/settings/integrations/klaviyo/connect': {
      id: '/_base/_auth/settings/integrations/klaviyo/connect'
      path: '/connect'
      fullPath: '/settings/integrations/klaviyo/connect'
      preLoaderRoute: typeof BaseAuthSettingsIntegrationsKlaviyoConnectRouteImport
      parentRoute: typeof BaseAuthSettingsIntegrationsKlaviyoRouteRoute
    }
    '/_base/_auth/settings/integrations/loopReturns/connect': {
      id: '/_base/_auth/settings/integrations/loopReturns/connect'
      path: '/connect'
      fullPath: '/settings/integrations/loopReturns/connect'
      preLoaderRoute: typeof BaseAuthSettingsIntegrationsLoopReturnsConnectRouteImport
      parentRoute: typeof BaseAuthSettingsIntegrationsLoopReturnsRouteRoute
    }
    '/_base/_auth/settings/integrations/reveni/connect': {
      id: '/_base/_auth/settings/integrations/reveni/connect'
      path: '/connect'
      fullPath: '/settings/integrations/reveni/connect'
      preLoaderRoute: typeof BaseAuthSettingsIntegrationsReveniConnectRouteImport
      parentRoute: typeof BaseAuthSettingsIntegrationsReveniRouteRoute
    }
    '/_base/_auth/settings/integrations/rever/connect': {
      id: '/_base/_auth/settings/integrations/rever/connect'
      path: '/connect'
      fullPath: '/settings/integrations/rever/connect'
      preLoaderRoute: typeof BaseAuthSettingsIntegrationsReverConnectRouteImport
      parentRoute: typeof BaseAuthSettingsIntegrationsReverRouteRoute
    }
    '/_base/_auth/settings/integrations/salesForce/connect': {
      id: '/_base/_auth/settings/integrations/salesForce/connect'
      path: '/connect'
      fullPath: '/settings/integrations/salesForce/connect'
      preLoaderRoute: typeof BaseAuthSettingsIntegrationsSalesForceConnectRouteImport
      parentRoute: typeof BaseAuthSettingsIntegrationsSalesForceRouteRoute
    }
    '/_base/_auth/settings/integrations/shopify/SizeChart': {
      id: '/_base/_auth/settings/integrations/shopify/SizeChart'
      path: '/SizeChart'
      fullPath: '/settings/integrations/shopify/SizeChart'
      preLoaderRoute: typeof BaseAuthSettingsIntegrationsShopifySizeChartRouteImport
      parentRoute: typeof BaseAuthSettingsIntegrationsShopifyRouteRoute
    }
    '/_base/_auth/settings/integrations/shopify/connect': {
      id: '/_base/_auth/settings/integrations/shopify/connect'
      path: '/connect'
      fullPath: '/settings/integrations/shopify/connect'
      preLoaderRoute: typeof BaseAuthSettingsIntegrationsShopifyConnectRouteImport
      parentRoute: typeof BaseAuthSettingsIntegrationsShopifyRouteRoute
    }
    '/_base/_auth/settings/integrations/zendesk/connect': {
      id: '/_base/_auth/settings/integrations/zendesk/connect'
      path: '/connect'
      fullPath: '/settings/integrations/zendesk/connect'
      preLoaderRoute: typeof BaseAuthSettingsIntegrationsZendeskConnectRouteImport
      parentRoute: typeof BaseAuthSettingsIntegrationsZendeskRouteRoute
    }
    '/_base/_auth/settings/keys-and-secrets/api-tokens/create': {
      id: '/_base/_auth/settings/keys-and-secrets/api-tokens/create'
      path: '/api-tokens/create'
      fullPath: '/settings/keys-and-secrets/api-tokens/create'
      preLoaderRoute: typeof BaseAuthSettingsKeysAndSecretsApiTokensCreateRouteImport
      parentRoute: typeof BaseAuthSettingsKeysAndSecretsRouteRoute
    }
    '/_base/_auth/settings/keys-and-secrets/vault/create': {
      id: '/_base/_auth/settings/keys-and-secrets/vault/create'
      path: '/vault/create'
      fullPath: '/settings/keys-and-secrets/vault/create'
      preLoaderRoute: typeof BaseAuthSettingsKeysAndSecretsVaultCreateRouteImport
      parentRoute: typeof BaseAuthSettingsKeysAndSecretsRouteRoute
    }
    '/_base/_auth/settings/subscription/usage/configure-topups': {
      id: '/_base/_auth/settings/subscription/usage/configure-topups'
      path: '/configure-topups'
      fullPath: '/settings/subscription/usage/configure-topups'
      preLoaderRoute: typeof BaseAuthSettingsSubscriptionUsageConfigureTopupsRouteImport
      parentRoute: typeof BaseAuthSettingsSubscriptionUsageRouteRoute
    }
    '/_base/_auth/settings/team/$employeeId/access': {
      id: '/_base/_auth/settings/team/$employeeId/access'
      path: '/$employeeId/access'
      fullPath: '/settings/team/$employeeId/access'
      preLoaderRoute: typeof BaseAuthSettingsTeamEmployeeIdAccessRouteImport
      parentRoute: typeof BaseAuthSettingsTeamRouteRoute
    }
    '/_base/_auth/backoffice/organizations/$id/companies/$companyId': {
      id: '/_base/_auth/backoffice/organizations/$id/companies/$companyId'
      path: '/$companyId'
      fullPath: '/backoffice/organizations/$id/companies/$companyId'
      preLoaderRoute: typeof BaseAuthBackofficeOrganizationsIdCompaniesCompanyIdRouteRouteImport
      parentRoute: typeof BaseAuthBackofficeOrganizationsIdCompaniesRouteRoute
    }
    '/_base/_auth/backoffice/organizations/$id/credits/list': {
      id: '/_base/_auth/backoffice/organizations/$id/credits/list'
      path: '/list'
      fullPath: '/backoffice/organizations/$id/credits/list'
      preLoaderRoute: typeof BaseAuthBackofficeOrganizationsIdCreditsListRouteImport
      parentRoute: typeof BaseAuthBackofficeOrganizationsIdCreditsRouteRoute
    }
    '/_base/_auth/campaigns/goals/list/edit/$id': {
      id: '/_base/_auth/campaigns/goals/list/edit/$id'
      path: '/edit/$id'
      fullPath: '/campaigns/goals/list/edit/$id'
      preLoaderRoute: typeof BaseAuthCampaignsGoalsListEditIdRouteImport
      parentRoute: typeof BaseAuthCampaignsGoalsListRouteRoute
    }
    '/_base/_auth/settings/channels/gmail/deleteIntegration/$id': {
      id: '/_base/_auth/settings/channels/gmail/deleteIntegration/$id'
      path: '/deleteIntegration/$id'
      fullPath: '/settings/channels/gmail/deleteIntegration/$id'
      preLoaderRoute: typeof BaseAuthSettingsChannelsGmailDeleteIntegrationIdRouteImport
      parentRoute: typeof BaseAuthSettingsChannelsGmailRouteRoute
    }
    '/_base/_auth/settings/channels/outlook/deleteIntegration/$id': {
      id: '/_base/_auth/settings/channels/outlook/deleteIntegration/$id'
      path: '/deleteIntegration/$id'
      fullPath: '/settings/channels/outlook/deleteIntegration/$id'
      preLoaderRoute: typeof BaseAuthSettingsChannelsOutlookDeleteIntegrationIdRouteImport
      parentRoute: typeof BaseAuthSettingsChannelsOutlookRouteRoute
    }
    '/_base/_auth/settings/channels/whatsapp/openings/': {
      id: '/_base/_auth/settings/channels/whatsapp/openings/'
      path: '/'
      fullPath: '/settings/channels/whatsapp/openings/'
      preLoaderRoute: typeof BaseAuthSettingsChannelsWhatsappOpeningsIndexRouteImport
      parentRoute: typeof BaseAuthSettingsChannelsWhatsappOpeningsRouteRoute
    }
    '/_base/_auth/settings/channels/whatsapp/openings/$id': {
      id: '/_base/_auth/settings/channels/whatsapp/openings/$id'
      path: '/$id'
      fullPath: '/settings/channels/whatsapp/openings/$id'
      preLoaderRoute: typeof BaseAuthSettingsChannelsWhatsappOpeningsIdRouteImport
      parentRoute: typeof BaseAuthSettingsChannelsWhatsappOpeningsRouteRoute
    }
    '/_base/_auth/settings/channels/whatsapp/openings/create': {
      id: '/_base/_auth/settings/channels/whatsapp/openings/create'
      path: '/create'
      fullPath: '/settings/channels/whatsapp/openings/create'
      preLoaderRoute: typeof BaseAuthSettingsChannelsWhatsappOpeningsCreateRouteImport
      parentRoute: typeof BaseAuthSettingsChannelsWhatsappOpeningsRouteRoute
    }
    '/_base/_auth/settings/channels/whatsapp/templates/': {
      id: '/_base/_auth/settings/channels/whatsapp/templates/'
      path: '/'
      fullPath: '/settings/channels/whatsapp/templates/'
      preLoaderRoute: typeof BaseAuthSettingsChannelsWhatsappTemplatesIndexRouteImport
      parentRoute: typeof BaseAuthSettingsChannelsWhatsappTemplatesRouteRoute
    }
    '/_base/_auth/settings/channels/whatsapp/templates/$id': {
      id: '/_base/_auth/settings/channels/whatsapp/templates/$id'
      path: '/$id'
      fullPath: '/settings/channels/whatsapp/templates/$id'
      preLoaderRoute: typeof BaseAuthSettingsChannelsWhatsappTemplatesIdRouteImport
      parentRoute: typeof BaseAuthSettingsChannelsWhatsappTemplatesRouteRoute
    }
    '/_base/_auth/settings/channels/whatsapp/templates/create': {
      id: '/_base/_auth/settings/channels/whatsapp/templates/create'
      path: '/create'
      fullPath: '/settings/channels/whatsapp/templates/create'
      preLoaderRoute: typeof BaseAuthSettingsChannelsWhatsappTemplatesCreateRouteImport
      parentRoute: typeof BaseAuthSettingsChannelsWhatsappTemplatesRouteRoute
    }
    '/_base/_auth/settings/keys-and-secrets/vault/$key/replace': {
      id: '/_base/_auth/settings/keys-and-secrets/vault/$key/replace'
      path: '/vault/$key/replace'
      fullPath: '/settings/keys-and-secrets/vault/$key/replace'
      preLoaderRoute: typeof BaseAuthSettingsKeysAndSecretsVaultKeyReplaceRouteImport
      parentRoute: typeof BaseAuthSettingsKeysAndSecretsRouteRoute
    }
    '/_base/_auth/backoffice/organizations/$id/companies/$companyId/': {
      id: '/_base/_auth/backoffice/organizations/$id/companies/$companyId/'
      path: '/'
      fullPath: '/backoffice/organizations/$id/companies/$companyId/'
      preLoaderRoute: typeof BaseAuthBackofficeOrganizationsIdCompaniesCompanyIdIndexRouteImport
      parentRoute: typeof BaseAuthBackofficeOrganizationsIdCompaniesCompanyIdRouteRoute
    }
    '/_base/_auth/backoffice/organizations/$id/companies/$companyId/canonical-topics': {
      id: '/_base/_auth/backoffice/organizations/$id/companies/$companyId/canonical-topics'
      path: '/canonical-topics'
      fullPath: '/backoffice/organizations/$id/companies/$companyId/canonical-topics'
      preLoaderRoute: typeof BaseAuthBackofficeOrganizationsIdCompaniesCompanyIdCanonicalTopicsRouteRouteImport
      parentRoute: typeof BaseAuthBackofficeOrganizationsIdCompaniesCompanyIdRouteRoute
    }
    '/_base/_auth/backoffice/organizations/$id/companies/$companyId/customers': {
      id: '/_base/_auth/backoffice/organizations/$id/companies/$companyId/customers'
      path: '/customers'
      fullPath: '/backoffice/organizations/$id/companies/$companyId/customers'
      preLoaderRoute: typeof BaseAuthBackofficeOrganizationsIdCompaniesCompanyIdCustomersRouteRouteImport
      parentRoute: typeof BaseAuthBackofficeOrganizationsIdCompaniesCompanyIdRouteRoute
    }
    '/_base/_auth/backoffice/organizations/$id/companies/$companyId/canonical-topics/list': {
      id: '/_base/_auth/backoffice/organizations/$id/companies/$companyId/canonical-topics/list'
      path: '/list'
      fullPath: '/backoffice/organizations/$id/companies/$companyId/canonical-topics/list'
      preLoaderRoute: typeof BaseAuthBackofficeOrganizationsIdCompaniesCompanyIdCanonicalTopicsListRouteImport
      parentRoute: typeof BaseAuthBackofficeOrganizationsIdCompaniesCompanyIdCanonicalTopicsRouteRoute
    }
    '/_base/_auth/backoffice/organizations/$id/companies/$companyId/customers/list': {
      id: '/_base/_auth/backoffice/organizations/$id/companies/$companyId/customers/list'
      path: '/list'
      fullPath: '/backoffice/organizations/$id/companies/$companyId/customers/list'
      preLoaderRoute: typeof BaseAuthBackofficeOrganizationsIdCompaniesCompanyIdCustomersListRouteImport
      parentRoute: typeof BaseAuthBackofficeOrganizationsIdCompaniesCompanyIdCustomersRouteRoute
    }
  }
}

interface BaseAuthBackofficeCampaignsRouteRouteChildren {
  BaseAuthBackofficeCampaignsHealthRouteRoute: typeof BaseAuthBackofficeCampaignsHealthRouteRoute
}

const BaseAuthBackofficeCampaignsRouteRouteChildren: BaseAuthBackofficeCampaignsRouteRouteChildren =
  {
    BaseAuthBackofficeCampaignsHealthRouteRoute:
      BaseAuthBackofficeCampaignsHealthRouteRoute,
  }

const BaseAuthBackofficeCampaignsRouteRouteWithChildren =
  BaseAuthBackofficeCampaignsRouteRoute._addFileChildren(
    BaseAuthBackofficeCampaignsRouteRouteChildren,
  )

interface BaseAuthBackofficeClustersRouteRouteChildren {
  BaseAuthBackofficeClustersIndexRoute: typeof BaseAuthBackofficeClustersIndexRoute
}

const BaseAuthBackofficeClustersRouteRouteChildren: BaseAuthBackofficeClustersRouteRouteChildren =
  {
    BaseAuthBackofficeClustersIndexRoute: BaseAuthBackofficeClustersIndexRoute,
  }

const BaseAuthBackofficeClustersRouteRouteWithChildren =
  BaseAuthBackofficeClustersRouteRoute._addFileChildren(
    BaseAuthBackofficeClustersRouteRouteChildren,
  )

interface BaseAuthBackofficeConversationExperimentsListRouteRouteChildren {
  BaseAuthBackofficeConversationExperimentsListPromptExperimentRoute: typeof BaseAuthBackofficeConversationExperimentsListPromptExperimentRoute
}

const BaseAuthBackofficeConversationExperimentsListRouteRouteChildren: BaseAuthBackofficeConversationExperimentsListRouteRouteChildren =
  {
    BaseAuthBackofficeConversationExperimentsListPromptExperimentRoute:
      BaseAuthBackofficeConversationExperimentsListPromptExperimentRoute,
  }

const BaseAuthBackofficeConversationExperimentsListRouteRouteWithChildren =
  BaseAuthBackofficeConversationExperimentsListRouteRoute._addFileChildren(
    BaseAuthBackofficeConversationExperimentsListRouteRouteChildren,
  )

interface BaseAuthBackofficeConversationExperimentsRouteRouteChildren {
  BaseAuthBackofficeConversationExperimentsListRouteRoute: typeof BaseAuthBackofficeConversationExperimentsListRouteRouteWithChildren
}

const BaseAuthBackofficeConversationExperimentsRouteRouteChildren: BaseAuthBackofficeConversationExperimentsRouteRouteChildren =
  {
    BaseAuthBackofficeConversationExperimentsListRouteRoute:
      BaseAuthBackofficeConversationExperimentsListRouteRouteWithChildren,
  }

const BaseAuthBackofficeConversationExperimentsRouteRouteWithChildren =
  BaseAuthBackofficeConversationExperimentsRouteRoute._addFileChildren(
    BaseAuthBackofficeConversationExperimentsRouteRouteChildren,
  )

interface BaseAuthBackofficeFlagsRouteRouteChildren {
  BaseAuthBackofficeFlagsIndexRoute: typeof BaseAuthBackofficeFlagsIndexRoute
}

const BaseAuthBackofficeFlagsRouteRouteChildren: BaseAuthBackofficeFlagsRouteRouteChildren =
  {
    BaseAuthBackofficeFlagsIndexRoute: BaseAuthBackofficeFlagsIndexRoute,
  }

const BaseAuthBackofficeFlagsRouteRouteWithChildren =
  BaseAuthBackofficeFlagsRouteRoute._addFileChildren(
    BaseAuthBackofficeFlagsRouteRouteChildren,
  )

interface BaseAuthBackofficeKnowledgeRouteRouteChildren {
  BaseAuthBackofficeKnowledgeTopicsTopicIdRoute: typeof BaseAuthBackofficeKnowledgeTopicsTopicIdRoute
}

const BaseAuthBackofficeKnowledgeRouteRouteChildren: BaseAuthBackofficeKnowledgeRouteRouteChildren =
  {
    BaseAuthBackofficeKnowledgeTopicsTopicIdRoute:
      BaseAuthBackofficeKnowledgeTopicsTopicIdRoute,
  }

const BaseAuthBackofficeKnowledgeRouteRouteWithChildren =
  BaseAuthBackofficeKnowledgeRouteRoute._addFileChildren(
    BaseAuthBackofficeKnowledgeRouteRouteChildren,
  )

interface BaseAuthBackofficeOrganizationsIdCompaniesCompanyIdCanonicalTopicsRouteRouteChildren {
  BaseAuthBackofficeOrganizationsIdCompaniesCompanyIdCanonicalTopicsListRoute: typeof BaseAuthBackofficeOrganizationsIdCompaniesCompanyIdCanonicalTopicsListRoute
}

const BaseAuthBackofficeOrganizationsIdCompaniesCompanyIdCanonicalTopicsRouteRouteChildren: BaseAuthBackofficeOrganizationsIdCompaniesCompanyIdCanonicalTopicsRouteRouteChildren =
  {
    BaseAuthBackofficeOrganizationsIdCompaniesCompanyIdCanonicalTopicsListRoute:
      BaseAuthBackofficeOrganizationsIdCompaniesCompanyIdCanonicalTopicsListRoute,
  }

const BaseAuthBackofficeOrganizationsIdCompaniesCompanyIdCanonicalTopicsRouteRouteWithChildren =
  BaseAuthBackofficeOrganizationsIdCompaniesCompanyIdCanonicalTopicsRouteRoute._addFileChildren(
    BaseAuthBackofficeOrganizationsIdCompaniesCompanyIdCanonicalTopicsRouteRouteChildren,
  )

interface BaseAuthBackofficeOrganizationsIdCompaniesCompanyIdCustomersRouteRouteChildren {
  BaseAuthBackofficeOrganizationsIdCompaniesCompanyIdCustomersListRoute: typeof BaseAuthBackofficeOrganizationsIdCompaniesCompanyIdCustomersListRoute
}

const BaseAuthBackofficeOrganizationsIdCompaniesCompanyIdCustomersRouteRouteChildren: BaseAuthBackofficeOrganizationsIdCompaniesCompanyIdCustomersRouteRouteChildren =
  {
    BaseAuthBackofficeOrganizationsIdCompaniesCompanyIdCustomersListRoute:
      BaseAuthBackofficeOrganizationsIdCompaniesCompanyIdCustomersListRoute,
  }

const BaseAuthBackofficeOrganizationsIdCompaniesCompanyIdCustomersRouteRouteWithChildren =
  BaseAuthBackofficeOrganizationsIdCompaniesCompanyIdCustomersRouteRoute._addFileChildren(
    BaseAuthBackofficeOrganizationsIdCompaniesCompanyIdCustomersRouteRouteChildren,
  )

interface BaseAuthBackofficeOrganizationsIdCompaniesCompanyIdRouteRouteChildren {
  BaseAuthBackofficeOrganizationsIdCompaniesCompanyIdCanonicalTopicsRouteRoute: typeof BaseAuthBackofficeOrganizationsIdCompaniesCompanyIdCanonicalTopicsRouteRouteWithChildren
  BaseAuthBackofficeOrganizationsIdCompaniesCompanyIdCustomersRouteRoute: typeof BaseAuthBackofficeOrganizationsIdCompaniesCompanyIdCustomersRouteRouteWithChildren
  BaseAuthBackofficeOrganizationsIdCompaniesCompanyIdIndexRoute: typeof BaseAuthBackofficeOrganizationsIdCompaniesCompanyIdIndexRoute
}

const BaseAuthBackofficeOrganizationsIdCompaniesCompanyIdRouteRouteChildren: BaseAuthBackofficeOrganizationsIdCompaniesCompanyIdRouteRouteChildren =
  {
    BaseAuthBackofficeOrganizationsIdCompaniesCompanyIdCanonicalTopicsRouteRoute:
      BaseAuthBackofficeOrganizationsIdCompaniesCompanyIdCanonicalTopicsRouteRouteWithChildren,
    BaseAuthBackofficeOrganizationsIdCompaniesCompanyIdCustomersRouteRoute:
      BaseAuthBackofficeOrganizationsIdCompaniesCompanyIdCustomersRouteRouteWithChildren,
    BaseAuthBackofficeOrganizationsIdCompaniesCompanyIdIndexRoute:
      BaseAuthBackofficeOrganizationsIdCompaniesCompanyIdIndexRoute,
  }

const BaseAuthBackofficeOrganizationsIdCompaniesCompanyIdRouteRouteWithChildren =
  BaseAuthBackofficeOrganizationsIdCompaniesCompanyIdRouteRoute._addFileChildren(
    BaseAuthBackofficeOrganizationsIdCompaniesCompanyIdRouteRouteChildren,
  )

interface BaseAuthBackofficeOrganizationsIdCompaniesRouteRouteChildren {
  BaseAuthBackofficeOrganizationsIdCompaniesCompanyIdRouteRoute: typeof BaseAuthBackofficeOrganizationsIdCompaniesCompanyIdRouteRouteWithChildren
}

const BaseAuthBackofficeOrganizationsIdCompaniesRouteRouteChildren: BaseAuthBackofficeOrganizationsIdCompaniesRouteRouteChildren =
  {
    BaseAuthBackofficeOrganizationsIdCompaniesCompanyIdRouteRoute:
      BaseAuthBackofficeOrganizationsIdCompaniesCompanyIdRouteRouteWithChildren,
  }

const BaseAuthBackofficeOrganizationsIdCompaniesRouteRouteWithChildren =
  BaseAuthBackofficeOrganizationsIdCompaniesRouteRoute._addFileChildren(
    BaseAuthBackofficeOrganizationsIdCompaniesRouteRouteChildren,
  )

interface BaseAuthBackofficeOrganizationsIdCreditsRouteRouteChildren {
  BaseAuthBackofficeOrganizationsIdCreditsListRoute: typeof BaseAuthBackofficeOrganizationsIdCreditsListRoute
}

const BaseAuthBackofficeOrganizationsIdCreditsRouteRouteChildren: BaseAuthBackofficeOrganizationsIdCreditsRouteRouteChildren =
  {
    BaseAuthBackofficeOrganizationsIdCreditsListRoute:
      BaseAuthBackofficeOrganizationsIdCreditsListRoute,
  }

const BaseAuthBackofficeOrganizationsIdCreditsRouteRouteWithChildren =
  BaseAuthBackofficeOrganizationsIdCreditsRouteRoute._addFileChildren(
    BaseAuthBackofficeOrganizationsIdCreditsRouteRouteChildren,
  )

interface BaseAuthBackofficeOrganizationsIdRouteRouteChildren {
  BaseAuthBackofficeOrganizationsIdCompaniesRouteRoute: typeof BaseAuthBackofficeOrganizationsIdCompaniesRouteRouteWithChildren
  BaseAuthBackofficeOrganizationsIdCreditsRouteRoute: typeof BaseAuthBackofficeOrganizationsIdCreditsRouteRouteWithChildren
  BaseAuthBackofficeOrganizationsIdIndexRoute: typeof BaseAuthBackofficeOrganizationsIdIndexRoute
}

const BaseAuthBackofficeOrganizationsIdRouteRouteChildren: BaseAuthBackofficeOrganizationsIdRouteRouteChildren =
  {
    BaseAuthBackofficeOrganizationsIdCompaniesRouteRoute:
      BaseAuthBackofficeOrganizationsIdCompaniesRouteRouteWithChildren,
    BaseAuthBackofficeOrganizationsIdCreditsRouteRoute:
      BaseAuthBackofficeOrganizationsIdCreditsRouteRouteWithChildren,
    BaseAuthBackofficeOrganizationsIdIndexRoute:
      BaseAuthBackofficeOrganizationsIdIndexRoute,
  }

const BaseAuthBackofficeOrganizationsIdRouteRouteWithChildren =
  BaseAuthBackofficeOrganizationsIdRouteRoute._addFileChildren(
    BaseAuthBackofficeOrganizationsIdRouteRouteChildren,
  )

interface BaseAuthBackofficeOrganizationsListRouteChildren {
  BaseAuthBackofficeOrganizationsListCreateRoute: typeof BaseAuthBackofficeOrganizationsListCreateRoute
  BaseAuthBackofficeOrganizationsListCreateFromWebsiteRoute: typeof BaseAuthBackofficeOrganizationsListCreateFromWebsiteRoute
}

const BaseAuthBackofficeOrganizationsListRouteChildren: BaseAuthBackofficeOrganizationsListRouteChildren =
  {
    BaseAuthBackofficeOrganizationsListCreateRoute:
      BaseAuthBackofficeOrganizationsListCreateRoute,
    BaseAuthBackofficeOrganizationsListCreateFromWebsiteRoute:
      BaseAuthBackofficeOrganizationsListCreateFromWebsiteRoute,
  }

const BaseAuthBackofficeOrganizationsListRouteWithChildren =
  BaseAuthBackofficeOrganizationsListRoute._addFileChildren(
    BaseAuthBackofficeOrganizationsListRouteChildren,
  )

interface BaseAuthBackofficeOrganizationsRouteRouteChildren {
  BaseAuthBackofficeOrganizationsIdRouteRoute: typeof BaseAuthBackofficeOrganizationsIdRouteRouteWithChildren
  BaseAuthBackofficeOrganizationsListRoute: typeof BaseAuthBackofficeOrganizationsListRouteWithChildren
  BaseAuthBackofficeOrganizationsIndexRoute: typeof BaseAuthBackofficeOrganizationsIndexRoute
}

const BaseAuthBackofficeOrganizationsRouteRouteChildren: BaseAuthBackofficeOrganizationsRouteRouteChildren =
  {
    BaseAuthBackofficeOrganizationsIdRouteRoute:
      BaseAuthBackofficeOrganizationsIdRouteRouteWithChildren,
    BaseAuthBackofficeOrganizationsListRoute:
      BaseAuthBackofficeOrganizationsListRouteWithChildren,
    BaseAuthBackofficeOrganizationsIndexRoute:
      BaseAuthBackofficeOrganizationsIndexRoute,
  }

const BaseAuthBackofficeOrganizationsRouteRouteWithChildren =
  BaseAuthBackofficeOrganizationsRouteRoute._addFileChildren(
    BaseAuthBackofficeOrganizationsRouteRouteChildren,
  )

interface BaseAuthBackofficeReferralsRouteRouteChildren {
  BaseAuthBackofficeReferralsListRoute: typeof BaseAuthBackofficeReferralsListRoute
  BaseAuthBackofficeReferralsIndexRoute: typeof BaseAuthBackofficeReferralsIndexRoute
}

const BaseAuthBackofficeReferralsRouteRouteChildren: BaseAuthBackofficeReferralsRouteRouteChildren =
  {
    BaseAuthBackofficeReferralsListRoute: BaseAuthBackofficeReferralsListRoute,
    BaseAuthBackofficeReferralsIndexRoute:
      BaseAuthBackofficeReferralsIndexRoute,
  }

const BaseAuthBackofficeReferralsRouteRouteWithChildren =
  BaseAuthBackofficeReferralsRouteRoute._addFileChildren(
    BaseAuthBackofficeReferralsRouteRouteChildren,
  )

interface BaseAuthBackofficeScheduledReportsRouteRouteChildren {
  BaseAuthBackofficeScheduledReportsListRouteRoute: typeof BaseAuthBackofficeScheduledReportsListRouteRoute
  BaseAuthBackofficeScheduledReportsIdRoute: typeof BaseAuthBackofficeScheduledReportsIdRoute
  BaseAuthBackofficeScheduledReportsCreateRoute: typeof BaseAuthBackofficeScheduledReportsCreateRoute
  BaseAuthBackofficeScheduledReportsIndexRoute: typeof BaseAuthBackofficeScheduledReportsIndexRoute
}

const BaseAuthBackofficeScheduledReportsRouteRouteChildren: BaseAuthBackofficeScheduledReportsRouteRouteChildren =
  {
    BaseAuthBackofficeScheduledReportsListRouteRoute:
      BaseAuthBackofficeScheduledReportsListRouteRoute,
    BaseAuthBackofficeScheduledReportsIdRoute:
      BaseAuthBackofficeScheduledReportsIdRoute,
    BaseAuthBackofficeScheduledReportsCreateRoute:
      BaseAuthBackofficeScheduledReportsCreateRoute,
    BaseAuthBackofficeScheduledReportsIndexRoute:
      BaseAuthBackofficeScheduledReportsIndexRoute,
  }

const BaseAuthBackofficeScheduledReportsRouteRouteWithChildren =
  BaseAuthBackofficeScheduledReportsRouteRoute._addFileChildren(
    BaseAuthBackofficeScheduledReportsRouteRouteChildren,
  )

interface BaseAuthBackofficeSupportRouteRouteChildren {
  BaseAuthBackofficeSupportListRouteRoute: typeof BaseAuthBackofficeSupportListRouteRoute
}

const BaseAuthBackofficeSupportRouteRouteChildren: BaseAuthBackofficeSupportRouteRouteChildren =
  {
    BaseAuthBackofficeSupportListRouteRoute:
      BaseAuthBackofficeSupportListRouteRoute,
  }

const BaseAuthBackofficeSupportRouteRouteWithChildren =
  BaseAuthBackofficeSupportRouteRoute._addFileChildren(
    BaseAuthBackofficeSupportRouteRouteChildren,
  )

interface BaseAuthBackofficeRouteRouteChildren {
  BaseAuthBackofficeBiRouteRoute: typeof BaseAuthBackofficeBiRouteRoute
  BaseAuthBackofficeCampaignsRouteRoute: typeof BaseAuthBackofficeCampaignsRouteRouteWithChildren
  BaseAuthBackofficeCapabilityExecutionsRouteRoute: typeof BaseAuthBackofficeCapabilityExecutionsRouteRoute
  BaseAuthBackofficeClustersRouteRoute: typeof BaseAuthBackofficeClustersRouteRouteWithChildren
  BaseAuthBackofficeConversationExperimentsRouteRoute: typeof BaseAuthBackofficeConversationExperimentsRouteRouteWithChildren
  BaseAuthBackofficeConversationSalesReportsRouteRoute: typeof BaseAuthBackofficeConversationSalesReportsRouteRoute
  BaseAuthBackofficeEmailVerifierRouteRoute: typeof BaseAuthBackofficeEmailVerifierRouteRoute
  BaseAuthBackofficeFlagsRouteRoute: typeof BaseAuthBackofficeFlagsRouteRouteWithChildren
  BaseAuthBackofficeGmailReaderRouteRoute: typeof BaseAuthBackofficeGmailReaderRouteRoute
  BaseAuthBackofficeJobSearchRouteRoute: typeof BaseAuthBackofficeJobSearchRouteRoute
  BaseAuthBackofficeKnowledgeRouteRoute: typeof BaseAuthBackofficeKnowledgeRouteRouteWithChildren
  BaseAuthBackofficeOrganizationsRouteRoute: typeof BaseAuthBackofficeOrganizationsRouteRouteWithChildren
  BaseAuthBackofficeOutlookReaderRouteRoute: typeof BaseAuthBackofficeOutlookReaderRouteRoute
  BaseAuthBackofficeReferralsRouteRoute: typeof BaseAuthBackofficeReferralsRouteRouteWithChildren
  BaseAuthBackofficeScheduledReportsRouteRoute: typeof BaseAuthBackofficeScheduledReportsRouteRouteWithChildren
  BaseAuthBackofficeSupportRouteRoute: typeof BaseAuthBackofficeSupportRouteRouteWithChildren
  BaseAuthBackofficeWhatsappRoutesRouteRoute: typeof BaseAuthBackofficeWhatsappRoutesRouteRoute
  BaseAuthBackofficeIndexRoute: typeof BaseAuthBackofficeIndexRoute
  BaseAuthBackofficeCompaniesCreateRoute: typeof BaseAuthBackofficeCompaniesCreateRoute
}

const BaseAuthBackofficeRouteRouteChildren: BaseAuthBackofficeRouteRouteChildren =
  {
    BaseAuthBackofficeBiRouteRoute: BaseAuthBackofficeBiRouteRoute,
    BaseAuthBackofficeCampaignsRouteRoute:
      BaseAuthBackofficeCampaignsRouteRouteWithChildren,
    BaseAuthBackofficeCapabilityExecutionsRouteRoute:
      BaseAuthBackofficeCapabilityExecutionsRouteRoute,
    BaseAuthBackofficeClustersRouteRoute:
      BaseAuthBackofficeClustersRouteRouteWithChildren,
    BaseAuthBackofficeConversationExperimentsRouteRoute:
      BaseAuthBackofficeConversationExperimentsRouteRouteWithChildren,
    BaseAuthBackofficeConversationSalesReportsRouteRoute:
      BaseAuthBackofficeConversationSalesReportsRouteRoute,
    BaseAuthBackofficeEmailVerifierRouteRoute:
      BaseAuthBackofficeEmailVerifierRouteRoute,
    BaseAuthBackofficeFlagsRouteRoute:
      BaseAuthBackofficeFlagsRouteRouteWithChildren,
    BaseAuthBackofficeGmailReaderRouteRoute:
      BaseAuthBackofficeGmailReaderRouteRoute,
    BaseAuthBackofficeJobSearchRouteRoute:
      BaseAuthBackofficeJobSearchRouteRoute,
    BaseAuthBackofficeKnowledgeRouteRoute:
      BaseAuthBackofficeKnowledgeRouteRouteWithChildren,
    BaseAuthBackofficeOrganizationsRouteRoute:
      BaseAuthBackofficeOrganizationsRouteRouteWithChildren,
    BaseAuthBackofficeOutlookReaderRouteRoute:
      BaseAuthBackofficeOutlookReaderRouteRoute,
    BaseAuthBackofficeReferralsRouteRoute:
      BaseAuthBackofficeReferralsRouteRouteWithChildren,
    BaseAuthBackofficeScheduledReportsRouteRoute:
      BaseAuthBackofficeScheduledReportsRouteRouteWithChildren,
    BaseAuthBackofficeSupportRouteRoute:
      BaseAuthBackofficeSupportRouteRouteWithChildren,
    BaseAuthBackofficeWhatsappRoutesRouteRoute:
      BaseAuthBackofficeWhatsappRoutesRouteRoute,
    BaseAuthBackofficeIndexRoute: BaseAuthBackofficeIndexRoute,
    BaseAuthBackofficeCompaniesCreateRoute:
      BaseAuthBackofficeCompaniesCreateRoute,
  }

const BaseAuthBackofficeRouteRouteWithChildren =
  BaseAuthBackofficeRouteRoute._addFileChildren(
    BaseAuthBackofficeRouteRouteChildren,
  )

interface BaseAuthCampaignsIdActivityRouteRouteChildren {
  BaseAuthCampaignsIdActivityCustomerIdRoute: typeof BaseAuthCampaignsIdActivityCustomerIdRoute
}

const BaseAuthCampaignsIdActivityRouteRouteChildren: BaseAuthCampaignsIdActivityRouteRouteChildren =
  {
    BaseAuthCampaignsIdActivityCustomerIdRoute:
      BaseAuthCampaignsIdActivityCustomerIdRoute,
  }

const BaseAuthCampaignsIdActivityRouteRouteWithChildren =
  BaseAuthCampaignsIdActivityRouteRoute._addFileChildren(
    BaseAuthCampaignsIdActivityRouteRouteChildren,
  )

interface BaseAuthCampaignsIdInsightsRouteRouteChildren {
  BaseAuthCampaignsIdInsightsLaunchRoute: typeof BaseAuthCampaignsIdInsightsLaunchRoute
}

const BaseAuthCampaignsIdInsightsRouteRouteChildren: BaseAuthCampaignsIdInsightsRouteRouteChildren =
  {
    BaseAuthCampaignsIdInsightsLaunchRoute:
      BaseAuthCampaignsIdInsightsLaunchRoute,
  }

const BaseAuthCampaignsIdInsightsRouteRouteWithChildren =
  BaseAuthCampaignsIdInsightsRouteRoute._addFileChildren(
    BaseAuthCampaignsIdInsightsRouteRouteChildren,
  )

interface BaseAuthCampaignsIdRouteRouteChildren {
  BaseAuthCampaignsIdActivityRouteRoute: typeof BaseAuthCampaignsIdActivityRouteRouteWithChildren
  BaseAuthCampaignsIdCapabilitiesRouteRoute: typeof BaseAuthCampaignsIdCapabilitiesRouteRoute
  BaseAuthCampaignsIdConfigurationRouteRoute: typeof BaseAuthCampaignsIdConfigurationRouteRoute
  BaseAuthCampaignsIdInsightsRouteRoute: typeof BaseAuthCampaignsIdInsightsRouteRouteWithChildren
  BaseAuthCampaignsIdKnowledgeBaseRouteRoute: typeof BaseAuthCampaignsIdKnowledgeBaseRouteRoute
  BaseAuthCampaignsIdWorkflowsRouteRoute: typeof BaseAuthCampaignsIdWorkflowsRouteRoute
  BaseAuthCampaignsIdIndexRoute: typeof BaseAuthCampaignsIdIndexRoute
}

const BaseAuthCampaignsIdRouteRouteChildren: BaseAuthCampaignsIdRouteRouteChildren =
  {
    BaseAuthCampaignsIdActivityRouteRoute:
      BaseAuthCampaignsIdActivityRouteRouteWithChildren,
    BaseAuthCampaignsIdCapabilitiesRouteRoute:
      BaseAuthCampaignsIdCapabilitiesRouteRoute,
    BaseAuthCampaignsIdConfigurationRouteRoute:
      BaseAuthCampaignsIdConfigurationRouteRoute,
    BaseAuthCampaignsIdInsightsRouteRoute:
      BaseAuthCampaignsIdInsightsRouteRouteWithChildren,
    BaseAuthCampaignsIdKnowledgeBaseRouteRoute:
      BaseAuthCampaignsIdKnowledgeBaseRouteRoute,
    BaseAuthCampaignsIdWorkflowsRouteRoute:
      BaseAuthCampaignsIdWorkflowsRouteRoute,
    BaseAuthCampaignsIdIndexRoute: BaseAuthCampaignsIdIndexRoute,
  }

const BaseAuthCampaignsIdRouteRouteWithChildren =
  BaseAuthCampaignsIdRouteRoute._addFileChildren(
    BaseAuthCampaignsIdRouteRouteChildren,
  )

interface BaseAuthCampaignsGoalsListRouteRouteChildren {
  BaseAuthCampaignsGoalsListCreateRoute: typeof BaseAuthCampaignsGoalsListCreateRoute
  BaseAuthCampaignsGoalsListEditIdRoute: typeof BaseAuthCampaignsGoalsListEditIdRoute
}

const BaseAuthCampaignsGoalsListRouteRouteChildren: BaseAuthCampaignsGoalsListRouteRouteChildren =
  {
    BaseAuthCampaignsGoalsListCreateRoute:
      BaseAuthCampaignsGoalsListCreateRoute,
    BaseAuthCampaignsGoalsListEditIdRoute:
      BaseAuthCampaignsGoalsListEditIdRoute,
  }

const BaseAuthCampaignsGoalsListRouteRouteWithChildren =
  BaseAuthCampaignsGoalsListRouteRoute._addFileChildren(
    BaseAuthCampaignsGoalsListRouteRouteChildren,
  )

interface BaseAuthCampaignsGoalsRouteRouteChildren {
  BaseAuthCampaignsGoalsListRouteRoute: typeof BaseAuthCampaignsGoalsListRouteRouteWithChildren
  BaseAuthCampaignsGoalsIndexRoute: typeof BaseAuthCampaignsGoalsIndexRoute
}

const BaseAuthCampaignsGoalsRouteRouteChildren: BaseAuthCampaignsGoalsRouteRouteChildren =
  {
    BaseAuthCampaignsGoalsListRouteRoute:
      BaseAuthCampaignsGoalsListRouteRouteWithChildren,
    BaseAuthCampaignsGoalsIndexRoute: BaseAuthCampaignsGoalsIndexRoute,
  }

const BaseAuthCampaignsGoalsRouteRouteWithChildren =
  BaseAuthCampaignsGoalsRouteRoute._addFileChildren(
    BaseAuthCampaignsGoalsRouteRouteChildren,
  )

interface BaseAuthCampaignsRouteRouteChildren {
  BaseAuthCampaignsIdRouteRoute: typeof BaseAuthCampaignsIdRouteRouteWithChildren
  BaseAuthCampaignsGoalsRouteRoute: typeof BaseAuthCampaignsGoalsRouteRouteWithChildren
  BaseAuthCampaignsListRouteRoute: typeof BaseAuthCampaignsListRouteRoute
  BaseAuthCampaignsIndexRoute: typeof BaseAuthCampaignsIndexRoute
}

const BaseAuthCampaignsRouteRouteChildren: BaseAuthCampaignsRouteRouteChildren =
  {
    BaseAuthCampaignsIdRouteRoute: BaseAuthCampaignsIdRouteRouteWithChildren,
    BaseAuthCampaignsGoalsRouteRoute:
      BaseAuthCampaignsGoalsRouteRouteWithChildren,
    BaseAuthCampaignsListRouteRoute: BaseAuthCampaignsListRouteRoute,
    BaseAuthCampaignsIndexRoute: BaseAuthCampaignsIndexRoute,
  }

const BaseAuthCampaignsRouteRouteWithChildren =
  BaseAuthCampaignsRouteRoute._addFileChildren(
    BaseAuthCampaignsRouteRouteChildren,
  )

interface BaseAuthCapabilitiesListRouteRouteChildren {
  BaseAuthCapabilitiesListCreateCustomRoute: typeof BaseAuthCapabilitiesListCreateCustomRoute
}

const BaseAuthCapabilitiesListRouteRouteChildren: BaseAuthCapabilitiesListRouteRouteChildren =
  {
    BaseAuthCapabilitiesListCreateCustomRoute:
      BaseAuthCapabilitiesListCreateCustomRoute,
  }

const BaseAuthCapabilitiesListRouteRouteWithChildren =
  BaseAuthCapabilitiesListRouteRoute._addFileChildren(
    BaseAuthCapabilitiesListRouteRouteChildren,
  )

interface BaseAuthCapabilitiesRouteRouteChildren {
  BaseAuthCapabilitiesListRouteRoute: typeof BaseAuthCapabilitiesListRouteRouteWithChildren
  BaseAuthCapabilitiesIndexRoute: typeof BaseAuthCapabilitiesIndexRoute
}

const BaseAuthCapabilitiesRouteRouteChildren: BaseAuthCapabilitiesRouteRouteChildren =
  {
    BaseAuthCapabilitiesListRouteRoute:
      BaseAuthCapabilitiesListRouteRouteWithChildren,
    BaseAuthCapabilitiesIndexRoute: BaseAuthCapabilitiesIndexRoute,
  }

const BaseAuthCapabilitiesRouteRouteWithChildren =
  BaseAuthCapabilitiesRouteRoute._addFileChildren(
    BaseAuthCapabilitiesRouteRouteChildren,
  )

interface BaseAuthConversationsListRouteRouteChildren {
  BaseAuthConversationsListCustomerIdRouteRoute: typeof BaseAuthConversationsListCustomerIdRouteRoute
}

const BaseAuthConversationsListRouteRouteChildren: BaseAuthConversationsListRouteRouteChildren =
  {
    BaseAuthConversationsListCustomerIdRouteRoute:
      BaseAuthConversationsListCustomerIdRouteRoute,
  }

const BaseAuthConversationsListRouteRouteWithChildren =
  BaseAuthConversationsListRouteRoute._addFileChildren(
    BaseAuthConversationsListRouteRouteChildren,
  )

interface BaseAuthConversationsRouteRouteChildren {
  BaseAuthConversationsListRouteRoute: typeof BaseAuthConversationsListRouteRouteWithChildren
  BaseAuthConversationsIndexRoute: typeof BaseAuthConversationsIndexRoute
}

const BaseAuthConversationsRouteRouteChildren: BaseAuthConversationsRouteRouteChildren =
  {
    BaseAuthConversationsListRouteRoute:
      BaseAuthConversationsListRouteRouteWithChildren,
    BaseAuthConversationsIndexRoute: BaseAuthConversationsIndexRoute,
  }

const BaseAuthConversationsRouteRouteWithChildren =
  BaseAuthConversationsRouteRoute._addFileChildren(
    BaseAuthConversationsRouteRouteChildren,
  )

interface BaseAuthCustomersListRouteRouteChildren {
  BaseAuthCustomersListIdRoute: typeof BaseAuthCustomersListIdRoute
  BaseAuthCustomersListCreateRoute: typeof BaseAuthCustomersListCreateRoute
  BaseAuthCustomersListImportRoute: typeof BaseAuthCustomersListImportRoute
}

const BaseAuthCustomersListRouteRouteChildren: BaseAuthCustomersListRouteRouteChildren =
  {
    BaseAuthCustomersListIdRoute: BaseAuthCustomersListIdRoute,
    BaseAuthCustomersListCreateRoute: BaseAuthCustomersListCreateRoute,
    BaseAuthCustomersListImportRoute: BaseAuthCustomersListImportRoute,
  }

const BaseAuthCustomersListRouteRouteWithChildren =
  BaseAuthCustomersListRouteRoute._addFileChildren(
    BaseAuthCustomersListRouteRouteChildren,
  )

interface BaseAuthCustomersSegmentsRouteRouteChildren {
  BaseAuthCustomersSegmentsIdRouteRoute: typeof BaseAuthCustomersSegmentsIdRouteRoute
  BaseAuthCustomersSegmentsListRouteRoute: typeof BaseAuthCustomersSegmentsListRouteRoute
  BaseAuthCustomersSegmentsIndexRoute: typeof BaseAuthCustomersSegmentsIndexRoute
}

const BaseAuthCustomersSegmentsRouteRouteChildren: BaseAuthCustomersSegmentsRouteRouteChildren =
  {
    BaseAuthCustomersSegmentsIdRouteRoute:
      BaseAuthCustomersSegmentsIdRouteRoute,
    BaseAuthCustomersSegmentsListRouteRoute:
      BaseAuthCustomersSegmentsListRouteRoute,
    BaseAuthCustomersSegmentsIndexRoute: BaseAuthCustomersSegmentsIndexRoute,
  }

const BaseAuthCustomersSegmentsRouteRouteWithChildren =
  BaseAuthCustomersSegmentsRouteRoute._addFileChildren(
    BaseAuthCustomersSegmentsRouteRouteChildren,
  )

interface BaseAuthCustomersRouteRouteChildren {
  BaseAuthCustomersListRouteRoute: typeof BaseAuthCustomersListRouteRouteWithChildren
  BaseAuthCustomersSegmentsRouteRoute: typeof BaseAuthCustomersSegmentsRouteRouteWithChildren
  BaseAuthCustomersIndexRoute: typeof BaseAuthCustomersIndexRoute
}

const BaseAuthCustomersRouteRouteChildren: BaseAuthCustomersRouteRouteChildren =
  {
    BaseAuthCustomersListRouteRoute:
      BaseAuthCustomersListRouteRouteWithChildren,
    BaseAuthCustomersSegmentsRouteRoute:
      BaseAuthCustomersSegmentsRouteRouteWithChildren,
    BaseAuthCustomersIndexRoute: BaseAuthCustomersIndexRoute,
  }

const BaseAuthCustomersRouteRouteWithChildren =
  BaseAuthCustomersRouteRoute._addFileChildren(
    BaseAuthCustomersRouteRouteChildren,
  )

interface BaseAuthInsightsRouteRouteChildren {
  BaseAuthInsightsIndexRoute: typeof BaseAuthInsightsIndexRoute
}

const BaseAuthInsightsRouteRouteChildren: BaseAuthInsightsRouteRouteChildren = {
  BaseAuthInsightsIndexRoute: BaseAuthInsightsIndexRoute,
}

const BaseAuthInsightsRouteRouteWithChildren =
  BaseAuthInsightsRouteRoute._addFileChildren(
    BaseAuthInsightsRouteRouteChildren,
  )

interface BaseAuthKnowledgeSuggestionsRouteChildren {
  BaseAuthKnowledgeSuggestionsGapIdDismissRoute: typeof BaseAuthKnowledgeSuggestionsGapIdDismissRoute
  BaseAuthKnowledgeSuggestionsGapIdEvidenceRoute: typeof BaseAuthKnowledgeSuggestionsGapIdEvidenceRoute
}

const BaseAuthKnowledgeSuggestionsRouteChildren: BaseAuthKnowledgeSuggestionsRouteChildren =
  {
    BaseAuthKnowledgeSuggestionsGapIdDismissRoute:
      BaseAuthKnowledgeSuggestionsGapIdDismissRoute,
    BaseAuthKnowledgeSuggestionsGapIdEvidenceRoute:
      BaseAuthKnowledgeSuggestionsGapIdEvidenceRoute,
  }

const BaseAuthKnowledgeSuggestionsRouteWithChildren =
  BaseAuthKnowledgeSuggestionsRoute._addFileChildren(
    BaseAuthKnowledgeSuggestionsRouteChildren,
  )

interface BaseAuthKnowledgeRouteRouteChildren {
  BaseAuthKnowledgeCustomizationRoute: typeof BaseAuthKnowledgeCustomizationRoute
  BaseAuthKnowledgeKnowledgeBaseRoute: typeof BaseAuthKnowledgeKnowledgeBaseRoute
  BaseAuthKnowledgeSuggestionsRoute: typeof BaseAuthKnowledgeSuggestionsRouteWithChildren
  BaseAuthKnowledgeIndexRoute: typeof BaseAuthKnowledgeIndexRoute
}

const BaseAuthKnowledgeRouteRouteChildren: BaseAuthKnowledgeRouteRouteChildren =
  {
    BaseAuthKnowledgeCustomizationRoute: BaseAuthKnowledgeCustomizationRoute,
    BaseAuthKnowledgeKnowledgeBaseRoute: BaseAuthKnowledgeKnowledgeBaseRoute,
    BaseAuthKnowledgeSuggestionsRoute:
      BaseAuthKnowledgeSuggestionsRouteWithChildren,
    BaseAuthKnowledgeIndexRoute: BaseAuthKnowledgeIndexRoute,
  }

const BaseAuthKnowledgeRouteRouteWithChildren =
  BaseAuthKnowledgeRouteRoute._addFileChildren(
    BaseAuthKnowledgeRouteRouteChildren,
  )

interface BaseAuthSettingsChannelsGmailRouteRouteChildren {
  BaseAuthSettingsChannelsGmailNewRoute: typeof BaseAuthSettingsChannelsGmailNewRoute
  BaseAuthSettingsChannelsGmailDeleteIntegrationIdRoute: typeof BaseAuthSettingsChannelsGmailDeleteIntegrationIdRoute
}

const BaseAuthSettingsChannelsGmailRouteRouteChildren: BaseAuthSettingsChannelsGmailRouteRouteChildren =
  {
    BaseAuthSettingsChannelsGmailNewRoute:
      BaseAuthSettingsChannelsGmailNewRoute,
    BaseAuthSettingsChannelsGmailDeleteIntegrationIdRoute:
      BaseAuthSettingsChannelsGmailDeleteIntegrationIdRoute,
  }

const BaseAuthSettingsChannelsGmailRouteRouteWithChildren =
  BaseAuthSettingsChannelsGmailRouteRoute._addFileChildren(
    BaseAuthSettingsChannelsGmailRouteRouteChildren,
  )

interface BaseAuthSettingsChannelsInstagramRouteRouteChildren {
  BaseAuthSettingsChannelsInstagramNewRoute: typeof BaseAuthSettingsChannelsInstagramNewRoute
}

const BaseAuthSettingsChannelsInstagramRouteRouteChildren: BaseAuthSettingsChannelsInstagramRouteRouteChildren =
  {
    BaseAuthSettingsChannelsInstagramNewRoute:
      BaseAuthSettingsChannelsInstagramNewRoute,
  }

const BaseAuthSettingsChannelsInstagramRouteRouteWithChildren =
  BaseAuthSettingsChannelsInstagramRouteRoute._addFileChildren(
    BaseAuthSettingsChannelsInstagramRouteRouteChildren,
  )

interface BaseAuthSettingsChannelsOutlookRouteRouteChildren {
  BaseAuthSettingsChannelsOutlookNewRoute: typeof BaseAuthSettingsChannelsOutlookNewRoute
  BaseAuthSettingsChannelsOutlookDeleteIntegrationIdRoute: typeof BaseAuthSettingsChannelsOutlookDeleteIntegrationIdRoute
}

const BaseAuthSettingsChannelsOutlookRouteRouteChildren: BaseAuthSettingsChannelsOutlookRouteRouteChildren =
  {
    BaseAuthSettingsChannelsOutlookNewRoute:
      BaseAuthSettingsChannelsOutlookNewRoute,
    BaseAuthSettingsChannelsOutlookDeleteIntegrationIdRoute:
      BaseAuthSettingsChannelsOutlookDeleteIntegrationIdRoute,
  }

const BaseAuthSettingsChannelsOutlookRouteRouteWithChildren =
  BaseAuthSettingsChannelsOutlookRouteRoute._addFileChildren(
    BaseAuthSettingsChannelsOutlookRouteRouteChildren,
  )

interface BaseAuthSettingsChannelsQrRouteRouteChildren {
  BaseAuthSettingsChannelsQrIdRoute: typeof BaseAuthSettingsChannelsQrIdRoute
  BaseAuthSettingsChannelsQrCreateRoute: typeof BaseAuthSettingsChannelsQrCreateRoute
}

const BaseAuthSettingsChannelsQrRouteRouteChildren: BaseAuthSettingsChannelsQrRouteRouteChildren =
  {
    BaseAuthSettingsChannelsQrIdRoute: BaseAuthSettingsChannelsQrIdRoute,
    BaseAuthSettingsChannelsQrCreateRoute:
      BaseAuthSettingsChannelsQrCreateRoute,
  }

const BaseAuthSettingsChannelsQrRouteRouteWithChildren =
  BaseAuthSettingsChannelsQrRouteRoute._addFileChildren(
    BaseAuthSettingsChannelsQrRouteRouteChildren,
  )

interface BaseAuthSettingsChannelsWhatsappOpeningsRouteRouteChildren {
  BaseAuthSettingsChannelsWhatsappOpeningsIdRoute: typeof BaseAuthSettingsChannelsWhatsappOpeningsIdRoute
  BaseAuthSettingsChannelsWhatsappOpeningsCreateRoute: typeof BaseAuthSettingsChannelsWhatsappOpeningsCreateRoute
  BaseAuthSettingsChannelsWhatsappOpeningsIndexRoute: typeof BaseAuthSettingsChannelsWhatsappOpeningsIndexRoute
}

const BaseAuthSettingsChannelsWhatsappOpeningsRouteRouteChildren: BaseAuthSettingsChannelsWhatsappOpeningsRouteRouteChildren =
  {
    BaseAuthSettingsChannelsWhatsappOpeningsIdRoute:
      BaseAuthSettingsChannelsWhatsappOpeningsIdRoute,
    BaseAuthSettingsChannelsWhatsappOpeningsCreateRoute:
      BaseAuthSettingsChannelsWhatsappOpeningsCreateRoute,
    BaseAuthSettingsChannelsWhatsappOpeningsIndexRoute:
      BaseAuthSettingsChannelsWhatsappOpeningsIndexRoute,
  }

const BaseAuthSettingsChannelsWhatsappOpeningsRouteRouteWithChildren =
  BaseAuthSettingsChannelsWhatsappOpeningsRouteRoute._addFileChildren(
    BaseAuthSettingsChannelsWhatsappOpeningsRouteRouteChildren,
  )

interface BaseAuthSettingsChannelsWhatsappTemplatesRouteRouteChildren {
  BaseAuthSettingsChannelsWhatsappTemplatesIdRoute: typeof BaseAuthSettingsChannelsWhatsappTemplatesIdRoute
  BaseAuthSettingsChannelsWhatsappTemplatesCreateRoute: typeof BaseAuthSettingsChannelsWhatsappTemplatesCreateRoute
  BaseAuthSettingsChannelsWhatsappTemplatesIndexRoute: typeof BaseAuthSettingsChannelsWhatsappTemplatesIndexRoute
}

const BaseAuthSettingsChannelsWhatsappTemplatesRouteRouteChildren: BaseAuthSettingsChannelsWhatsappTemplatesRouteRouteChildren =
  {
    BaseAuthSettingsChannelsWhatsappTemplatesIdRoute:
      BaseAuthSettingsChannelsWhatsappTemplatesIdRoute,
    BaseAuthSettingsChannelsWhatsappTemplatesCreateRoute:
      BaseAuthSettingsChannelsWhatsappTemplatesCreateRoute,
    BaseAuthSettingsChannelsWhatsappTemplatesIndexRoute:
      BaseAuthSettingsChannelsWhatsappTemplatesIndexRoute,
  }

const BaseAuthSettingsChannelsWhatsappTemplatesRouteRouteWithChildren =
  BaseAuthSettingsChannelsWhatsappTemplatesRouteRoute._addFileChildren(
    BaseAuthSettingsChannelsWhatsappTemplatesRouteRouteChildren,
  )

interface BaseAuthSettingsChannelsWhatsappRouteRouteChildren {
  BaseAuthSettingsChannelsWhatsappOpeningsRouteRoute: typeof BaseAuthSettingsChannelsWhatsappOpeningsRouteRouteWithChildren
  BaseAuthSettingsChannelsWhatsappTemplatesRouteRoute: typeof BaseAuthSettingsChannelsWhatsappTemplatesRouteRouteWithChildren
  BaseAuthSettingsChannelsWhatsappAlertsRoute: typeof BaseAuthSettingsChannelsWhatsappAlertsRoute
  BaseAuthSettingsChannelsWhatsappIndexRoute: typeof BaseAuthSettingsChannelsWhatsappIndexRoute
}

const BaseAuthSettingsChannelsWhatsappRouteRouteChildren: BaseAuthSettingsChannelsWhatsappRouteRouteChildren =
  {
    BaseAuthSettingsChannelsWhatsappOpeningsRouteRoute:
      BaseAuthSettingsChannelsWhatsappOpeningsRouteRouteWithChildren,
    BaseAuthSettingsChannelsWhatsappTemplatesRouteRoute:
      BaseAuthSettingsChannelsWhatsappTemplatesRouteRouteWithChildren,
    BaseAuthSettingsChannelsWhatsappAlertsRoute:
      BaseAuthSettingsChannelsWhatsappAlertsRoute,
    BaseAuthSettingsChannelsWhatsappIndexRoute:
      BaseAuthSettingsChannelsWhatsappIndexRoute,
  }

const BaseAuthSettingsChannelsWhatsappRouteRouteWithChildren =
  BaseAuthSettingsChannelsWhatsappRouteRoute._addFileChildren(
    BaseAuthSettingsChannelsWhatsappRouteRouteChildren,
  )

interface BaseAuthSettingsChannelsWidgetRouteRouteChildren {
  BaseAuthSettingsChannelsWidgetPhoneMockupRoute: typeof BaseAuthSettingsChannelsWidgetPhoneMockupRoute
  BaseAuthSettingsChannelsWidgetIndexRoute: typeof BaseAuthSettingsChannelsWidgetIndexRoute
}

const BaseAuthSettingsChannelsWidgetRouteRouteChildren: BaseAuthSettingsChannelsWidgetRouteRouteChildren =
  {
    BaseAuthSettingsChannelsWidgetPhoneMockupRoute:
      BaseAuthSettingsChannelsWidgetPhoneMockupRoute,
    BaseAuthSettingsChannelsWidgetIndexRoute:
      BaseAuthSettingsChannelsWidgetIndexRoute,
  }

const BaseAuthSettingsChannelsWidgetRouteRouteWithChildren =
  BaseAuthSettingsChannelsWidgetRouteRoute._addFileChildren(
    BaseAuthSettingsChannelsWidgetRouteRouteChildren,
  )

interface BaseAuthSettingsChannelsRouteRouteChildren {
  BaseAuthSettingsChannelsGmailRouteRoute: typeof BaseAuthSettingsChannelsGmailRouteRouteWithChildren
  BaseAuthSettingsChannelsInstagramRouteRoute: typeof BaseAuthSettingsChannelsInstagramRouteRouteWithChildren
  BaseAuthSettingsChannelsOutlookRouteRoute: typeof BaseAuthSettingsChannelsOutlookRouteRouteWithChildren
  BaseAuthSettingsChannelsQrRouteRoute: typeof BaseAuthSettingsChannelsQrRouteRouteWithChildren
  BaseAuthSettingsChannelsWhatsappRouteRoute: typeof BaseAuthSettingsChannelsWhatsappRouteRouteWithChildren
  BaseAuthSettingsChannelsWidgetRouteRoute: typeof BaseAuthSettingsChannelsWidgetRouteRouteWithChildren
  BaseAuthSettingsChannelsIndexRoute: typeof BaseAuthSettingsChannelsIndexRoute
}

const BaseAuthSettingsChannelsRouteRouteChildren: BaseAuthSettingsChannelsRouteRouteChildren =
  {
    BaseAuthSettingsChannelsGmailRouteRoute:
      BaseAuthSettingsChannelsGmailRouteRouteWithChildren,
    BaseAuthSettingsChannelsInstagramRouteRoute:
      BaseAuthSettingsChannelsInstagramRouteRouteWithChildren,
    BaseAuthSettingsChannelsOutlookRouteRoute:
      BaseAuthSettingsChannelsOutlookRouteRouteWithChildren,
    BaseAuthSettingsChannelsQrRouteRoute:
      BaseAuthSettingsChannelsQrRouteRouteWithChildren,
    BaseAuthSettingsChannelsWhatsappRouteRoute:
      BaseAuthSettingsChannelsWhatsappRouteRouteWithChildren,
    BaseAuthSettingsChannelsWidgetRouteRoute:
      BaseAuthSettingsChannelsWidgetRouteRouteWithChildren,
    BaseAuthSettingsChannelsIndexRoute: BaseAuthSettingsChannelsIndexRoute,
  }

const BaseAuthSettingsChannelsRouteRouteWithChildren =
  BaseAuthSettingsChannelsRouteRoute._addFileChildren(
    BaseAuthSettingsChannelsRouteRouteChildren,
  )

interface BaseAuthSettingsIntegrationsAmphoraRouteRouteChildren {
  BaseAuthSettingsIntegrationsAmphoraConnectRoute: typeof BaseAuthSettingsIntegrationsAmphoraConnectRoute
}

const BaseAuthSettingsIntegrationsAmphoraRouteRouteChildren: BaseAuthSettingsIntegrationsAmphoraRouteRouteChildren =
  {
    BaseAuthSettingsIntegrationsAmphoraConnectRoute:
      BaseAuthSettingsIntegrationsAmphoraConnectRoute,
  }

const BaseAuthSettingsIntegrationsAmphoraRouteRouteWithChildren =
  BaseAuthSettingsIntegrationsAmphoraRouteRoute._addFileChildren(
    BaseAuthSettingsIntegrationsAmphoraRouteRouteChildren,
  )

interface BaseAuthSettingsIntegrationsBigblueRouteRouteChildren {
  BaseAuthSettingsIntegrationsBigblueConnectRoute: typeof BaseAuthSettingsIntegrationsBigblueConnectRoute
}

const BaseAuthSettingsIntegrationsBigblueRouteRouteChildren: BaseAuthSettingsIntegrationsBigblueRouteRouteChildren =
  {
    BaseAuthSettingsIntegrationsBigblueConnectRoute:
      BaseAuthSettingsIntegrationsBigblueConnectRoute,
  }

const BaseAuthSettingsIntegrationsBigblueRouteRouteWithChildren =
  BaseAuthSettingsIntegrationsBigblueRouteRoute._addFileChildren(
    BaseAuthSettingsIntegrationsBigblueRouteRouteChildren,
  )

interface BaseAuthSettingsIntegrationsFrontappRouteRouteChildren {
  BaseAuthSettingsIntegrationsFrontappConnectRoute: typeof BaseAuthSettingsIntegrationsFrontappConnectRoute
}

const BaseAuthSettingsIntegrationsFrontappRouteRouteChildren: BaseAuthSettingsIntegrationsFrontappRouteRouteChildren =
  {
    BaseAuthSettingsIntegrationsFrontappConnectRoute:
      BaseAuthSettingsIntegrationsFrontappConnectRoute,
  }

const BaseAuthSettingsIntegrationsFrontappRouteRouteWithChildren =
  BaseAuthSettingsIntegrationsFrontappRouteRoute._addFileChildren(
    BaseAuthSettingsIntegrationsFrontappRouteRouteChildren,
  )

interface BaseAuthSettingsIntegrationsGorgiasRouteRouteChildren {
  BaseAuthSettingsIntegrationsGorgiasConnectRoute: typeof BaseAuthSettingsIntegrationsGorgiasConnectRoute
}

const BaseAuthSettingsIntegrationsGorgiasRouteRouteChildren: BaseAuthSettingsIntegrationsGorgiasRouteRouteChildren =
  {
    BaseAuthSettingsIntegrationsGorgiasConnectRoute:
      BaseAuthSettingsIntegrationsGorgiasConnectRoute,
  }

const BaseAuthSettingsIntegrationsGorgiasRouteRouteWithChildren =
  BaseAuthSettingsIntegrationsGorgiasRouteRoute._addFileChildren(
    BaseAuthSettingsIntegrationsGorgiasRouteRouteChildren,
  )

interface BaseAuthSettingsIntegrationsKlaviyoRouteRouteChildren {
  BaseAuthSettingsIntegrationsKlaviyoConnectRoute: typeof BaseAuthSettingsIntegrationsKlaviyoConnectRoute
}

const BaseAuthSettingsIntegrationsKlaviyoRouteRouteChildren: BaseAuthSettingsIntegrationsKlaviyoRouteRouteChildren =
  {
    BaseAuthSettingsIntegrationsKlaviyoConnectRoute:
      BaseAuthSettingsIntegrationsKlaviyoConnectRoute,
  }

const BaseAuthSettingsIntegrationsKlaviyoRouteRouteWithChildren =
  BaseAuthSettingsIntegrationsKlaviyoRouteRoute._addFileChildren(
    BaseAuthSettingsIntegrationsKlaviyoRouteRouteChildren,
  )

interface BaseAuthSettingsIntegrationsLoopReturnsRouteRouteChildren {
  BaseAuthSettingsIntegrationsLoopReturnsConnectRoute: typeof BaseAuthSettingsIntegrationsLoopReturnsConnectRoute
}

const BaseAuthSettingsIntegrationsLoopReturnsRouteRouteChildren: BaseAuthSettingsIntegrationsLoopReturnsRouteRouteChildren =
  {
    BaseAuthSettingsIntegrationsLoopReturnsConnectRoute:
      BaseAuthSettingsIntegrationsLoopReturnsConnectRoute,
  }

const BaseAuthSettingsIntegrationsLoopReturnsRouteRouteWithChildren =
  BaseAuthSettingsIntegrationsLoopReturnsRouteRoute._addFileChildren(
    BaseAuthSettingsIntegrationsLoopReturnsRouteRouteChildren,
  )

interface BaseAuthSettingsIntegrationsReveniRouteRouteChildren {
  BaseAuthSettingsIntegrationsReveniConnectRoute: typeof BaseAuthSettingsIntegrationsReveniConnectRoute
}

const BaseAuthSettingsIntegrationsReveniRouteRouteChildren: BaseAuthSettingsIntegrationsReveniRouteRouteChildren =
  {
    BaseAuthSettingsIntegrationsReveniConnectRoute:
      BaseAuthSettingsIntegrationsReveniConnectRoute,
  }

const BaseAuthSettingsIntegrationsReveniRouteRouteWithChildren =
  BaseAuthSettingsIntegrationsReveniRouteRoute._addFileChildren(
    BaseAuthSettingsIntegrationsReveniRouteRouteChildren,
  )

interface BaseAuthSettingsIntegrationsReverRouteRouteChildren {
  BaseAuthSettingsIntegrationsReverConnectRoute: typeof BaseAuthSettingsIntegrationsReverConnectRoute
}

const BaseAuthSettingsIntegrationsReverRouteRouteChildren: BaseAuthSettingsIntegrationsReverRouteRouteChildren =
  {
    BaseAuthSettingsIntegrationsReverConnectRoute:
      BaseAuthSettingsIntegrationsReverConnectRoute,
  }

const BaseAuthSettingsIntegrationsReverRouteRouteWithChildren =
  BaseAuthSettingsIntegrationsReverRouteRoute._addFileChildren(
    BaseAuthSettingsIntegrationsReverRouteRouteChildren,
  )

interface BaseAuthSettingsIntegrationsSalesForceRouteRouteChildren {
  BaseAuthSettingsIntegrationsSalesForceConnectRoute: typeof BaseAuthSettingsIntegrationsSalesForceConnectRoute
}

const BaseAuthSettingsIntegrationsSalesForceRouteRouteChildren: BaseAuthSettingsIntegrationsSalesForceRouteRouteChildren =
  {
    BaseAuthSettingsIntegrationsSalesForceConnectRoute:
      BaseAuthSettingsIntegrationsSalesForceConnectRoute,
  }

const BaseAuthSettingsIntegrationsSalesForceRouteRouteWithChildren =
  BaseAuthSettingsIntegrationsSalesForceRouteRoute._addFileChildren(
    BaseAuthSettingsIntegrationsSalesForceRouteRouteChildren,
  )

interface BaseAuthSettingsIntegrationsShopifyRouteRouteChildren {
  BaseAuthSettingsIntegrationsShopifySizeChartRoute: typeof BaseAuthSettingsIntegrationsShopifySizeChartRoute
  BaseAuthSettingsIntegrationsShopifyConnectRoute: typeof BaseAuthSettingsIntegrationsShopifyConnectRoute
}

const BaseAuthSettingsIntegrationsShopifyRouteRouteChildren: BaseAuthSettingsIntegrationsShopifyRouteRouteChildren =
  {
    BaseAuthSettingsIntegrationsShopifySizeChartRoute:
      BaseAuthSettingsIntegrationsShopifySizeChartRoute,
    BaseAuthSettingsIntegrationsShopifyConnectRoute:
      BaseAuthSettingsIntegrationsShopifyConnectRoute,
  }

const BaseAuthSettingsIntegrationsShopifyRouteRouteWithChildren =
  BaseAuthSettingsIntegrationsShopifyRouteRoute._addFileChildren(
    BaseAuthSettingsIntegrationsShopifyRouteRouteChildren,
  )

interface BaseAuthSettingsIntegrationsZendeskRouteRouteChildren {
  BaseAuthSettingsIntegrationsZendeskConnectRoute: typeof BaseAuthSettingsIntegrationsZendeskConnectRoute
}

const BaseAuthSettingsIntegrationsZendeskRouteRouteChildren: BaseAuthSettingsIntegrationsZendeskRouteRouteChildren =
  {
    BaseAuthSettingsIntegrationsZendeskConnectRoute:
      BaseAuthSettingsIntegrationsZendeskConnectRoute,
  }

const BaseAuthSettingsIntegrationsZendeskRouteRouteWithChildren =
  BaseAuthSettingsIntegrationsZendeskRouteRoute._addFileChildren(
    BaseAuthSettingsIntegrationsZendeskRouteRouteChildren,
  )

interface BaseAuthSettingsIntegrationsRouteRouteChildren {
  BaseAuthSettingsIntegrationsAmphoraRouteRoute: typeof BaseAuthSettingsIntegrationsAmphoraRouteRouteWithChildren
  BaseAuthSettingsIntegrationsBigblueRouteRoute: typeof BaseAuthSettingsIntegrationsBigblueRouteRouteWithChildren
  BaseAuthSettingsIntegrationsFrontappRouteRoute: typeof BaseAuthSettingsIntegrationsFrontappRouteRouteWithChildren
  BaseAuthSettingsIntegrationsGorgiasRouteRoute: typeof BaseAuthSettingsIntegrationsGorgiasRouteRouteWithChildren
  BaseAuthSettingsIntegrationsKlaviyoRouteRoute: typeof BaseAuthSettingsIntegrationsKlaviyoRouteRouteWithChildren
  BaseAuthSettingsIntegrationsLoopReturnsRouteRoute: typeof BaseAuthSettingsIntegrationsLoopReturnsRouteRouteWithChildren
  BaseAuthSettingsIntegrationsReveniRouteRoute: typeof BaseAuthSettingsIntegrationsReveniRouteRouteWithChildren
  BaseAuthSettingsIntegrationsReverRouteRoute: typeof BaseAuthSettingsIntegrationsReverRouteRouteWithChildren
  BaseAuthSettingsIntegrationsSalesForceRouteRoute: typeof BaseAuthSettingsIntegrationsSalesForceRouteRouteWithChildren
  BaseAuthSettingsIntegrationsShopifyRouteRoute: typeof BaseAuthSettingsIntegrationsShopifyRouteRouteWithChildren
  BaseAuthSettingsIntegrationsZendeskRouteRoute: typeof BaseAuthSettingsIntegrationsZendeskRouteRouteWithChildren
  BaseAuthSettingsIntegrationsIndexRoute: typeof BaseAuthSettingsIntegrationsIndexRoute
}

const BaseAuthSettingsIntegrationsRouteRouteChildren: BaseAuthSettingsIntegrationsRouteRouteChildren =
  {
    BaseAuthSettingsIntegrationsAmphoraRouteRoute:
      BaseAuthSettingsIntegrationsAmphoraRouteRouteWithChildren,
    BaseAuthSettingsIntegrationsBigblueRouteRoute:
      BaseAuthSettingsIntegrationsBigblueRouteRouteWithChildren,
    BaseAuthSettingsIntegrationsFrontappRouteRoute:
      BaseAuthSettingsIntegrationsFrontappRouteRouteWithChildren,
    BaseAuthSettingsIntegrationsGorgiasRouteRoute:
      BaseAuthSettingsIntegrationsGorgiasRouteRouteWithChildren,
    BaseAuthSettingsIntegrationsKlaviyoRouteRoute:
      BaseAuthSettingsIntegrationsKlaviyoRouteRouteWithChildren,
    BaseAuthSettingsIntegrationsLoopReturnsRouteRoute:
      BaseAuthSettingsIntegrationsLoopReturnsRouteRouteWithChildren,
    BaseAuthSettingsIntegrationsReveniRouteRoute:
      BaseAuthSettingsIntegrationsReveniRouteRouteWithChildren,
    BaseAuthSettingsIntegrationsReverRouteRoute:
      BaseAuthSettingsIntegrationsReverRouteRouteWithChildren,
    BaseAuthSettingsIntegrationsSalesForceRouteRoute:
      BaseAuthSettingsIntegrationsSalesForceRouteRouteWithChildren,
    BaseAuthSettingsIntegrationsShopifyRouteRoute:
      BaseAuthSettingsIntegrationsShopifyRouteRouteWithChildren,
    BaseAuthSettingsIntegrationsZendeskRouteRoute:
      BaseAuthSettingsIntegrationsZendeskRouteRouteWithChildren,
    BaseAuthSettingsIntegrationsIndexRoute:
      BaseAuthSettingsIntegrationsIndexRoute,
  }

const BaseAuthSettingsIntegrationsRouteRouteWithChildren =
  BaseAuthSettingsIntegrationsRouteRoute._addFileChildren(
    BaseAuthSettingsIntegrationsRouteRouteChildren,
  )

interface BaseAuthSettingsKeysAndSecretsRouteRouteChildren {
  BaseAuthSettingsKeysAndSecretsApiTokensCreateRoute: typeof BaseAuthSettingsKeysAndSecretsApiTokensCreateRoute
  BaseAuthSettingsKeysAndSecretsVaultCreateRoute: typeof BaseAuthSettingsKeysAndSecretsVaultCreateRoute
  BaseAuthSettingsKeysAndSecretsVaultKeyReplaceRoute: typeof BaseAuthSettingsKeysAndSecretsVaultKeyReplaceRoute
}

const BaseAuthSettingsKeysAndSecretsRouteRouteChildren: BaseAuthSettingsKeysAndSecretsRouteRouteChildren =
  {
    BaseAuthSettingsKeysAndSecretsApiTokensCreateRoute:
      BaseAuthSettingsKeysAndSecretsApiTokensCreateRoute,
    BaseAuthSettingsKeysAndSecretsVaultCreateRoute:
      BaseAuthSettingsKeysAndSecretsVaultCreateRoute,
    BaseAuthSettingsKeysAndSecretsVaultKeyReplaceRoute:
      BaseAuthSettingsKeysAndSecretsVaultKeyReplaceRoute,
  }

const BaseAuthSettingsKeysAndSecretsRouteRouteWithChildren =
  BaseAuthSettingsKeysAndSecretsRouteRoute._addFileChildren(
    BaseAuthSettingsKeysAndSecretsRouteRouteChildren,
  )

interface BaseAuthSettingsSubscriptionUsageRouteRouteChildren {
  BaseAuthSettingsSubscriptionUsageConfigureTopupsRoute: typeof BaseAuthSettingsSubscriptionUsageConfigureTopupsRoute
}

const BaseAuthSettingsSubscriptionUsageRouteRouteChildren: BaseAuthSettingsSubscriptionUsageRouteRouteChildren =
  {
    BaseAuthSettingsSubscriptionUsageConfigureTopupsRoute:
      BaseAuthSettingsSubscriptionUsageConfigureTopupsRoute,
  }

const BaseAuthSettingsSubscriptionUsageRouteRouteWithChildren =
  BaseAuthSettingsSubscriptionUsageRouteRoute._addFileChildren(
    BaseAuthSettingsSubscriptionUsageRouteRouteChildren,
  )

interface BaseAuthSettingsSubscriptionRouteRouteChildren {
  BaseAuthSettingsSubscriptionPlansRouteRoute: typeof BaseAuthSettingsSubscriptionPlansRouteRoute
  BaseAuthSettingsSubscriptionReferralsRouteRoute: typeof BaseAuthSettingsSubscriptionReferralsRouteRoute
  BaseAuthSettingsSubscriptionUsageRouteRoute: typeof BaseAuthSettingsSubscriptionUsageRouteRouteWithChildren
  BaseAuthSettingsSubscriptionIndexRoute: typeof BaseAuthSettingsSubscriptionIndexRoute
}

const BaseAuthSettingsSubscriptionRouteRouteChildren: BaseAuthSettingsSubscriptionRouteRouteChildren =
  {
    BaseAuthSettingsSubscriptionPlansRouteRoute:
      BaseAuthSettingsSubscriptionPlansRouteRoute,
    BaseAuthSettingsSubscriptionReferralsRouteRoute:
      BaseAuthSettingsSubscriptionReferralsRouteRoute,
    BaseAuthSettingsSubscriptionUsageRouteRoute:
      BaseAuthSettingsSubscriptionUsageRouteRouteWithChildren,
    BaseAuthSettingsSubscriptionIndexRoute:
      BaseAuthSettingsSubscriptionIndexRoute,
  }

const BaseAuthSettingsSubscriptionRouteRouteWithChildren =
  BaseAuthSettingsSubscriptionRouteRoute._addFileChildren(
    BaseAuthSettingsSubscriptionRouteRouteChildren,
  )

interface BaseAuthSettingsTeamRouteRouteChildren {
  BaseAuthSettingsTeamInviteRoute: typeof BaseAuthSettingsTeamInviteRoute
  BaseAuthSettingsTeamIndexRoute: typeof BaseAuthSettingsTeamIndexRoute
  BaseAuthSettingsTeamEmployeeIdAccessRoute: typeof BaseAuthSettingsTeamEmployeeIdAccessRoute
}

const BaseAuthSettingsTeamRouteRouteChildren: BaseAuthSettingsTeamRouteRouteChildren =
  {
    BaseAuthSettingsTeamInviteRoute: BaseAuthSettingsTeamInviteRoute,
    BaseAuthSettingsTeamIndexRoute: BaseAuthSettingsTeamIndexRoute,
    BaseAuthSettingsTeamEmployeeIdAccessRoute:
      BaseAuthSettingsTeamEmployeeIdAccessRoute,
  }

const BaseAuthSettingsTeamRouteRouteWithChildren =
  BaseAuthSettingsTeamRouteRoute._addFileChildren(
    BaseAuthSettingsTeamRouteRouteChildren,
  )

interface BaseAuthSettingsWorkflowsRouteRouteChildren {
  BaseAuthSettingsWorkflowsIndexRoute: typeof BaseAuthSettingsWorkflowsIndexRoute
}

const BaseAuthSettingsWorkflowsRouteRouteChildren: BaseAuthSettingsWorkflowsRouteRouteChildren =
  {
    BaseAuthSettingsWorkflowsIndexRoute: BaseAuthSettingsWorkflowsIndexRoute,
  }

const BaseAuthSettingsWorkflowsRouteRouteWithChildren =
  BaseAuthSettingsWorkflowsRouteRoute._addFileChildren(
    BaseAuthSettingsWorkflowsRouteRouteChildren,
  )

interface BaseAuthSettingsRouteRouteChildren {
  BaseAuthSettingsChannelsRouteRoute: typeof BaseAuthSettingsChannelsRouteRouteWithChildren
  BaseAuthSettingsCustomizationRouteRoute: typeof BaseAuthSettingsCustomizationRouteRoute
  BaseAuthSettingsIntegrationsRouteRoute: typeof BaseAuthSettingsIntegrationsRouteRouteWithChildren
  BaseAuthSettingsKeysAndSecretsRouteRoute: typeof BaseAuthSettingsKeysAndSecretsRouteRouteWithChildren
  BaseAuthSettingsReferralsRouteRoute: typeof BaseAuthSettingsReferralsRouteRoute
  BaseAuthSettingsSubscriptionRouteRoute: typeof BaseAuthSettingsSubscriptionRouteRouteWithChildren
  BaseAuthSettingsTeamRouteRoute: typeof BaseAuthSettingsTeamRouteRouteWithChildren
  BaseAuthSettingsWorkflowsRouteRoute: typeof BaseAuthSettingsWorkflowsRouteRouteWithChildren
  BaseAuthSettingsIndexRoute: typeof BaseAuthSettingsIndexRoute
}

const BaseAuthSettingsRouteRouteChildren: BaseAuthSettingsRouteRouteChildren = {
  BaseAuthSettingsChannelsRouteRoute:
    BaseAuthSettingsChannelsRouteRouteWithChildren,
  BaseAuthSettingsCustomizationRouteRoute:
    BaseAuthSettingsCustomizationRouteRoute,
  BaseAuthSettingsIntegrationsRouteRoute:
    BaseAuthSettingsIntegrationsRouteRouteWithChildren,
  BaseAuthSettingsKeysAndSecretsRouteRoute:
    BaseAuthSettingsKeysAndSecretsRouteRouteWithChildren,
  BaseAuthSettingsReferralsRouteRoute: BaseAuthSettingsReferralsRouteRoute,
  BaseAuthSettingsSubscriptionRouteRoute:
    BaseAuthSettingsSubscriptionRouteRouteWithChildren,
  BaseAuthSettingsTeamRouteRoute: BaseAuthSettingsTeamRouteRouteWithChildren,
  BaseAuthSettingsWorkflowsRouteRoute:
    BaseAuthSettingsWorkflowsRouteRouteWithChildren,
  BaseAuthSettingsIndexRoute: BaseAuthSettingsIndexRoute,
}

const BaseAuthSettingsRouteRouteWithChildren =
  BaseAuthSettingsRouteRoute._addFileChildren(
    BaseAuthSettingsRouteRouteChildren,
  )

interface BaseAuthSupportListRouteRouteChildren {
  BaseAuthSupportListCustomerIdRouteRoute: typeof BaseAuthSupportListCustomerIdRouteRoute
}

const BaseAuthSupportListRouteRouteChildren: BaseAuthSupportListRouteRouteChildren =
  {
    BaseAuthSupportListCustomerIdRouteRoute:
      BaseAuthSupportListCustomerIdRouteRoute,
  }

const BaseAuthSupportListRouteRouteWithChildren =
  BaseAuthSupportListRouteRoute._addFileChildren(
    BaseAuthSupportListRouteRouteChildren,
  )

interface BaseAuthSupportRouteRouteChildren {
  BaseAuthSupportListRouteRoute: typeof BaseAuthSupportListRouteRouteWithChildren
  BaseAuthSupportIndexRoute: typeof BaseAuthSupportIndexRoute
}

const BaseAuthSupportRouteRouteChildren: BaseAuthSupportRouteRouteChildren = {
  BaseAuthSupportListRouteRoute: BaseAuthSupportListRouteRouteWithChildren,
  BaseAuthSupportIndexRoute: BaseAuthSupportIndexRoute,
}

const BaseAuthSupportRouteRouteWithChildren =
  BaseAuthSupportRouteRoute._addFileChildren(BaseAuthSupportRouteRouteChildren)

interface BaseAuthRouteRouteChildren {
  BaseAuthBackofficeRouteRoute: typeof BaseAuthBackofficeRouteRouteWithChildren
  BaseAuthCampaignsRouteRoute: typeof BaseAuthCampaignsRouteRouteWithChildren
  BaseAuthCapabilitiesRouteRoute: typeof BaseAuthCapabilitiesRouteRouteWithChildren
  BaseAuthConversationsRouteRoute: typeof BaseAuthConversationsRouteRouteWithChildren
  BaseAuthCustomersRouteRoute: typeof BaseAuthCustomersRouteRouteWithChildren
  BaseAuthInsightsRouteRoute: typeof BaseAuthInsightsRouteRouteWithChildren
  BaseAuthKnowledgeRouteRoute: typeof BaseAuthKnowledgeRouteRouteWithChildren
  BaseAuthSettingsRouteRoute: typeof BaseAuthSettingsRouteRouteWithChildren
  BaseAuthSupportRouteRoute: typeof BaseAuthSupportRouteRouteWithChildren
}

const BaseAuthRouteRouteChildren: BaseAuthRouteRouteChildren = {
  BaseAuthBackofficeRouteRoute: BaseAuthBackofficeRouteRouteWithChildren,
  BaseAuthCampaignsRouteRoute: BaseAuthCampaignsRouteRouteWithChildren,
  BaseAuthCapabilitiesRouteRoute: BaseAuthCapabilitiesRouteRouteWithChildren,
  BaseAuthConversationsRouteRoute: BaseAuthConversationsRouteRouteWithChildren,
  BaseAuthCustomersRouteRoute: BaseAuthCustomersRouteRouteWithChildren,
  BaseAuthInsightsRouteRoute: BaseAuthInsightsRouteRouteWithChildren,
  BaseAuthKnowledgeRouteRoute: BaseAuthKnowledgeRouteRouteWithChildren,
  BaseAuthSettingsRouteRoute: BaseAuthSettingsRouteRouteWithChildren,
  BaseAuthSupportRouteRoute: BaseAuthSupportRouteRouteWithChildren,
}

const BaseAuthRouteRouteWithChildren = BaseAuthRouteRoute._addFileChildren(
  BaseAuthRouteRouteChildren,
)

interface BasePublicSignupWebsiteRouteRouteChildren {
  BasePublicSignupWebsitePreviewRoute: typeof BasePublicSignupWebsitePreviewRoute
  BasePublicSignupWebsiteIndexRoute: typeof BasePublicSignupWebsiteIndexRoute
}

const BasePublicSignupWebsiteRouteRouteChildren: BasePublicSignupWebsiteRouteRouteChildren =
  {
    BasePublicSignupWebsitePreviewRoute: BasePublicSignupWebsitePreviewRoute,
    BasePublicSignupWebsiteIndexRoute: BasePublicSignupWebsiteIndexRoute,
  }

const BasePublicSignupWebsiteRouteRouteWithChildren =
  BasePublicSignupWebsiteRouteRoute._addFileChildren(
    BasePublicSignupWebsiteRouteRouteChildren,
  )

interface BasePublicRouteRouteChildren {
  BasePublicSignupWebsiteRouteRoute: typeof BasePublicSignupWebsiteRouteRouteWithChildren
  BasePublicForgotPasswordRoute: typeof BasePublicForgotPasswordRoute
  BasePublicInviteRoute: typeof BasePublicInviteRoute
  BasePublicLoginRoute: typeof BasePublicLoginRoute
  BasePublicResetPasswordRoute: typeof BasePublicResetPasswordRoute
  BasePublicSignupRoute: typeof BasePublicSignupRoute
}

const BasePublicRouteRouteChildren: BasePublicRouteRouteChildren = {
  BasePublicSignupWebsiteRouteRoute:
    BasePublicSignupWebsiteRouteRouteWithChildren,
  BasePublicForgotPasswordRoute: BasePublicForgotPasswordRoute,
  BasePublicInviteRoute: BasePublicInviteRoute,
  BasePublicLoginRoute: BasePublicLoginRoute,
  BasePublicResetPasswordRoute: BasePublicResetPasswordRoute,
  BasePublicSignupRoute: BasePublicSignupRoute,
}

const BasePublicRouteRouteWithChildren = BasePublicRouteRoute._addFileChildren(
  BasePublicRouteRouteChildren,
)

interface BaseRouteRouteChildren {
  BaseAuthRouteRoute: typeof BaseAuthRouteRouteWithChildren
  BasePublicRouteRoute: typeof BasePublicRouteRouteWithChildren
}

const BaseRouteRouteChildren: BaseRouteRouteChildren = {
  BaseAuthRouteRoute: BaseAuthRouteRouteWithChildren,
  BasePublicRouteRoute: BasePublicRouteRouteWithChildren,
}

const BaseRouteRouteWithChildren = BaseRouteRoute._addFileChildren(
  BaseRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  BaseRouteRoute: BaseRouteRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
